import {
  FormGroup,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Paper,
  Typography,
  Table,
  TableCell,
  TableBody,
  TableContainer,
  TableRow,
  TableHead,
  Tooltip,
  Switch,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
  ListSubheader,
  Radio,
  FormLabel,
  DialogContent,
} from "@material-ui/core";

import { preventDoubleClick } from "./preventDC.js";
import Loading from "./loading";
import Divider from "@mui/material/Divider";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from "@mui/icons-material/Info";
import { Dialog } from "@mui/material";
import GetRole from "./user";
import useRole from "./useRole.js";
import { useAppData } from "./appDataContext.js";
import { useEffect, useRef, useMemo } from "react";
import DateCalc from "./date";
import axios from "axios";
import useState from "react-usestateref";
import {
  getquality,
  identifydest,
  classifyfup,
  airportlist,
  removeDuplicatesmulti2,
  calltrue2,
  DateCalc2,
  isSameMonth,
  getprofit,
  BlinkingText,
  getconvdate,
  isNumericRegex,
  converttoISO,
  pending, total
} from "./date";
import {
  sendmailtoteam,
  updatequoteData,
  getinsightviaapi,
  startclaudecallinsight,
  getclaudecallinsightstatus,
  updateTripdata,
  fetchTripbyId,
  runcancflagcheck,
  fetchquotelist,
  fetchwadata,
  fetchCustomerbyId,
  analyzeDocumentviaAI,
  analyzeDocumentsviaAI,
  fetchEmployeebyName,
  gmailSend,
  searchCustomersbyNumber,
  fetchQuotebyId,
  fetchquotedatesonly,
  makecall,
  uploadsinglefile,
  sendpurchasetoMeta,
  fetchdestHotelsbyDest,
  getanalyzedocsresult,
  analyzedocs,
  fetchTripsbyNumber,
  deletefile,
  fetchpostponedlength,
  fetchHotelbyId,
  searchboTripsbyDate3,
  getaiinfo,
  fetchtaskbytripid,
} from "../api/customerapi";
import { Link } from "react-router-dom";
import { svtoken } from "../api/customerapi";
import { styled } from "@mui/system";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  red: {
    color: "#ff0000",
  },
  checkboxalign: {
    alignSelf: "center",
    justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  textField4: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    //color: "red",
  },
  textField3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  headertext2: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: "#ff7c02",
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textArea2: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    width: theme.spacing(200),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button4: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(75),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(4),
  },
  input: {
    "&:invalid": {
      border: "red solid 2px",
    },
  },
  headtext: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  redheadtext: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    justifyContent: "center",
    border: "red solid 2px",
  },
  bodytext: {
    marginLeft: theme.spacing(5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const Tripdataupdate = () => {
  const classes = useStyles();
  const [leadfilterData, setleadfilterData] = useState({});
  const currenturl = window.location.href;
  const url1 = currenturl.split("/");
  const url = url1[0] + "//" + url1[1] + url1[2];
  const urlarray = currenturl.split("/");
  const currentid = urlarray[urlarray.length - 1];
  const [open, setOpen, openRef] = useState(false);
  const [quotelist, setquotelist] = useState([]);
  const [leadid, setleadid] = useState("");
  const [nextaction, setnextaction] = useState([]);
  const [scannedwords, setscannedwords] = useState(false);
  const [panstring, setpanstring] = useState("");
  const [passportstring, setpassportstring] = useState("");
  const [insight, setinsight] = useState(null);
  const [AIdata, setAIdata] = useState(false);
  const isFirstRender = useRef(true);
  var [followupData, setfollowupData] = useState({
    status: "",
    date: String(DateCalc(1)),
    time: "00:00",
    notes: "",
    fuptype: "",
    fupautonote: "",
    override: false,
  });
  const [calldata, setcalldata] = useState(false);
  const [followupData2, setfollowupData2, followupData2Ref] = useState(null);
  // Guards the auto-submit so it fires exactly once per system-generated fup.
  const autoSubmitRef = useRef(false);
  const [rbq, setrbq] = useState(false);
  const [whyhot, setwhyhot] = useState({
    destination: false,
    date: false,
    pax: false,
    package: false,
    fake1: false,
    fake2: false,
    fake3: false,
  });
  const [watime, setwatime] = useState(null);
  const [filecategory, setfilecategory] = useState(false);
  const [Obj1, setObj1] = useState(false);
  const [Obj2, setObj2] = useState(false);
  const [Obj3, setObj3] = useState(false);
  const [Obj4, setObj4] = useState(false);
  const [Obj5, setObj5] = useState(false);
  const [Open2, setOpen2] = useState(false);
  const [Open2b, setOpen2b] = useState(false);
  const [Open3, setOpen3] = useState(false);
  const [Open4, setOpen4] = useState(false);
  const [Open5, setOpen5] = useState(false);
  const [Open6, setOpen6] = useState(false);
  const [Open7, setOpen7] = useState(false);
  const [Open8, setOpen8] = useState(false);
  const [Open9, setOpen9] = useState(false);
  const [Open11, setOpen11] = useState(false);
  const [Open12, setOpen12] = useState(false);
  const [Open13, setOpen13] = useState(false);
  const [Open15, setOpen15] = useState(false);
  const [Open16, setOpen16] = useState(false);
  const [Open17, setOpen17] = useState(false);
  const [Open18, setOpen18] = useState(false);
  const [Open19, setOpen19] = useState(false);
  const [Open20, setOpen20] = useState(false);
  const [showsh, setshowsh] = useState(false);
  const [callrecorddata, setcallrecorddata] = useState([]);
  const [showsave, setshowsave] = useState(true);
  const [fupData, setfupData] = useState([]);
  const [tasklist, settasklist] = useState([]);
  const [emp, setemp] = useState([]);
  const [emp22, setemp22] = useState([]);
  const [empops, setempops] = useState([]);
  const [bookconfirm, setbookconfirm] = useState({});
  const [emplist, setemplist] = useState([]);
  const [wadata, setwadata] = useState([
    {
      wa_name: "",
      wa_owner: "",
      wa_body: "",
      wa_category: "",
      wa_custom: false,
      wa_id: 0,
      wa_cust: false,
      wa_trip: false,
    },
  ]);
  const [userdetails, setuserdetails] = useState(false);
  const [docmgmt, setdocmgmt] = useState(false);
  const [Attempted, setAttempted] = useState(false);
  const [shownewfup, setshownewfup] = useState(false);
  const [quotepending, setquotepending] = useState(null);
  const [quotemissing, setquotemissing] = useState(null);
  const [quotesent, setquotesent] = useState(null);
  const [scroll, setscroll] = useState(false);
  const [scroll2, setscroll2] = useState(false);
  const [publishreview, setpublishreview] = useState(true);
  const [dest, setdest] = useState([]);
  const [fsData, setfsData] = useState({});
  const [frData, setfrData] = useState(null);
  const [cf, setcf] = useState(false);
  const [postponedlength, setpostponedlength] = useState(0);
  const [hotelData, sethotelData] = useState([]);
  const [Open10, setOpen10] = useState(false);
  const options = ["Yes", "No", "NA"];
  const [reconfirm, setreconfirm] = useState({
    number_adults: 0,
    number_child: 0,
    child_age: "",
    duration: 0,
    trip_start_date: "",
    merge_ids: "",
  });
  const [oldstatus, setoldstatus] = useState([]);
  const [olddestination, setolddestination] = useState(null);
  const [bookingData, setbookingData] = useState(null);
  const [vm, setvm] = useState(null);
  const [finalfiledetails, setfinalfiledetails] = useState([]);
  const [walist2b, setwalist2b] = useState(null);
  const [oldbookingData, setoldbookingData] = useState(null);
  const [oldconvquote, setoldconvquote] = useState(null);
  const [clickcall, setclickcall] = useState(false);
  const [loadtime, setloadtime] = useState(null);
  const [quotedetails, setquotedetails] = useState({
    cust_notes: "",
    internal_notes: "",
  });
  const [filedetails, setfiledetails] = useState({
    filetype: "",
    file: null,
  });
  const [custData, setcustData] = useState({
    cust_name: "",
    primary_mobile_number: undefined,
    chat_mobile_number: undefined,
    secondary_mobile_numbers: "",
    only_chat: false,
    super_user: false,
    marketing_message: true,
    cust_ref: "",
    cust_notes: "",
    cust_channel: "",
    primary_email_id: "",
    secondary_email_ids: "",
    cust_city: "",
    cust_state: "",
    cust_createdBy: "",
    cust_trips: [
      {
        id: undefined,
        status: "",
      },
    ],
  });
  const [tripData, settripData] = useState({
    start_date_undecided: "No",
    quote: [],
    primary_destination: "Kashmir",
    number_adults: 2,
    number_child: 0,
    conv_quote: 0,
    type_of_vacation: "Honeymoon",
    duration: 4,
    trip_stage: "Plan in progress",
    trip_channel: "",
    trip_requirements: "",
    trip_campaign: "",
    multi_destinations: "No",
    secondary_destinations: "",
    tertiary_destinations: "",
    status_history: [],
    team_leader: "",
    trip_status: "New",
    trip_review: "",
    incentive_paid: "",
    trip_owner: "",
    trip_review_score: 4,
    trip_review_source: "",
    lead_source_airport: "",
    flight_sp: 0,
    flight_cp: 0,
    land_sp: 0,
    land_cp: 0,
    anc_sp: 0,
    extra_sp: 0,
    anc_cp: 0,
    extra_cp: 0,
    visa_sp: 0,
    visa_cp: 0,
    cruise_sp: 0,
    cruise_cp: 0,
    callrecord: [],
    follow_up: [
      {
        status: "Open",
        sys_gen: false,
        notes: "",
        fuptype: "",
        fupautonote: "",
      },
    ],
  });
  const airportlist2 = airportlist.sort((a, b) => (a.city > b.city ? 1 : -1));
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  //var { cuser, role, employeelist, destinationlist } = useRole();
  // const { appData, loading } = useAppData();
  // var cuser=appData.cuser
  // var role=appData.role
  //console.log(appData)
  const today = DateCalc(0);
  const nextday = DateCalc(1);
  const yesterday = DateCalc(-1);
  const dayafter = DateCalc(2);

  function shuffleArray(array) {
    return [...array].sort(() => Math.random() - 0.5);
  }

  function shuffleArray2(array) {
    return [...array].sort(() => Math.random() - 0);
  }

  function shuffleArray3(array) {
    return [...array].sort(() => Math.random() - 0.75);
  }

  function shuffleArray4(array) {
    return [...array].sort(() => Math.random() - 0.25);
  }

  const shuffledOptions = useMemo(() => shuffleArray(options), []);
  const shuffledOptions2 = useMemo(() => shuffleArray2(options), []);
  const shuffledOptions3 = useMemo(() => shuffleArray3(options), []);
  const shuffledOptions4 = useMemo(() => shuffleArray4(options), []);

  function containsNumbers(str) {
    return /\d/.test(str);
  }

  const getdate = (text) => {
    var x = text.slice(-2);
    var y = text.slice(-5, -3);
    var z = text.slice(-10, -6);
    return z + "-" + y + "-" + x;
  };

  const gettime = (text) => {
    var x = text.slice(-21, -14);
    var x2 = x.trim();
    if (
      x2 == "5:30pm" ||
      x2 == "17:30pm" ||
      x2 == "17:00pm" ||
      x2 == "5:00pm"
    ) {
      return "17:30";
    } else if (x2 == "14:00pm") {
      return "14:00";
    } else if (x2 == "20:00pm") {
      return "20:00";
    } else {
      return "12:30";
    }
    //return text.slice(-21, -14)
  };

  const getTrip = async (id) => {
    try {
      const data = await fetchTripbyId(id);
      console.log(data.data);
      const taskdata=await fetchtaskbytripid(id)
      settasklist(taskdata.data)
      const ret = await nextactioncall(data.data);
      setnextaction(ret);
      let num = containsNumbers(ret);
      if (num) {
        let d = getdate(ret);
        let t = gettime(ret);
        //console.log(d)
        //console.log(t)
        setfollowupData({
          status: "Open",
          date: d,
          time: t,
          notes: "",
          fuptype: "",
          fupautonote: "",
          override: false,
        });
      }
      setloadtime(new Date());
      settripData(data.data);
      if (data.data.hotreason) {
        setwhyhot(data.data.hotreason);
      }
      if (data.data.last_wa_sent) {
        setwatime(data.data.last_wa_sent);
      } else {
        setwatime(new Date(yesterday));
      }
      //check call record to show if new fup can be created
      //testing on few people
      if (role == "Sales" || role == "SME" || role == "Sales Support") {
        if (
          new Date(data.data.createdAt).getTime() >
          new Date(DateCalc(0)).getTime()
        ) {
          setshownewfup(true);
          //console.log("here1")
        } else {
          for (let i = 0; i < data.data.callrecord.length; i++) {
            if (
              new Date(data.data.callrecord[i].start_stamp).getTime() >
                new Date(DateCalc(0)).getTime() &&
              (Number(data.data.callrecord[i].duration) >= 15 ||
                data.data.callrecord[i].hangup_cause ==
                  "disconnected_by_callee" ||
                data.data.callrecord[i].hangup_cause == "noanswer" ||
                data.data.callrecord[i].hangup_cause == "User busy" ||
                data.data.callrecord[i].hangup_cause == "missed")
            ) {
              setshownewfup(true);
              //console.log("here2")
              break;
            }
          }
        }
        // }else{
        //   console.log("here3")
        //   setshownewfup(true)
      }

      setoldstatus(data.data.trip_status);
      setquotepending(data.data.quote_pending);
      if ("manual_quote" in data.data) {
        setquotemissing(data.data.manual_quote);
      } else {
        if (data.data.quote.length > 0) {
          setquotemissing(false);
        } else {
          setquotemissing(true);
        }
      }
      if ("lead" in data.data && "lead_id" in data.data.lead) {
        setleadid(data.data.lead.lead_id);
      }
      setbookingData(data.data.booking);
      setoldbookingData(data.data.booking);
      setolddestination(data.data.primary_destination);
      setoldconvquote(data.data.conv_quote);
      setfinalfiledetails(data.data.file); //
      const data2 = await fetchquotelist(data.data.primary_destination);
      setquotelist(data2.data);
      const data3 = await fetchwadata();
      setwadata(data3.data);
      const data4 = await fetchCustomerbyId(data.data.cust_id);
      setcustData(data4.data);
      setfupData(
        data.data.follow_up.slice(
          data.data.follow_up.length - 3,
          data.data.follow_up.length,
        ),
      );

      if (data.data.trip_status == "Converted") {
        var tempobj = data.data.follow_up.slice(
          data.data.follow_up.length - 1,
          data.data.follow_up.length,
        );
        setfollowupData({ ...tempobj[0], status: "Open" });
      }
      if (
        data.data.trip_status == "Converted" ||
        data.data.trip_status == "Closed"
      ) {
        const hoteldata = await fetchdestHotelsbyDest(
          data.data.primary_destination,
        );
        sethotelData(hoteldata.data);
        if ("secondary_destinations" in data.data) {
          const hoteldata2 = await fetchdestHotelsbyDest(
            data.data.secondary_destinations,
          );
          sethotelData([...hoteldata2.data, ...hoteldata.data]);
        }
      }
      // console.log("booking" in data.data)
      // console.log("hotellist" in data.data.booking)
      // console.log("conv_quote" in data.data)
      var temparr = [];
      if (
        "booking" in data.data &&
        !(
          "hotellist" in data.data.booking &&
          data.data.booking.hotellist.length > 0
        ) &&
        "conv_quote" in data.data &&
        data.data.conv_quote !== 1
      ) {
        const qd = await fetchQuotebyId(data.data.conv_quote);
        //console.log(qd.data)

        if ("day" in qd.data && qd.data.day.length > 0) {
          for (let i = 0; i < qd.data.day.length; i++) {
            const temp = {
              name: qd.data.day[i].hotel_name,
              date: qd.data.day[i].date,
              status:
                "hotel" in data.data.booking && data.data.booking.hotel == "Yes"
                  ? "Yes"
                  : "No",
            };
            temparr = [...temparr, temp];
          }
          //console.log(temparr)
        }
        setbookingData({ ...data.data.booking, hotellist: temparr });
        //console.log({...data.data.booking, hotellist:temparr})
      }
      var temparr2 = [];
      if (
        "booking" in data.data &&
        !("fup" in data.data.booking && data.data.booking.fup.length > 0)
      ) {
        const temp = {
          date: new Date(data.data.booking.follow_up_date_text),
          note: data.data.booking.notes,
          category: "",
          assigned: data.data.booking.ops_assigned,
        };
        temparr2 = [
          temp,
          { date: new Date(), note: "", category: "", assigned: "" },
        ];
        setbookingData({
          ...data.data.booking,
          fup: temparr2,
          hotellist:
            "hotellist" in data.data.booking &&
            data.data.booking.hotellist.length > 0
              ? data.data.booking.hotellist
              : temparr,
        });
      }
      if (
        "booking" in data.data &&
        "fup" in data.data.booking &&
        data.data.booking.fup.length > 0
      ) {
        if (
          new Date(
            data.data.booking.fup[data.data.booking.fup.length - 1].date,
          ).getTime() < new Date(DateCalc(1)).getTime()
        ) {
          setbookingData({
            ...data.data.booking,
            fup: [
              ...data.data.booking.fup,
              { date: new Date(), note: "", category: "", assigned: "" },
            ],
            hotellist:
              "hotellist" in data.data.booking &&
              data.data.booking.hotellist.length > 0
                ? data.data.booking.hotellist
                : temparr,
          });
        } else {
          setbookingData({
            ...data.data.booking,
            fup: [
              ...data.data.booking.fup,
              {
                date: data.data.booking.fup[
                  data.data.booking.fup.length - 1
                ].date
                  .split("T")
                  .slice(0, 1),
                note: data.data.booking.fup[data.data.booking.fup.length - 1]
                  .note,
                category:
                  data.data.booking.fup[data.data.booking.fup.length - 1]
                    .category,
                assigned:
                  data.data.booking.fup[data.data.booking.fup.length - 1]
                    .assigned,
              },
            ],
            hotellist:
              "hotellist" in data.data.booking &&
              data.data.booking.hotellist.length > 0
                ? data.data.booking.hotellist
                : temparr,
          });
        }
      }

      var someDate = data.data.trip_start_date
        ? new Date(data.data.trip_start_date).getTime()
        : 0;
      var mstoAdd = data.data.duration
        ? data.data.duration * 24 * 60 * 60 * 1000
        : 0;
      //console.log(someDate, mstoAdd);
      var returndate = new Date(someDate + mstoAdd).toISOString();
      setreconfirm({
        ...reconfirm,
        primary_email_id: tripData.primary_email_id,
      });
      setfsData({
        source: "",
        dest: "",
        direct: "No",
        type: "Return",
        number_adults: data.data.number_adults,
        number_child: data.data.number_child,
        dot: data.data.trip_start_date
          ? data.data.trip_start_date.slice(0, 10)
          : 0,
        dor: returndate.slice(0, 10),
      });
      getPostponedtrips(data.data.trip_owner);
    } catch (err) {
      console.log(err);
    }
  };
  //console.log(shownewfup)
  const getrbq = () => {
    //console.log("Ran")
    if (tripData.multi_destinations == "Yes") {
      if (
        tripData.primary_destination == "Indonesia" ||
        tripData.primary_destination == "Singapore" ||
        tripData.primary_destination == "Malaysia"
      ) {
        //console.log("Ran4")
        setrbq(true);
      }
    } else {
      //console.log("Ran2")
      if (
        tripData.primary_destination == "Andaman" ||
        tripData.primary_destination == "Thailand" ||
        tripData.primary_destination == "Philippines" ||
        tripData.primary_destination == "Dubai" ||
        tripData.primary_destination == "Indonesia" ||
        tripData.primary_destination == "Singapore" ||
        tripData.primary_destination == "Malaysia" ||
        tripData.primary_destination == "Kerala" ||
        tripData.primary_destination == "Vietnam" ||
        tripData.primary_destination == "Sri Lanka" ||
        tripData.primary_destination == "Kashmir" ||
        tripData.primary_destination == "Azerbaijan" ||
        tripData.primary_destination == "Sikkim" ||
        tripData.primary_destination == "Kazakhstan" ||
        tripData.primary_destination == "Rajasthan" ||
        tripData.primary_destination == "Turkey" ||
        tripData.primary_destination == "Uttarakhand" ||
        tripData.primary_destination == "Hong Kong" ||
        tripData.primary_destination == "Philippines" ||
        tripData.primary_destination == "Goa" ||
        tripData.primary_destination == "Arunachal Pradesh" ||
        tripData.primary_destination == "Meghalaya" ||
        tripData.primary_destination == "Japan" ||
        tripData.primary_destination == "Georgia"
      ) {
        //console.log("Ran4")
        setrbq(true);
      }
    }
  };

  const getPostponedtrips = async (owner) => {
    try {
      const data = await fetchpostponedlength(owner);
      //console.log(data.data)
      setpostponedlength(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const changeTL = () => {
    const data = window.prompt("Enter TL name:");
    settripData({ ...tripData, team_leader: data.trim() });
    //handleSubmit2()
  };

  //console.log(bookingData)

  useEffect(() => {
    if (!loading) {
      getTrip(currentid);
    } //getEmployees();
    // getrbq()
  }, [cuser, role, employeelist, destinationlist, loading]);

  useEffect(() => {
    getrbq();
  }, [tripData, cuser]);

  // useEffect(() => {
  //   if(!loading){
  //   getEmployees();
  //   getDest()
  //   }
  // }, [loading]);

  // useEffect(() => {
  //   if (!roleloading && role) {
  //     console.log("User Role:", role);
  //   }
  // }, [roleloading, role]);
  useEffect(() => {
    if (!loading) {
      console.log("User:", cuser);
      console.log("Role:", role);
      console.log("Employees:", employeelist.length);
      console.log("Destinations:", destinationlist.length);
      getEmployees();
      getDest();
    }
  }, [loading, cuser, role, employeelist, destinationlist]);

  useEffect(() => {
    if (!followupData2?.sys_gen) return;
    // Run exactly once per system-generated fup. No setTimeout: the effect
    // already runs after the render commits, so followupData2 / tripData are
    // fresh here. A timer only opened a 2s window in which a re-render could
    // clear it and silently drop the submit (the ~10% failures).
    if (autoSubmitRef.current) return;
    autoSubmitRef.current = true;

    // if(cuser=="Debayan" || cuser=="Sidharth" || cuser=="Manish" || cuser=="Dev"){
    //   alert(followupData2.fupautonote)
    // }
    handleSubmit2();
  }, [followupData2]);

  // useEffect(() => {
  //   followupData2Ref.current = followupData2;
  // }, [followupData2]);

  //console.log(cuser)

  const getDest = async () => {
    try {
      // const data = await fetchDest();
      // const temp=data.data.filter(d=>"order" in d)
      // setdest(temp[0].dest);
      //console.log(destinationlist)
      setdest(destinationlist);
    } catch (err) {
      console.log(err);
    }
  };

  const getEmployees = async () => {
    try {
      // const data = await fetchEmployees();
      // setemplist(data.data)
      setemplist(employeelist);
      const empsplist = employeelist.filter(
        (emp) =>
          emp.role == "Sales" ||
          emp.role == "TL" ||
          emp.role == "Manager" ||
          emp.role == "SME",
      );
      const empshortname = empsplist.map((emp) => emp.short_name);
      var tempemp = empshortname.sort();
      setemp(tempemp);
      const empsplist22 = employeelist.filter(
        (emp) => emp.role == "Sales" || emp.role == "SME",
      );
      const empshortname22 = empsplist22.map((emp) => emp.short_name);
      var tempemp22 = empshortname22.sort();
      setemp22(tempemp22);
      const temp = employeelist.filter((emp) => emp.short_name == cuser);
      setuserdetails(temp[0]);

      const empsplist2 = employeelist.filter(
        (emp) =>
          emp.role == "TL" ||
          emp.role == "Operations" ||
          emp.role == "Operations-TL" ||
          emp.role == "Product",
      );
      //console.log(empsplist2)
      const empshortname2 = empsplist2.map((emp) => emp.short_name);
      setempops(empshortname2);
      //console.log(empshortname2)
    } catch (err) {
      console.log(err);
    }
  };
  //console.log(followupData)
  const fupfinalDate = DateCalc(0);
  const ttt = tripData.trip_start_date
    ? (
        (new Date(tripData.trip_start_date).getTime() - new Date().getTime()) /
        (1000 * 60 * 60 * 24)
      ).toFixed(0)
    : 0;
  //console.log(tripData);
  //quote number dialog
  const dialogopen = () => {
    setOpen(true);
    //console.log(quotelist)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose10 = () => {
    var flag = 0;
    if (
      bookingData &&
      "hotellist" in bookingData &&
      bookingData.hotellist.length > 0
    ) {
      var count = 0;
      for (let i = 0; i < bookingData.hotellist.length; i++) {
        if (bookingData.hotellist[i].status == "Yes") {
          count++;
        }
      }
      if (count == bookingData.hotellist.length) {
        flag = 1;
      }
    }
    if (
      bookingData &&
      "fup" in bookingData &&
      bookingData.fup.length > 0 &&
      bookingData.fup[bookingData.fup.length - 1].note == "" &&
      bookingData.fup[bookingData.fup.length - 1].category == ""
    ) {
      setbookingData({
        ...bookingData,
        fup: bookingData.fup.slice(0, bookingData.fup.length - 1),
        follow_up_date_text:
          "fup" in tripData.booking && tripData.booking.fup.length > 0
            ? tripData.booking.fup[tripData.booking.fup.length - 1].date
            : tripData.booking.follow_up_date_text,
        hotel:
          "hotellist" in bookingData && bookingData.hotellist.length > 0
            ? flag
              ? "Yes"
              : "No"
            : bookingData.hotel,
      });
    }
    setOpen9(false);
  };

  const handleClose13 = () => {
    setOpen13(false);
  };

  const handleClose16 = () => {
    setOpen16(false);
  };

  const handleClose17 = () => {
    setOpen17(false);
  };

  const handleClose18 = () => {
    setOpen18(false);
  };

  const handleClose19 = () => {
    setshownewfup(false);
    setOpen19(false);
  };

  const handleClose12 = () => {
    setOpen11(false);
  };

  const handleClose15 = () => {
    setOpen15(false);
  };

  const walist2 = wadata.filter(
    (wa) =>
      wa.wa_trip == true &&
      (wa.wa_custom == false || wa.wa_owner == tripData.trip_owner) &&
      wa.wa_id !== 57 &&
      wa.wa_id !== 58,
  );

  const walist = walist2.sort((a, b) => {
    let fa = a.group_id,
      fb = b.group_id,
      fc = a.wa_id,
      fd = b.wa_id;

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    if (fa == fb) {
      if (fc < fd) {
        return -1;
      }
      if (fc > fd) {
        return 1;
      }
    }
    return 0;
  });

  const whatsapp = (name) => {
    if (custData.chat_mobile_number) {
      var d = new Date().getHours();
      var textpoll = `<p>We have not heard from you in a while and wanted to know if there is any problem where we could help. If you kindly let us know the issue, it will be helpful for both of us.</p>
<p>1. <strong>All good. Will contact you soon</strong> <a href="https://handypolls.com/o/ngQWrk" rel="nofollow" target="_blank">vote</a></p>
<p>2. <strong>Waiting for someone else to confirm</strong> <a href="https://handypolls.com/o/nJvM7W" rel="nofollow" target="_blank">vote</a></p>
<p>3. <strong>Waiting for some other event (e.g. leaves, arranging funds etc.)</strong> <a href="https://handypolls.com/o/ePoRLZ" rel="nofollow" target="_blank">vote</a></p>
<p>4. <strong>Still not sure about the plan. Exploring more options</strong> <a href="https://handypolls.com/o/nxLomk" rel="nofollow" target="_blank">vote</a></p>
<p>5. <strong>Plans are final but not sure about your company</strong> <a href="https://handypolls.com/o/85Wd2v" rel="nofollow" target="_blank">vote</a></p>
<p>6. <strong>Not interested anymore. Kindly cancel</strong> <a href="https://handypolls.com/o/nZaWxa" rel="nofollow" target="_blank">vote</a></p>
<p><a href="https://handypolls.com/p/KQ34DQ" target="_blank">Go to poll page</a></p>`;

      var extratext = "";
      if (d > 5 && d < 12) {
        extratext = "Good Morning !";
      } else if (d >= 12 && d < 17) {
        extratext = "Good Afternoon !";
      } else if (d >= 18 && d < 23) {
        extratext = "Good Evening !";
      }

      var body = walist.filter((wa) => wa.wa_name == name);
      var text2 = "";
      if (body[0].wa_id > 35 && body[0].wa_id < 40) {
        text2 = extratext + "%0a%0a" + body[0].wa_body;
      } else {
        text2 = body[0].wa_body;
      }
      var text5 = text2.replace("<destination>", tripData.primary_destination);
      var text6 = text5.replace("<x>", tripData.duration);
      var text7 = text6.replace(
        "<date>",
        tripData.trip_start_date.split("T").slice(0, 1),
      );
      var text8 = text7.replace("<pax>", tripData.number_adults);
      var text9 = text8.replace("<owner>", tripData.trip_owner);
      var text4 = text9.replace("<name>", tripData.cust_name);
      var text3 = text4.split("||");

      var text = "";
      for (var i = 0; i < text3.length; i++) {
        if (i == 0) {
          text = text3[i];
        } else {
          text = text + "%0a" + text3[i];
        }
      }

      // if(body[0].wa_id==69){
      //   // text="We have not heard from you in a while and wanted to know if there is any problem where we could help. If you kindly let us know the issue, it will be helpful for both of us.%0a%0a1. *All good. Will contact you soon* %0ahandypolls.com/o/ngQWrk %0a%0a2. *Waiting for someone else to confirm* %0ahandypolls.com/o/nJvM7W %0a%0a3. *Waiting for some other event (e.g. leaves, arranging funds etc.)* %0ahandypolls.com/o/ePoRLZ %0a%0a4. *Still not sure about the plan. Exploring more options* %0ahandypolls.com/o/nxLomk %0a%0a5. *Plans are final but not sure about your company* %0ahandypolls.com/o/85Wd2v %0a%0a6. *Not interested anymore. Kindly cancel* %0ahandypolls.com/o/nZaWxa"
      //   text="poll%0ajetovacations.com"
      // }

      var win = window.open(
        `https://wa.me/91${custData.chat_mobile_number}?text=${text}`,
        "_blank",
      );
    } else {
      alert(
        "Chat mobile number not present. Please enter number and try again",
      );
    }
  };

  const handleChange2 = () => {
    setpublishreview(!publishreview);
    settripData({ ...tripData, trip_review_show: publishreview });
  };

  var fupsomeDate = new Date();

  fupsomeDate.setDate(fupsomeDate.getDate());
  const fupy = fupsomeDate.getFullYear();
  const fupm =
    fupsomeDate.getMonth() + 1 < 10
      ? "0" + (fupsomeDate.getMonth() + 1)
      : fupsomeDate.getMonth() + 1;
  const fupdt =
    fupsomeDate.getDate() < 10
      ? "0" + fupsomeDate.getDate()
      : fupsomeDate.getDate();
  const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;

  const refreshconvquote = async () => {
    const qd = await fetchQuotebyId(tripData.conv_quote);
    //console.log(qd.data)
    var temparr = [];
    if ("day" in qd.data && qd.data.day.length > 0) {
      for (let i = 0; i < qd.data.day.length; i++) {
        const temp = {
          name: qd.data.day[i].hotel_name,
          date: qd.data.day[i].date,
          status: "No",
        };
        temparr = [...temparr, temp];
      }
      console.log(temparr);
    }
    setbookingData({ ...bookingData, hotellist: temparr });
  };

  // const total = () => {
  //   let sum = 0;
  //   if ("cust_payments" in tripData) {
  //     if (tripData.cust_payments.length == 0) {
  //       return sum;
  //     } else {
  //       tripData.cust_payments.map((item) =>
  //         item.amount
  //           ? !(item.status == "Refund" || item.status == "Credit Note")
  //             ? (sum = sum + parseInt(item.amount))
  //             : (sum = sum - parseInt(item.amount))
  //           : sum,
  //       );
  //       return sum;
  //     }
  //   } else {
  //     return sum;
  //   }
  // };

  const whatsappupdate = async (name, e) => {
    //console.log("ABC")

    if (e.target.innerHTML == "Send - 5:30pm") {
      setfollowupData2({
        date: today,
        fuptype: "Quote feedback",
        notes: "System fup - WA msg sent -" + name,
        time: "17:30",
        sys_gen: 1,
        status: "Open",
      });
    } else if (e.target.innerHTML == "Send - 2:00pm") {
      setfollowupData2({
        date: today,
        fuptype: "Quote feedback",
        notes: "System fup - WA msg sent -" + name,
        time: "14:00",
        sys_gen: 1,
        status: "Open",
      });
    } else if (e.target.innerHTML == "Send - D+1 12:30pm") {
      setfollowupData2({
        date: nextday,
        fuptype: "Quote feedback",
        notes: "System fup - WA msg sent -" + name,
        time: "12:30",
        sys_gen: 1,
        status: "Open",
      });
    } else if (e.target.innerHTML == "Send - D+2 12:30pm") {
      setfollowupData2({
        date: dayafter,
        fuptype: "Quote feedback",
        notes: "System fup - WA msg sent -" + name,
        time: "12:30",
        sys_gen: 1,
        status: "Open",
      });
    }
    whatsapp(name);

    // setTimeout(handleSubmit(e),5000)
  };

  const whatsappupdate1 = async (name, e) => {
    setwatime(new Date());
    settripData({ ...tripData, wa_sequence: [...tripData.wa_sequence, name] });

    setfollowupData2({
      date: today,
      fuptype: "Quote feedback",
      fupautonote: "System fup - WA msg sent -" + name,
      notes: "System fup - WA msg sent -" + name,
      time: "17:30",
      sys_gen: 1,
      status: "Open",
    });

    whatsapp(name);

    // setTimeout(handleSubmit(e),5000)
  };
  const whatsappupdate2 = async (name, e) => {
    setwatime(new Date());
    settripData({ ...tripData, wa_sequence: [...tripData.wa_sequence, name] });

    setfollowupData2({
      date: today,
      fuptype: "Quote feedback",
      fupautonote: "System fup - WA msg sent -" + name,
      notes: "System fup - WA msg sent -" + name,
      time: "14:00",
      sys_gen: 1,
      status: "Open",
    });

    whatsapp(name);

    // setTimeout(handleSubmit(e),5000)
  };
  const whatsappupdate3 = async (name, e) => {
    setwatime(new Date());
    settripData({ ...tripData, wa_sequence: [...tripData.wa_sequence, name] });
    setfollowupData2({
      date: nextday,
      fuptype: "Quote feedback",
      fupautonote: "System fup - WA msg sent -" + name,
      notes: "System fup - WA msg sent -" + name,
      time: "12:30",
      sys_gen: 1,
      status: "Open",
    });

    whatsapp(name);

    // setTimeout(handleSubmit(e),5000)
  };
  const whatsappupdate4 = async (name, e) => {
    setwatime(new Date());
    settripData({ ...tripData, wa_sequence: [...tripData.wa_sequence, name] });
    setfollowupData2({
      date: dayafter,
      fuptype: "Quote feedback",
      fupautonote: "System fup - WA msg sent -" + name,
      notes: "System fup - WA msg sent -" + name,
      time: "12:30",
      sys_gen: 1,
      status: "Open",
    });

    whatsapp(name);

    // setTimeout(handleSubmit(e),5000)
  };
  const whatsappupdate5 = async (name, e) => {
    var e2 = {
      target: {
        value: name,
      },
    };
    setwatime(new Date());
    settripData({ ...tripData, wa_sequence: [...tripData.wa_sequence, name] });
    let newaction = await liveactioncall(e2, tripData);
    //setnextaction(newaction)
    console.log(newaction);
    if (newaction && newaction.length > 10) {
      var date = newaction.slice(-10);
      if (new Date(date).getTime() <= new Date(DateCalc(0)).getTime()) {
        date = DateCalc(1);
      }
      setfollowupData2({
        date: date,
        fuptype: "Quote feedback",
        fupautonote: "System fup - WA msg sent -" + name,
        notes: "System fup - WA msg sent -" + name,
        time: "12:30",
        sys_gen: 1,
        status: "Open",
      });
    } else {
      //console.log("2")
      setfollowupData2({
        date: DateCalc(1),
        fuptype: "Quote feedback",
        fupautonote: "System fup - WA msg sent -" + name,
        notes: "System fup - WA msg sent -" + name,
        time: "12:30",
        sys_gen: 1,
        status: "Open",
      });
    }

    whatsapp(name);
  };

  const flightsearchtc = (fsData) => {
    if (fsData.source.length == 3 && fsData.dest.length == 3) {
      //https://tripjack.com/flight/list/?from=BLR&to=DEL&dep=2022-05-05&ADT=1&CHD=0&INF=0&pClass=Economy&tripType=0&pft=REGULAR
      //console.log(fsData)
      if (fsData.direct == "No" && fsData.type == "One-way") {
        var win = window.open(
          `https://www.travclan.com/flights/search/?&adultCount=${fsData.number_adults}&childCount=${fsData.number_child}&infantCount=0&directFlight=false&journeyType=1&origin=${fsData.source}&destination=${fsData.dest}&preferredDepartureTime=${fsData.dot}&flightCabinClass=1&memberCode=mj851&organizationCode=orjnsw`,
          "_blank",
        );
      } else if (fsData.direct == "Yes" && fsData.type == "One-way") {
        var win = window.open(
          `https://www.travclan.com/flights/search/?&adultCount=${fsData.number_adults}&childCount=${fsData.number_child}&infantCount=0&directFlight=true&journeyType=1&origin=${fsData.source}&destination=${fsData.dest}&preferredDepartureTime=${fsData.dot}&flightCabinClass=1&memberCode=mj851&organizationCode=orjnsw`,
          "_blank",
        );
      } else if (fsData.direct == "No" && fsData.type == "Return") {
        var win = window.open(
          `https://www.travclan.com/flights/search/?&adultCount=${fsData.number_adults}&childCount=${fsData.number_child}&infantCount=0&directFlight=false&journeyType=2&origin=${fsData.source}&destination=${fsData.dest}&preferredDepartureTime=${fsData.dot}&preferredReturnDepartureTime=${fsData.dor}&flightCabinClass=1&memberCode=mj851&organizationCode=orjnsw`,
          "_blank",
        );
      } else {
        var win = window.open(
          `https://www.travclan.com/flights/search/?&adultCount=${fsData.number_adults}&childCount=${fsData.number_child}&infantCount=0&directFlight=true&journeyType=2&origin=${fsData.source}&destination=${fsData.dest}&preferredDepartureTime=${fsData.dot}&preferredReturnDepartureTime=${fsData.dor}&flightCabinClass=1&memberCode=mj851&organizationCode=orjnsw`,
          "_blank",
        );
      }
    } else {
      alert("Wrong entry in source and dest. Must be 3 letters in each");
    }
  };

  const flightsearchtj = (fsData) => {
    if (fsData.source.length == 3 && fsData.dest.length == 3) {
      //https://tripjack.com/flight/list/?from=BLR&to=DEL&dep=2022-05-05&ADT=1&CHD=0&INF=0&pClass=Economy&tripType=0&pft=REGULAR
      //console.log(fsData)
      if (fsData.direct == "No" && fsData.type == "One-way") {
        var win = window.open(
          `https://tripjack.com/flight/list/?from=${fsData.source}&to=${fsData.dest}&dep=${fsData.dot}&ADT=${fsData.number_adults}&CHD=${fsData.number_child}&INF=0&pClass=Economy&tripType=0&pft=REGULAR`,
          "_blank",
        );
      } else if (fsData.direct == "Yes" && fsData.type == "One-way") {
        var win = window.open(
          `https://tripjack.com/flight/list/?from=${fsData.source}&to=${fsData.dest}&dep=${fsData.dot}&ADT=${fsData.number_adults}&CHD=${fsData.number_child}&INF=0&pClass=Economy&tripType=0&stops=0&pft=REGULAR`,
          "_blank",
        );
      } else if (fsData.direct == "No" && fsData.type == "Return") {
        var win = window.open(
          `https://tripjack.com/flight/list/?from=${fsData.source}&to=${fsData.dest}&dep=${fsData.dot}&ret=${fsData.dor}&ADT=${fsData.number_adults}&CHD=${fsData.number_child}&INF=0&pClass=Economy&tripType=1&pft=REGULAR`,
          "_blank",
        );
      } else {
        var win = window.open(
          `https://tripjack.com/flight/list/?from=${fsData.source}&to=${fsData.dest}&dep=${fsData.dot}&ADT=${fsData.number_adults}&CHD=${fsData.number_child}&INF=0&pClass=Economy&tripType=0&stops=0&pft=REGULAR`,
          "_blank",
        );
      }
    } else {
      alert("Wrong entry in source and dest. Must be 3 letters in each");
    }
  };

  const flightsearchapi = async (fsData) => {
    setOpen4(false);
    setOpen5(true);
    if (fsData.type == "One-way") {
      if (fsData.source && fsData.dest && fsData.dot && fsData.number_adults) {
        const options = {
          method: "GET",
          url: "https://skyscanner44.p.rapidapi.com/search",
          params: {
            adults: String(fsData.number_adults),
            origin: fsData.source,
            destination: fsData.dest,
            departureDate: fsData.dot,
            currency: "INR",
          },
          headers: {
            "X-RapidAPI-Key":
              "cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1",
            "X-RapidAPI-Host": "skyscanner44.p.rapidapi.com",
          },
        };

        //console.log(options)
        await axios
          .request(options)
          .then(function (response) {
            //const responseData = response.data
            setfrData(response.data);
            console.log(response.data);
          })
          .catch(function (error) {
            console.error(error);
          });
      } else {
        alert(
          "Please enter all data-source, dest, pax, date of travel correctly",
        );
      }
    } else if (fsData.type == "Return") {
      if (
        fsData.source &&
        fsData.dest &&
        fsData.dot &&
        fsData.dor &&
        fsData.number_adults
      ) {
        const options = {
          method: "GET",
          url: "https://skyscanner44.p.rapidapi.com/search",
          params: {
            adults: String(fsData.number_adults),
            origin: fsData.source,
            destination: fsData.dest,
            departureDate: fsData.dot,
            returnDate: fsData.dor,
            currency: "INR",
          },
          headers: {
            "X-RapidAPI-Key":
              "cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1",
            "X-RapidAPI-Host": "skyscanner44.p.rapidapi.com",
          },
        };

        //console.log(options)
        axios
          .request(options)
          .then(function (response) {
            //const responseData = response.data
            setfrData(response.data);
            console.log(response.data);
          })
          .catch(function (error) {
            console.error(error);
          });
      } else {
        alert(
          "Please enter all data-source, dest, pax, date of travel correctly",
        );
      }
    }
  };

  const custom = () => {
    if (custData.chat_mobile_number) {
      var customtext = prompt("Enter custom message: (use || for new line)");
      if (customtext) {
        var text3 = customtext.split("||");
        console.log(text3);
        var text = "";
        for (var i = 0; i < text3.length; i++) {
          if (i == 0) {
            text = text3[i];
          } else {
            text = text + "%0a" + text3[i];
          }
        }
        setwatime(new Date());

        var win = window.open(
          `https://wa.me/91${custData.chat_mobile_number}?text=${text}`,
          "_blank",
        );
      } else {
        alert("No text present");
      }
    } else {
      alert(
        "Chat mobile number not present. Please enter number and try again",
      );
    }
  };
  //whatsapp dialog
  const dialogopen2 = () => {
    if (shownewfup) {
      setOpen2(true);
    }

    //console.log(quotelist)
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleClose2b = () => {
    setOpen2b(false);
  };
  //flight dialog

  const dialogopen4 = async () => {
    setOpen4(true);

    //console.log(quotelist)
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  const handleClose5 = () => {
    setOpen5(false);
  };

  const handleClose7 = () => {
    setOpen7(false);
  };
  //script dialog
  const dialogopen3 = async () => {
    setOpen3(true);

    //console.log(quotelist)
  };

  const dialogopen5 = async () => {
    const data = await fetchTripsbyNumber(tripData.primary_mobile_number);
    //console.log(data.data)
    var temp = [];
    for (let i = 0; i < data.data.length; i++) {
      var crarr = [];
      for (let j = 0; j < data.data[i].callrecord.length; j++) {
        const newcr = {
          ...data.data[i].callrecord[j],
          trip_id: data.data[i].trip_id,
        };
        crarr = [...crarr, newcr];
      }
      temp = [...temp, ...crarr];
    }
    //   if("callrecord" in tripData){
    //     if("callrecord" in data.data){
    //       temp=[...tripData.callrecord,...data.data.callrecord]
    //   }else{
    //     temp=[...tripData.callrecord]
    //   }
    // }else{
    //   if("callrecord" in data.data){
    //     temp=[...data.data.callrecord]
    // }else{
    //   temp=[]
    // }
    // }
    // console.log([...tripData.callrecord])

    setcallrecorddata(temp);
    console.log(temp);

    setOpen6(true);

    //console.log(quotelist)
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  const handleClose6 = () => {
    setOpen6(false);
  };

  const handleClose8 = () => {
    setOpen8(false);
  };

  const getspRole = (owner) => {
    const temp = emplist.filter((data) => data.short_name == owner);
    if (temp.length > 0) {
      return temp[0].role;
    } else {
      return "";
    }
  };

  const tripcheck = (number) => {
    var temp3 = 0;

    if (
      !(role == "Admin" || cuser == "Kaushal") &&
      tripData.trip_owner == "Amit"
    ) {
      temp3 = 1;
      alert("Check trip owner and try again!");
    }

    if (
      role !== "Admin" &&
      (tripData.lead_source_airport == undefined ||
        tripData.lead_source_airport == "")
    ) {
      temp3 = 1;
      alert("Source Airport missing");
    }

    if (
      role == "Admin" &&
      (tripData.trip_status == "Active" ||
        tripData.trip_status == "Hot" ||
        tripData.trip_status == "New") &&
      !(
        getspRole(tripData.trip_owner) == "Sales" ||
        getspRole(tripData.trip_owner) == "TL" ||
        getspRole(tripData.trip_owner) == "SME" ||
        getspRole(tripData.trip_owner) == "Manager"
      )
    ) {
      temp3 = 1;
      alert("Cannot assign trip to an inactive salesperson");
    }

    if (new Date().getTime() - loadtime.getTime() > 60 * 1000 * 30) {
      alert("Trip Id is open for more than 30 minutes. Kindly reload the page");
      // console.log(temp)
      temp3 = 1;
      // if(temp!=="1"){
      //   temp3=1
      // }
    }

    if (
      (tripData.trip_status == "New" ||
        tripData.trip_status == "Active" ||
        tripData.trip_status == "Hot" ||
        tripData.trip_status == "Postponed") &&
      new Date(followupData.date).getTime() > new Date() &&
      (followupData.fupautonote !== "Waiting for rates" ||
        followupData.fupautonote !==
          "Need changes. Need to share updated quote" ||
        followupData.fupautonote !== "Will let you know within 2-3 days")
    ) {
      if (
        new Date(watime).getTime() < new Date(today).getTime() &&
        (role == "Sales" || role == "TL")
      ) {
        alert("Record not found for any Whatsapp msg sent today");
        let response = prompt("Skip sending WA msg? Press Y to skip");
        if (response !== "Y") {
          temp3 = 1;
        }
      }
    }

    // if(falsehot){
    //   alert("This a not the right criteria for marking hot. Only use the first 4 parameters to correctly judge a HOT lead")
    // }

    if (tripData.trip_status == "Hot") {
      // if(whyhot.fake1 || whyhot.fake2 || whyhot.fake3){
      //   alert("How the customer sounds or how you feel are not valid reasons for marking hot. Please use HOT definition for marking HOT")
      //   temp3=1
      // }
      var count = 0;
      if (whyhot.destination) {
        count++;
      }
      if (whyhot.date) {
        count++;
      }
      if (whyhot.pax) {
        count++;
      }

      if (count < 2 && !("package" in whyhot && whyhot.package)) {
        temp3 = 1;
        alert("Condition not satisfied for Hot");
      }
    }

    if (
      number !== 2 &&
      (role == "Sales" || role == "SME") &&
      (new Date(tripData.trip_start_date).getTime() - new Date().getTime()) /
        (1000 * 60 * 60 * 24) <
        7
    ) {
      let response2 = prompt(
        "Travel Date too near. Is the travel date correct? (Press Y to enter)",
      );
      if (response2 !== "Y") {
        temp3 = 1;
      }
    }
    // console.log(tripData)
    // console.log(temp3)
    return temp3;
  };

  const quotecheck = async () => {
    let temp = 1;
    for (let i = 0; i < tripData.quote.length; i++) {
      //console.log(tripData.quote[i])
      const data = await fetchquotedatesonly(tripData.quote[i]);
      // console.log(data.data[0])
      console.log(tripData.quote_pending_time);
      console.log(new Date(data.data[0].updatedAt).getTime());
      console.log(new Date(data.data[0].createdAt).getTime());
      console.log(new Date(tripData.quote_pending_time).getTime());
      if (
        data.data.length > 0 &&
        tripData.quote_pending_time &&
        new Date(data.data[0].createdAt).getTime() >
          new Date(tripData.quote_pending_time).getTime()
      ) {
        temp = 0;
      }
      if (
        data.data.length > 0 &&
        tripData.quote_pending_time &&
        new Date(data.data[0].updatedAt).getTime() >
          new Date(tripData.quote_pending_time).getTime()
      ) {
        temp = 0;
      }
    }
    //console.log(temp)
    return temp;
  };

  const quotecheck2 = async () => {
    let temp = 1;
    const today2 = DateCalc(0);
    const today = DateCalc2(today2, 0);
    const yesterday = DateCalc(-1);
    for (let i = 0; i < tripData.quote.length; i++) {
      //console.log(tripData.quote[i])
      const data = await fetchquotedatesonly(tripData.quote[i]);
      // console.log(new Date(tripData.quote_pending_time).getTime())
      // console.log(data.data[0])
      // console.log(tripData.quote_pending_time)
      // console.log(new Date(data.data[0].updatedAt).getTime())
      // console.log(new Date(today).getTime())
      // console.log(new Date(today))
      // console.log(new Date(yesterday))
      if (
        data.data.length > 0 &&
        new Date(data.data[0].createdAt).getTime() > new Date(today).getTime()
      ) {
        temp = 0;
      }
      if (
        data.data.length > 0 &&
        new Date(data.data[0].updatedAt).getTime() > new Date(today).getTime()
      ) {
        temp = 0;
      }
    }
    //console.log(temp)
    return temp;
  };

  const landstatuschange = (e) => {
    setbookingData({ ...bookingData, land: e.target.value });
    if (e.target.value == "Yes") {
      settripData({ ...tripData, land_booking_date: new Date() });
    }
  };
  //console.log(followupData)
  const handleSubmit = async (e) => {
    //console.log(quotepending)
    try {
      let qp = 0;

      var updatedata = 0,
        merge;
      e.preventDefault();
      let x = tripcheck(1);
      //if tripcheck passes
      if (!x) {
        var bookingflag =
          tripData.conv_quote == 1 ? { ...bookingData } : changehotelstatus2();
        console.log(bookingflag);
        var dnsave = 0;
        var abflag = false,
          jcdate = null,
          bor="",
          newfupdata = [...tripData.follow_up];
        //cannot save if edited or new quote is not found
        if (
          (tripData.trip_status == "Active" || tripData.trip_status == "Hot") &&
          (role == "Sales" || role == "TL") &&
          (followupData.fupautonote == "Quote shared" ||
            followupData.fupautonote ==
              "Asked to add flights. Shared quote with flights" ||
            followupData.fupautonote ==
              "Needed changes. Shared updated quote" ||
            followupData.fupautonote ==
              "Our quote is costly. Shared other options")
        ) {
          let ret2 = await quotecheck2();
          console.log(ret2);
          if (ret2) {
            qp = 1;
            dnsave = 1;
            alert("No edited or new quote found. Cannot save changes");
            return;
          }
        }
        //mark postponed automatically
        if (
          tripData.trip_status == "Active" &&
          (followupData.fupautonote == "Asked to postpone" ||
            followupData.fupautonote ==
              "Will call you back if we are interested" ||
            followupData.fupautonote == "Plan on hold")
        ) {
          settripData({ ...tripData, trip_status: "Postponed" });
        }

        if (tripData.quote.length > 0 && tripData.quote_pending) {
          qp = await quotecheck();
          console.log(qp);
        }
        var sdest = tripData.secondary_destinations;
        var tdest = tripData.tertiary_destinations;
        if (
          tripData.multi_destinations == "No" &&
          tripData.secondary_destinations !== ""
        ) {
          sdest = "";
          tdest = "";
        }
        var cp = {};
        var quotedata = {};
        console.log(tripData.trip_status);

        if (tripData.trip_status == "Converted") {
          if (tripData.conv_quote >= 1) {
            //fetch converted quote
            quotedata = await fetchQuotebyId(tripData.conv_quote);
            //set jcdate initially
            if ("jc_date" in tripData && tripData.jc_date == null) {
              jcdate = new Date(getconvdate(tripData));
              //console.log(jcdate)
            }
            if (!cf) {
              //converted quote data set state
              setquotedetails(quotedata.data);
              //set advance booking
              for (let i = 0; i < quotedata.data.day.length; i++) {
                if (
                  "tour_advance_booking" in quotedata.data.day[i] &&
                  quotedata.data.day[i].tour_advance_booking
                ) {
                  abflag = true;
                }
                if (
                  "hotel_name" in quotedata.data.day[i] &&
                  quotedata.data.day[i].hotel_name == "Genting Dream Cruise "
                ) {
                  abflag = true;
                }
                if (
                  new Date(quotedata.data.day[i].date).getTime() ==
                    new Date("2026-12-25").getTime() ||
                  new Date(quotedata.data.day[i].date).getTime() ==
                    new Date("2026-12-31").getTime()
                ) {
                  abflag = true;
                }
              }
            }

            cp =
              "cost_price" in quotedata.data ? quotedata.data.cost_price : {};
            console.log(quotedata.data);
          } else {
            dnsave = 1;
            alert("Select Converted quote. Trip will not be saved");
          }
        }

        if (tripData.trip_status == "Booked Outside") {
          const bodata = await searchboTripsbyDate3(
            DateCalc(-3),
            DateCalc(1),
            cuser,
          );
          console.log(bodata.data);
          if (bodata.data && bodata.data.length > 10) {
            alert("Too many BOs marked in the last 3 days. Consult your TL");
            return;
          }
        }

        //console.log(bookingData)

        const fupid =
          tripData.follow_up[tripData.follow_up.length - 1].id === undefined
            ? 1
            : tripData.follow_up[tripData.follow_up.length - 1].id + 1;

        if (
          followupData.fupautonote ==
          "Need changes. Need to share updated quote"
        ) {
          qp = 1;
        }
        var log = "status_log" in tripData ? [...tripData.status_log] : [];
        var ad = "accepted_date" in tripData ? tripData.accepted_date : null;
        jcdate = jcdate ? jcdate : tripData.jc_date;
        //var b2sd="b2s_date" in tripData?tripData.b2s_date:null
        if (
          oldbookingData &&
          bookingData &&
          "transfer_state" in oldbookingData &&
          "transfer_state" in bookingData &&
          oldbookingData.transfer_state !== bookingData.transfer_state
        ) {
          if (bookingData.transfer_state == "Accepted") {
            ad = new Date();
          }
          var r=""
          if (bookingData.transfer_state == "Just Converted") {
            jcdate = new Date();
            r=window.prompt("Enter reason of status change: ")
          }
                   
          var temp = {
            transfer_state: bookingData.transfer_state,
            transfer_state_date: new Date(),
            transfer_by:cuser,
            transfer_reason:r,
          };
          log = [...log, temp];
          if (bookingData.transfer_state == "Back to Sales") {
            var sp = employeelist.filter(
              (e) => e.short_name == tripData.trip_owner,
            );
            var spemail = sp[0].email;
            var tl = employeelist.filter(
              (e) => e.short_name == sp[0].reporting_manager,
            );
            var tlemail = tl[0].email;
            settripData({ ...tripData, upsell: [] });
            let from = "care@jetovacations.com";
            let to = [
              "abhishek.sharma@jetovacations.com",
              "ops4@jetovacations.com",
              "amit.singh@jetovacations.com",
              "rohit.saini@jetovacations.com",
              "product1@jetovacations.com",
              spemail,
              tlemail,
            ];
            let subject = "Trip assigned back to sales";
            let body = `<p>Trip Id ${tripData.trip_id} assigned back to sales. Owner is ${tripData.trip_owner}. Contact ops for detailed reason</p>`;
            gmailSend(from, to, subject, body);
          }
        }

        if (
          oldbookingData &&
          bookingData &&
          "ops_assigned" in oldbookingData &&
          "ops_assigned" in bookingData &&
          oldbookingData.ops_assigned !== bookingData.ops_assigned
        ) {
          var mailtemp = emplist.filter(
            (data) => data.short_name == bookingData.ops_assigned,
          );

          let from = "care@jetovacations.com";
          let to = mailtemp[0].email;
          let subject = "Trip assigned to you: " + tripData.trip_id;
          let body = `<p>New trip assigned to you with Trip Id ${tripData.trip_id} assigned back to sales. Owner is ${tripData.trip_owner}.</p>`;
          gmailSend(from, to, subject, body);
        }
        if (
          oldbookingData &&
          bookingData &&
          "upsell_ops_assigned" in oldbookingData &&
          "upsell_ops_assigned" in bookingData &&
          oldbookingData.upsell_ops_assigned !== bookingData.upsell_ops_assigned
        ) {
          var mailtemp = emplist.filter(
            (data) => data.short_name == bookingData.upsell_ops_assigned,
          );

          let from = "care@jetovacations.com";
          let to = mailtemp[0].email;
          let subject = "Trip assigned to you: " + tripData.trip_id;
          let body = `<p>New trip assigned to you with Trip Id ${tripData.trip_id} assigned back to sales. Owner is ${tripData.trip_owner}.</p>`;
          gmailSend(from, to, subject, body);
        }
        var newtl =
          "team_leader" in tripData ||
          ("team_leader" in tripData &&
            (tripData.team_leader == "" || tripData.team_leader == "Tarun"))
            ? false
            : tripData.team_leader;
        var newleadid = false;
        if (
          cuser == "Debayan" &&
          (tripData.trip_status == "Closed" ||
            tripData.trip_status == "Converted")
        ) {
          if (
            !("team_leader" in tripData) ||
            ("team_leader" in tripData &&
              (tripData.team_leader == "" || tripData.team_leader == "Tarun"))
          ) {
            newtl = window.prompt("Enter TL name:");
          }
          if (
            !(
              "lead" in tripData &&
              "lead_id" in tripData.lead &&
              tripData.lead.lead_id
            )
          ) {
            newleadid = window.prompt("Enter lead id:");
          }
        }

        var hbd =
          "hotel_booking_date" in tripData ? tripData.hotel_booking_date : null;
        if (
          oldbookingData &&
          bookingData &&
          bookingData.hotel == "Yes" &&
          oldbookingData.hotel !== "Yes"
        ) {
          hbd = new Date();
          let from = "care@jetovacations.com";
          let to = ["operations@jetovacations.com"];
          let subject =
            "Hotels booked: " +
            tripData.trip_id +
            " by " +
            tripData.booking.ops_assigned +
            " done by " +
            cuser;
          let body = `<p>Hotels booked marked Yes. Kindly reconfirm rates</p>`;
          gmailSend(from, to, subject, body);
        }

        if (
          followupData &&
          "fupautonote" in followupData &&
          followupData.fupautonote.length > 0
        ) {
          const finalfollowupData = {
            ...followupData,
            id: fupid,
            status:
              tripData.trip_status == "Closed" ||
              tripData.trip_status == "Dropped After Booking" ||
              tripData.trip_status == "Booked Outside" ||
              tripData.trip_status == "Cancelled"
                ? "Closed"
                : "Open",
            createdAt: new Date(),
            updatedAt: new Date(),
            createdby: cuser,
          };
          console.log(finalfollowupData);
          var x1 = [];
          tripData.follow_up.map((fup) => (fup.status = "Closed"));
          tripData.follow_up.map((fup) => (fup.updatedAt = new Date()));
          //console.log(tripData.follow_up);
          newfupdata = [...tripData.follow_up, finalfollowupData];
        }
        //console.log(oldstatus)
        if (tripData.trip_status !== oldstatus) {
          var newstatus = {
            new_status: tripData.trip_status,
            date: new Date(),
          };
          //disallow closing trip in the same month as conversion
          if (
            tripData.trip_status == "Closed" ||
            tripData.trip_status == "Dropped After Booking"
          ) {
            if ("converted_date" in tripData) {
              if (isSameMonth(new Date(tripData.converted_date), new Date())) {
                alert(
                  "Closed date/DAB date and Converted date cannot be in the same month",
                );
                return;
              }
            } else {
              alert("Converted date not found. Cannot proceed");
              return;
            }
          }
          //check number of pax matches
          if (
            tripData.trip_status == "Converted" &&
            tripData.conv_quote !== 1
          ) {
            if (
              tripData.number_adults !== quotedata.data.number_adults ||
              tripData.number_child !== quotedata.data.number_child
            ) {
              alert(
                "Number of adults or child in final quote and trip does not match",
              );
              return;
            }
            //autoupdate supplier payment
            // var flightcost =
            //   "totalflightcost" in quotedata.data
            //     ? quotedata.data.totalflightcost
            //     : 0;
            // var landcost =
            //   "totalcost" in quotedata.data ? quotedata.data.totalcost : 0;
            // var othercost =
            //   "totalvisacost" in quotedata.data
            //     ? quotedata.data.totalvisacost
            //     : 0;

            // tripData.visa_cp = othercost;
            // tripData.land_cp = landcost;
            // tripData.flight_cp = flightcost;

            // if (othercost > 0) {
            //   var newspentry = {
            //     date: new Date(),
            //     amount: othercost,
            //     status: "Pending",
            //   };
            //   tripData.supplier_payments = [
            //     ...tripData.supplier_payments,
            //     newspentry,
            //   ];
            // }

            // if (landcost > 0) {
            //   var newspentry2 = {
            //     date: new Date(),
            //     amount: landcost,
            //     status: "Pending",
            //   };
            //   tripData.supplier_payments = [
            //     ...tripData.supplier_payments,
            //     newspentry2,
            //   ];
            // }

            // if (flightcost > 0) {
            //   var newspentry3 = {
            //     date: new Date(),
            //     amount: flightcost,
            //     status: "Pending",
            //   };
            //   tripData.supplier_payments = [
            //     ...tripData.supplier_payments,
            //     newspentry3,
            //   ];
            // }
            //set booking flags for new conversions
            x1 = emplist.filter((emp) => emp.short_name == tripData.trip_owner);
            
            tripData.converted_date = new Date();
            bookingflag = {
              ...bookingflag,
              hotel: "No",
              flight: "No",
              insurance: "No",
              visa: "No",
              visa_applied: "No",
              others: "No",
              land: "No",
              voucher_matched: "No",
              voucher_explained: "No",
              preventive_messages: "No",
              invoice_name_matched: "No",
              cust_state_matched: "No",
              passport: "No",
              pan: "No",
              aadhaar: "No",
              return_tickets: "No",
              wa_group: "No",
              advance_tickets: "No",
              briefing_call: "No",
              transfer_state:"Just Converted"
            };
            console.log(tripData);
            //not reco hotels
            for (let i = 0; i < quotedata.data.day.length; i++) {
              const hid = quotedata.data.day[i].hotel_id;
              const tid = quotedata.data.day[i].tour_id;
              const hotel = await fetchHotelbyId(hid);
              if (
                hotel.data.hotel_reco == "Not Recommended" ||
                hotel.data.hotel_reco == "Not Allowed"
              ) {
                let from2 = "care@jetovacations.com";
                let to2 = [
                  "amit.singh@jetovacations.com",
                  "abhishek.sharma@jetovacations.com",
                  "debayan.ghosh@jetovacations.com",
                  "ops4@jetovacations.com",
                ];
                let subject2 =
                  "Wrong hotel sold in: " +
                  tripData.trip_id +
                  " by " +
                  tripData.trip_owner;
                let body2 = "";
                gmailSend(from2, to2, subject2, body2);
              } else {
                //alert("Hotel okay: "+hotel.data.hotel_name)
              }
            }
            if (!cf) {
              setOpen15(true);
              setcf(true);
              return;
            }
            console.log(tripData);
            if ("merge_trips" in reconfirm) {
              var merge2 = reconfirm.merge_trips.replace(/ /g, "");
              var checkstr = isNumericRegex(merge2);
              if (!checkstr) {
                alert("Merge trip ids not saved due to wrong entry!");
              } else {
                merge = merge2.split(",");
              }
            }
            updatedata = 1;
            if ("conv_quote" in tripData && tripData.conv_quote !== 1) {
              const updateQuoteResponse = await updatequoteData(
                quotedata.data._id,
                quotedata.data,
              );

              if (
                updateQuoteResponse.status == 200 ||
                201 ||
                202 ||
                203 ||
                204 ||
                205 ||
                206 ||
                207
              ) {
                alert(
                  "Quote updated for trip with trip id " +
                    updateQuoteResponse.data.trip_id +
                    " with quote id: " +
                    updateQuoteResponse.data.quote_id,
                );
              } else {
                alert("Something went wrong. Contact support");
                window.location = "/";
              }
            }
            try {
              const metadata = await sendpurchasetoMeta(tripData);
              console.log(metadata);
            } catch (err) {
              console.error("Meta CAPI failed:", err);
            }
          }
          console.log(tripData);
          if (
            tripData.trip_status == "Converted" ||
            tripData.trip_status == "Cancelled" ||
            tripData.trip_status == "Booked Outside" ||
            tripData.trip_status == "Dropped After Booking"
          ) {
            qp = 0;
            //alert(tripData.team_leader)
          }
          if (tripData.trip_status == "Booked Oustide"){
            bor=window.prompt("Enter reason for BO:")
          }
          if (tripData.trip_status == "Active") {
            tripData.canc_flag = false;
            tripData.canc_flag_time = null;
          }
          tripData.status_history.push(newstatus);
        }
        if (quotesent == true) {
          qp = 1;
        } else if (quotesent == false) {
          qp = 0;
        }
        if (
          oldconvquote &&
          "conv_quote" in tripData &&
          tripData.conv_quote &&
          tripData.conv_quote !== oldconvquote
        ) {
          var opsass =
            "booking" in tripData && "ops_assigned" in tripData.booking
              ? tripData.booking.ops_assigned
              : "Ops Not Assigned";
          var upsellass =
            "booking" in tripData && "upsell_ops_assigned" in tripData.booking
              ? tripData.booking.upsell_ops_assigned
              : "Ops Not Assigned";
          let from = "care@jetovacations.com";
          let to = ["operationsteam@jetovacations.com"];
          let subject =
            "Conv Quote changed: " +
            tripData.trip_id +
            " for " +
            opsass +
            "and " +
            upsellass;
          let body = `<p>Converted quote changed for Trip Id ${tripData.trip_id}. Owner is ${tripData.trip_owner}.</p>`;
          gmailSend(from, to, subject, body);
        }
        if (olddestination && tripData.primary_destination !== olddestination) {
          let from = "care@jetovacations.com";
          let to = ["accountsteam@jetovacations.com"];
          let subject = "Conv Quote destination changed: " + tripData.trip_id;
          let body = `<p>Converted quote destination changed for Trip Id ${tripData.trip_id}. Owner is ${tripData.trip_owner}.</p>`;
          gmailSend(from, to, subject, body);
        }
        console.log(tripData);
        const newdata = await fetchTripbyId(tripData.trip_id);
        console.log(updatedata);
        const finaltripData = {
          ...tripData,
          lead: newleadid
            ? { ...tripData.lead, lead_id: newleadid }
            : { ...tripData.lead },
          primary_email_id:
            "primary_email_id" in reconfirm
              ? reconfirm.primary_email_id
              : tripData.primary_email_id,
          number_adults:
            updatedata &&
            "number_adults" in reconfirm &&
            reconfirm.number_adults > 0
              ? reconfirm.number_adults
              : tripData.number_adults,
          number_child:
            updatedata &&
            "number_child" in reconfirm &&
            reconfirm.number_adults > 0
              ? reconfirm.number_child
              : tripData.number_child,
          child_age:
            updatedata &&
            "child_age" in reconfirm &&
            reconfirm.child_age.length > 0
              ? reconfirm.child_age
              : tripData.child_age,
          duration:
            updatedata &&
            "duration" in reconfirm &&
            reconfirm.duration.length > 0
              ? reconfirm.duration
              : tripData.duration,
          merge_trips:
            updatedata && "merge_trips" in reconfirm
              ? merge
              : "merge_trips" in tripData
                ? tripData.merge_trips
                : "",
          trip_start_date:
            updatedata &&
            "trip_start_date" in reconfirm &&
            reconfirm.trip_start_date.length > 0
              ? reconfirm.trip_start_date
              : tripData.trip_start_date,
          refund_committed:
            updatedata && "refund_committed" in reconfirm
              ? reconfirm.refund_committed
              : "refund_committed" in tripData
                ? tripData.refund_committed
                : "",
          last_wa_sent: watime,
          team_leader:
            "team_leader" in tripData && tripData.team_leader !== ""
              ? tripData.team_leader
              : newtl
                ? newtl
                : x1 && x1.length > 0 && "reporting_manager" in x1[0]
                  ? x1[0].reporting_manager
                  : "",
          hotreason: whyhot,
          secondary_destinations: sdest,
          tertiary_destinations: tdest,
          accepted_date: ad,
          jc_date: jcdate,
          status_log: log,
          hotel_booking_date: hbd,
          manual_quote: quotemissing,
          quote_pending: qp,
          quote_pending_time: qp ? new Date() : null,
          prev_next_action: nextaction,
          callrecord:
            "callrecord" in newdata.data
              ? newdata.data.callrecord.map((cr) =>
                  cr.call_id == calldata.call_id ? calldata : cr,
                )
              : [],
          cost_price: cp,
          follow_up: newfupdata,
          updatedAt: new Date(),
          last_updated_by: cuser,
          trip_password: "jeto@" + tripData.trip_id,
          booking: bookingflag,
          file: finalfiledetails,
          cust_details: custData._id,
          advance_booking: abflag,
          bo_reason:bor,
        };

        console.log(finaltripData);
        //window.location = ("/custdataentry/"+currentid);
        /////////////////////////////////////////////////////////////////////

        if (!dnsave) {
          const updatetripResponse = await updateTripdata(
            tripData._id,
            finaltripData,
          );

          if (
            updatetripResponse.status == 200 ||
            201 ||
            202 ||
            203 ||
            204 ||
            205 ||
            206 ||
            207
          ) {
            alert(
              "Data updated for trip with trip id " +
                updatetripResponse.data.trip_id,
            );
            window.location =
              "/tripdataentry/" + updatetripResponse.data.trip_id;
          } else {
            alert("Something went wrong. Contact support");
            window.location = "/";
          }
          //////////////////////////////////////////////////////////////////////////
        }
      } else {
        alert("Parameters of trip check failed. Cannot proceed");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const qualityopen = (cr) => {
    setOpen13(true);
    setcalldata(cr);
  };

  const handleSubmit2 = async () => {
    try {
      let qp = 0;
      var newfupdata = [...tripData.follow_up];
      let x = tripcheck(2);
      if (!x) {
        if (tripData.quote_pending) {
          qp = await quotecheck();
        }
        if (followupData2 == null) {
          alert("Please select a new fup date from messages");
        } else {
          var cp = {};
          if (tripData.trip_status == "Converted") {
            const quotedata = await fetchQuotebyId(tripData.conv_quote);
            cp =
              "cost_price" in quotedata.data ? quotedata.data.cost_price : {};
          }
          const fupid =
            tripData.follow_up[tripData.follow_up.length - 1].id === undefined
              ? 1
              : tripData.follow_up[tripData.follow_up.length - 1].id + 1;

          if (
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote" ||
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote-budget constraints" ||
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote-destination not sure" ||
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote-honeymoon" ||
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote-new hotels" ||
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote-premium properties" ||
            followupData2.fupautonote ==
              "System fup - WA msg sent -Will share quote-sample"
          ) {
            qp = 1;
          }
          if (
            followupData2 &&
            "fupautonote" in followupData2 &&
            followupData2.fupautonote.length > 0
          ) {
            const finalfollowupData = {
              ...followupData2,
              id: fupid,
              status:
                tripData.trip_status == "Converted" ||
                tripData.trip_status == "Closed" ||
                tripData.trip_status == "Dropped After Booking" ||
                tripData.trip_status == "Booked Outside" ||
                tripData.trip_status == "Cancelled"
                  ? "Closed"
                  : "Open",
              createdAt: new Date(),
              updatedAt: new Date(),
              createdby: cuser,
            };
            //console.log(finalfollowupData);

            tripData.follow_up.map((fup) => (fup.status = "Closed"));
            tripData.follow_up.map((fup) => (fup.updatedAt = new Date()));
            //console.log(tripData.follow_up);
            newfupdata = [...tripData.follow_up, finalfollowupData];
          }
          //console.log(oldstatus)
          if (tripData.trip_status !== oldstatus) {
            var newstatus = {
              new_status: tripData.trip_status,
              date: new Date(),
            };
            if (tripData.trip_status == "Closed") {
              tripData.all_clear = true;
            }
            tripData.status_history.push(newstatus);
          }
          if (quotesent == true) {
            qp = 1;
          } else if (quotesent == false) {
            qp = 0;
          }

          if (
            oldconvquote &&
            "conv_quote" in tripData &&
            tripData.conv_quote &&
            tripData.conv_quote !== oldconvquote
          ) {
            var opsass =
              "booking" in tripData && "ops_assigned" in tripData.booking
                ? tripData.booking.ops_assigned
                : "Ops Not Assigned";
            var upsellass =
              "booking" in tripData && "upsell_ops_assigned" in tripData.booking
                ? tripData.booking.upsell_ops_assigned
                : "Ops Not Assigned";
            let from = "care@jetovacations.com";
            let to = ["operationsteam@jetovacations.com"];
            let subject =
              "Conv Quote changed: " +
              tripData.trip_id +
              " for " +
              opsass +
              " and " +
              upsellass;
            let body = `<p>Converted quote changed for Trip Id ${tripData.trip_id} assigned back to sales. Owner is ${tripData.trip_owner}.</p>`;
            gmailSend(from, to, subject, body);
          }
          const newdata = await fetchTripbyId(tripData.trip_id);
          //console.log(newdata.data)
          const finaltripData = {
            ...tripData,
            last_wa_sent: watime,
            hotreason: whyhot,
            quote_pending: qp,
            quote_pending_time: qp ? new Date() : null,
            callrecord:
              "callrecord" in newdata.data ? newdata.data.callrecord : [],
            cost_price: cp,
            prev_next_action: nextaction,
            follow_up: newfupdata,
            updatedAt: new Date(),
            last_updated_by: cuser,
            booking: bookingData,
            cust_details: custData._id,
            file: finalfiledetails,
            trip_password: tripData.trip_password
              ? tripData.trip_password
              : "jeto@" + tripData.trip_id,
          };

          //console.log(finaltripData);
          //window.location = ("/custdataentry/"+currentid);
          const updatetripResponse = await updateTripdata(
            tripData._id,
            finaltripData,
          );

          if (
            updatetripResponse.status == 200 ||
            201 ||
            202 ||
            203 ||
            204 ||
            205 ||
            206 ||
            207
          ) {
            alert(
              "Data updated for trip with trip id " +
                updatetripResponse.data.trip_id,
            );
            window.location =
              "/tripdataentry/" + updatetripResponse.data.trip_id;
          } else {
            alert("Something went wrong. Contact support");
            window.location = "/";
          }
        }
      } else {
        alert("Trip parameters failed. Check date and airport");
      }
    } catch (err) {
      console.log(err);
    } finally {
      // Allow another auto-submit if this run bailed out (validation failed or
      // threw). On success the page navigates away, so resetting here is harmless.
      autoSubmitRef.current = false;
    }
  };

  const handleSubmit3 = async (temp) => {
    try {
      var finaltripData = { ...tripData };
      //console.log(newdata.data)
      if (temp) {
        finaltripData = {
          ...tripData,

          file: temp,
        };
      }

      console.log(finaltripData);
      //window.location = ("/custdataentry/"+currentid);
      const updatetripResponse = await updateTripdata(
        tripData._id,
        finaltripData,
      );

      if (
        updatetripResponse.status == 200 ||
        201 ||
        202 ||
        203 ||
        204 ||
        205 ||
        206 ||
        207
      ) {
        alert(
          "Data updated for trip with trip id " +
            updatetripResponse.data.trip_id,
        );
        window.location = "/tripdataentry/" + updatetripResponse.data.trip_id;
      } else {
        alert("Something went wrong. Contact support");
        window.location = "/";
      }
    } catch (err) {
      console.log(err);
    }
  };
  // reduce fup count shown in page
  const scrollshow = () => {
    setscroll(!scroll);
    if (tripData.follow_up && tripData.follow_up.length > 3) {
      if (scroll == true) {
        setfupData(
          tripData.follow_up.slice(
            tripData.follow_up.length - 3,
            tripData.follow_up.length,
          ),
        );
      } else {
        setfupData(tripData.follow_up);
      }
    } else {
      setfupData(tripData.follow_up);
    }
    //console.log(quotelist)
  };

  const scrollshow2 = () => {
    setscroll2(!scroll2);
    // if("fup" in bookingData && bookingData.fup.length>3){
    //   if(scroll2==true){
    //     setshowbookingData({...bookingData, fup:bookingData.fup.slice((bookingData.fup.length-3),bookingData.fup.length)});
    //   }else{
    //     setshowbookingData(bookingData);
    //   }
    // }else{
    //   setshowbookingData(bookingData);
    // }
    //console.log(quotelist)
  };

  const calltrue = () => {
    if (tripData.trip_status == "Hot") {
      return true;
    } else if (tripData.trip_status == "Active") {
      if (tripData.trip_channel == "Meta") {
        if ("lead" in tripData && "lead_status" in tripData.lead) {
          if (
            tripData.lead.lead_status ==
              "Definitely going on a trip. Planning in progress" ||
            tripData.lead.lead_status ==
              "Travel date, destination and people travelling all finalized. Just looking for a package"
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else if (tripData.trip_channel == "TripCrafters") {
        return true;
      } else if (tripData.trip_channel == "Manual") {
        if (tripData.trip_campaign !== "Poptin") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else if (tripData.trip_status == "New") {
      return true;
    }
  };

  const getInsight = async (index) => {
    try {
      console.log(index);
      let t = prompt(
        "Enter time in minutes to process. Usually takes 2 minutes",
      );
      const data = await getinsightviaapi({
        index: index,
        lead_id: tripData.trip_id,
        time: t,
      });
      console.log(data.data);
      if (data.data.details[0].progress == 100) {
        const temp1 = data.data.details[0].transcript.includes("Speaker")
          ? data.data.details[0].transcript.replaceAll("Speaker", "\n\nSpeaker")
          : "";
        const temp2 = data.data.details[0].default_prompt_response.includes(
          "Call Summary",
        )
          ? data.data.details[0].default_prompt_response.split("Call Summary")
          : [];
        const temp3 =
          temp2.length > 1 ? temp2[1].split("Agent Sentiment") : [""];
        setOpen4(true);
        setinsight({ transcript: temp1, summary: temp3[0], index: index });
      } else {
        alert("Need more time to process. Try again with incresing time");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const showInsight = (index) => {
    setinsight({
      transcript: tripData.callrecord[index].transcript,
      summary: tripData.callrecord[index].summary,
    });
    setOpen4(true);
  };

  const getClaudeInsight = async (cr) => {
    try {
      if (!cr.recording_url) {
        alert("No recording URL found for this call.");
        return;
      }
      const ok = window.confirm(
        "Transcribe & summarise this call using Claude AI? This can take a couple of minutes.",
      );
      if (!ok) return;
      setinsight({
        transcript:
          "Processing... transcribing and summarising the call. Please wait (this can take a few minutes).",
        summary: "",
      });
      setOpen4(true);

      // Step 1: start the transcription job.
      const startResp = await startclaudecallinsight({
        recording_url: cr.recording_url,
        call_id: cr.call_id,
      });
      const { jobName, s3Key } = startResp.data;

      // Step 2: poll for the result. ~5s interval, up to ~8 minutes.
      const MAX_POLLS = 96;
      for (let i = 0; i < MAX_POLLS; i++) {
        await new Promise((r) => setTimeout(r, 5000));
        const statusResp = await getclaudecallinsightstatus({ jobName, s3Key });
        if (statusResp.data.status === "completed") {
          setinsight({
            transcript: statusResp.data.transcript,
            summary: statusResp.data.summary,
          });
          return;
        }
        // else still processing — keep waiting.
      }
      setinsight({
        transcript:
          "Transcription is taking longer than expected. Please try again in a minute.",
        summary: "",
      });
    } catch (err) {
      console.log(err);
      const msg =
        err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : "Something went wrong while generating the AI insight.";
      setinsight({ transcript: msg, summary: "" });
      setOpen4(true);
    }
  };

  const changecannednotes = async (e) => {
    cancidentify(e);
    //alert(e.target.value)
    if (
      e.target.value == "Data entry only" ||
      e.target.value == "Data entry only - Msg sent" ||
      e.target.value == "Everything finalized. Awaiting payment" ||
      e.target.value == "Discussion going on over WA" ||
      e.target.value == "Call later for feedback"
    ) {
      setfollowupData({
        ...followupData,
        notes: e.target.value,
        fupautonote: e.target.value,
        date: tripData.follow_up[tripData.follow_up.length - 1].date,
        new_date: new Date(
          tripData.follow_up[tripData.follow_up.length - 1].date,
        ),
        time: tripData.follow_up[tripData.follow_up.length - 1].time,
      });
    } else {
      //console.log("ABC")

      let newaction = await liveactioncall(e, tripData);
      setnextaction(newaction);
      //console.log(newaction)
      let num = containsNumbers(newaction);
      if (num) {
        let d = getdate(newaction);
        let t = gettime(newaction);
        //console.log(d)
        //console.log(t)
        setfollowupData({
          ...followupData,
          date: d,
          time: t,
          notes: e.target.value,
          fupautonote: e.target.value,
          new_date: new Date(d),
        });
      }
    }
  };

  //console.log(followupData)

  const liveactioncall = async (e, td) => {
    var temp = "";
    const ttt2 = td.trip_start_date
      ? (
          (new Date(td.trip_start_date).getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
        ).toFixed(0)
      : 0;
    let q =
      "lead" in td
        ? getquality(
            td.lead.lead_status,
            td.lead.time_to_book,
            td.trip_channel,
            td.trip_start_date,
            td.lead.quality_upgrade,
            null,
          )
        : getquality(
            null,
            null,
            td.trip_channel,
            td.trip_start_date,
            null,
            null,
          );
    let p =
      "lead" in td && "potential" in td.lead
        ? " - " + "Potential: " + td.lead.potential
        : "";
    let fup = e.target.value;
    let fup1 =
      td.follow_up.length > 0
        ? td.follow_up[td.follow_up.length - 1].fupautonote
        : "";
    let fup2 =
      td.follow_up.length > 1
        ? td.follow_up[td.follow_up.length - 2].fupautonote
        : "";
    let fup3 =
      td.follow_up.length > 2
        ? td.follow_up[td.follow_up.length - 3].fupautonote
        : "";
    let status = td.trip_status;
    let fup1time =
      td.follow_up.length > 0 ? td.follow_up[td.follow_up.length - 1].time : "";
    let fup1date =
      td.follow_up.length > 0 ? td.follow_up[td.follow_up.length - 1].date : "";
    let fupcat = classifyfup(fup);
    let fup1cat = classifyfup(fup1);
    let fup2cat = classifyfup(fup2);
    let fup3cat = classifyfup(fup3);
    let ct = calltrue();
    console.log(fupcat);
    // if(fup1cat.qp){
    //   //console.log(fup1cat.qp)
    //   setquotepending(true)
    // }
    // console.log(p)
    // console.log(q)
    console.log(ttt2);
    // console.log(fup1)
    console.log(fup1time);
    // console.log(fup2)
    // console.log(status)
    console.log(fup1cat);
    var f = fupcat.fup ? fupcat.fup : fup1cat.fup ? fup1cat.fup : fup2cat.fup;
    var f2 = fup1cat.fup
      ? fup1cat.fup
      : fup2cat.fup
        ? fup2cat.fup
        : fup3cat.fup;
    // if(f==17){
    //   f2=fup2cat.fup?fup2cat.fup:(fup3cat.fup?fup3cat.fup:0)
    //   f=fup1cat.fup?fup1cat.fup:(fup2cat.fup?fup2cat.fup:fup3cat.fup)
    // }
    console.log(f, f2);
    if (status == "Active" || status == "New" || status == "Postponed") {
      ////Active+12:30
      if (fup1time == "12:30" || fup1time == "12:00") {
        if (f == 1) {
          if (ct) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61 && ttt2 < 91) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            }
          } else {
            if (f2 == 9) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                  q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(4);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(5);
                }
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                   q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(2);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(3);
                }
              }
            }
          }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 12:30pm on " +
              DateCalc(1);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3) {
          //console.log("Here")
          if (q == "Platinum" || q == "Rhodium" || q == "Diamond" || p == true) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Call after sharing quote and Set next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" || q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" || q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" || q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp = "Try to convert by offering the lowest quote possible";
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 17) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(6);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 22) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        }
      } else {
        //Active+5:30

        if (f == 1) {
          if (f2 == 9) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(4);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(5);
              }
            }
          } else {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              }
            }
          }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3 || f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" ||   q == "Rhodium" ||  q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(10);
          }
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp = "Try to convert by offering the lowest quote possible";
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 17) {
          temp = "Mark as Hot and Set next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(6);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 22) {
          temp = "Take next fup at 20:00pm on " + DateCalc(0);
        }
      }
    } else if (status == "Hot") {
      //Hot+12:30
      if (fup1time == "12:30" || fup1time == "12:00") {
        if (f == 1) {
          if (ct) {
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (f2 == 9) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                    q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(4);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(5);
                }
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                    q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(2);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(3);
                }
              }
            }
          }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 12:30pm on " +
              DateCalc(1);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3) {
          //console.log("Here")
          if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Call after sharing quote and Set next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp = "Try to convert by offering the lowest quote possible";
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 17) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(6);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 22) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        }
      } else {
        //Hot+5:30
        // var f=fupcat.fup?fupcat.fup:(fup1cat.fup?fup1cat.fup:fup2cat.fup)
        // var f2=fup1cat.fup?fup1cat.fup:(fup2cat.fup?fup2cat.fup:fup3cat.fup)
        if (f == 1) {
          if (f2 == 9) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(4);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(5);
              }
            }
          } else {
            if (ttt2 > 0 && ttt2 < 45) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 45 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              }
            }
          }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3 || f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 17:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(4);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 17:30pm on " + DateCalc(1);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp =
            "Try to convert by offering the lowest quote possible and take next fup at 17:30pm on " +
            DateCalc(0);
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 17) {
          temp = "Mark as Hot and Set next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 22) {
          temp = "Take next fup at 20:00pm on " + DateCalc(0);
        }
      }
    }

    // if(role=="Sales"){
    // settripData({...tripData, prev_next_action:temp})
    // }
    console.log(temp);
    return temp;

    // setnextaction(temp)
  };

  const countcall = () => {
    if (tripData.callrecord.length > 0) {
      var count = 0,
        diff = 0;
      for (let i = 0; i < tripData.callrecord.length; i++) {
        if (
          new Date(tripData.callrecord[i].start_stamp).getTime() >
          new Date(DateCalc(0)).getTime()
        ) {
          count++;
          if (count > 1) {
            diff = (
              (new Date(tripData.callrecord[i].start_stamp).getTime() -
                new Date(tripData.callrecord[i - 1].start_stamp).getTime()) /
              (1000 * 60)
            ).toFixed(0);
          }
        }
      }
      return { count: count, diff: diff };
    } else {
      return { count: 0, diff: 0 };
    }
  };

  const templiveactioncall = async (e, td) => {
    var temp = "";
    const ttt2 = td.trip_start_date
      ? (
          (new Date(td.trip_start_date).getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
        ).toFixed(0)
      : 0;
    let q =
      "lead" in td
        ? getquality(
            td.lead.lead_status,
            td.lead.time_to_book,
            td.trip_channel,
            td.trip_start_date,
            td.lead.quality_upgrade,
            null,
          )
        : getquality(
            null,
            null,
            td.trip_channel,
            td.trip_start_date,
            null,
            null,
          );
    let p =
      "lead" in td && "potential" in td.lead
        ? " - " + "Potential: " + td.lead.potential
        : "";
    let fup = e.target.value;
    let fup1 =
      td.follow_up.length > 0
        ? td.follow_up[td.follow_up.length - 1].fupautonote
        : "";
    let fup2 =
      td.follow_up.length > 1
        ? td.follow_up[td.follow_up.length - 2].fupautonote
        : "";
    let fup3 =
      td.follow_up.length > 2
        ? td.follow_up[td.follow_up.length - 3].fupautonote
        : "";
    let status = td.trip_status;
    let fup1time =
      td.follow_up.length > 0 ? td.follow_up[td.follow_up.length - 1].time : "";
    let fup1date =
      td.follow_up.length > 0 ? td.follow_up[td.follow_up.length - 1].date : "";
    let fupcat = classifyfup(fup);
    let fup1cat = classifyfup(fup1);
    let fup2cat = classifyfup(fup2);
    let fup3cat = classifyfup(fup3);
    let ct = calltrue();
    console.log(fupcat);
    // if(fup1cat.qp){
    //   //console.log(fup1cat.qp)
    //   setquotepending(true)
    // }
    // console.log(p)
    // console.log(q)
    console.log(ttt2);
    // console.log(fup1)
    console.log(fup1time);
    // console.log(fup2)
    // console.log(status)
    console.log(fup1cat);
    var f = fupcat.fup ? fupcat.fup : fup1cat.fup ? fup1cat.fup : fup2cat.fup;
    var f2 = fup1cat.fup
      ? fup1cat.fup
      : fup2cat.fup
        ? fup2cat.fup
        : fup3cat.fup;
    // if(f==17){
    //   f2=fup2cat.fup?fup2cat.fup:(fup3cat.fup?fup3cat.fup:0)
    //   f=fup1cat.fup?fup1cat.fup:(fup2cat.fup?fup2cat.fup:fup3cat.fup)
    // }
    console.log(f, f2);
    if (status == "Active" || status == "New" || status == "Postponed") {
      console.log(fup1time);
      ////Active+12:30
      if (fup1time !== "17:30") {
        if (f == 1) {
          temp =
            "Send updated quote and Set next fup at 17:30pm on " + DateCalc(0);
          // if(ct){
          //   if(ttt2>0 && ttt2<21){
          //   temp="Set next fup at 17:30pm on "+DateCalc(0)
          //   }else if(ttt2>=21 && ttt2<61){
          //     temp="Set next fup at 12:30pm on "+DateCalc(1)
          //   }else if(ttt2>=61 && ttt2<91){
          //     temp="Set next fup at 12:30pm on "+DateCalc(2)
          //   }else{
          //     temp="Set next fup at 12:30pm on "+DateCalc(3)
          //   }
          // }else{
          //   if(f2==9){
          //     if(ttt2>0 && ttt2<21){
          //       temp="Set next fup at 12:30pm on "+DateCalc(3)
          //     }else if(ttt2>=21 && ttt2<61){
          //       temp="Set next fup at 12:30pm on "+DateCalc(4)
          //     }else if(ttt2>=61 ){
          //       if(q=="Platinum" || q=="Diamond" || q=="Gold" || p==true){
          //         temp="Set next fup at 12:30pm on "+DateCalc(4)
          //       }else{
          //         temp="Set next fup at 12:30pm on "+DateCalc(5)
          //       }

          //     }
          //   }else{
          //   if(ttt2>0 && ttt2<21){
          //     temp="Set next fup at 12:30pm on "+DateCalc(1)
          //   }else if(ttt2>=21 && ttt2<61){
          //     temp="Set next fup at 12:30pm on "+DateCalc(2)
          //   }else if(ttt2>=61 ){
          //     if(q=="Platinum" || q=="Diamond" || q=="Gold" || p==true){
          //       temp="Set next fup at 12:30pm on "+DateCalc(2)
          //     }else{
          //       temp="Set next fup at 12:30pm on "+DateCalc(3)
          //     }

          //   }
          // }
          // }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 12:30pm on " +
              DateCalc(1);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3) {
          //console.log("Here")
          if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Call after sharing quote and Set next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" ||  q == "Rhodium" ||  q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp = "Try to convert by offering the lowest quote possible";
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 17) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(6);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 22) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        }
      } else {
        //Active+5:30
        var c = countcall();
        console.log(c);
        if (c.count > 1 && c.diff > 180) {
          if (f == 1) {
            if (f2 == 9) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                    q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(4);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(5);
                }
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                    q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(2);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(3);
                }
              }
            }
          } else if (f == 2) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            }
          } else if (f == 5) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (f == 3 || f == 20) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          } else if (f == 4) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            }
          } else if (f == 6) {
            let ret2 = await quotecheck2();
            if (ret2) {
              alert("Updated quote not found");
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else {
              if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
                if (ttt2 > 0 && ttt2 < 21) {
                  temp =
                    "Call after sharing quote and Set next fup at 17:30pm on " +
                    DateCalc(0);
                } else if (ttt2 >= 21 && ttt2 < 61) {
                  temp =
                    "Call after sharing quote and Set next fup at 12:30pm on " +
                    DateCalc(1);
                } else if (ttt2 >= 61) {
                  temp =
                    "Call after sharing quote and Set next fup at 12:30pm on " +
                    DateCalc(1);
                }
              } else {
                if (ttt2 > 0 && ttt2 < 21) {
                  temp = "Set next fup at 17:30pm on " + DateCalc(0);
                } else if (ttt2 >= 21 && ttt2 < 61) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(1);
                } else if (ttt2 >= 61) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(1);
                }
              }
            }
          } else if (f == 7) {
            temp = "Take action as per conversation";
          } else if (f == 8) {
            temp = "";
          } else if (f == 9) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 > 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(10);
            }
          } else if (f == 10) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
            } else if (ttt2 >= 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(5);
              }
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(7);
              }
            }
          } else if (f == 11) {
            /////email
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            }
          } else if (f == 12) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (f == 13) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(45);
            } else if (ttt2 >= 31 && ttt2 < 31) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(50);
            } else if (ttt2 >= 61) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(60);
            }
          } else if (f == 14) {
            temp = "Try to convert by offering the lowest quote possible";
          } else if (f == 15) {
            temp = "Mark as BO and report reason to TL";
          } else if (f == 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (f == 17) {
            temp = "Mark as Hot and Set next fup at 17:30pm on " + DateCalc(0);
          } else if (f == 18) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 > 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(6);
            }
          } else if (f == 19) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Set first quote and take next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 31) {
              temp =
                "Set first quote and take next fup at 12:30pm on " +
                DateCalc(1);
            } else if (ttt2 >= 61) {
              temp =
                "Set first quote and take next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else if (f == 21) {
            temp = "Take next fup at 12:30pm on " + DateCalc(1);
          } else if (f == 22) {
            temp = "Take next fup at 20:00pm on " + DateCalc(0);
          }
        }
      }
    } else if (status == "Hot") {
      //Hot+12:30
      if (fup1time == "12:30" || fup1time == "12:00") {
        if (f == 1) {
          if (ct) {
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (f2 == 9) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                    q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(4);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(5);
                }
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else if (ttt2 >= 61) {
                if (
                  q == "Platinum" ||
                    q == "Rhodium" ||
                  q == "Diamond" ||
                  q == "Gold" ||
                  p == true
                ) {
                  temp = "Set next fup at 12:30pm on " + DateCalc(2);
                } else {
                  temp = "Set next fup at 12:30pm on " + DateCalc(3);
                }
              }
            }
          }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 12:30pm on " +
              DateCalc(1);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3) {
          //console.log("Here")
          if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp =
                "Call after sharing quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Call after sharing quote and Set next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp = "Try to convert by offering the lowest quote possible";
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 17) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(6);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 22) {
          temp = "Take next fup at 17:30pm on " + DateCalc(0);
        }
      } else {
        //Hot+5:30
        // var f=fupcat.fup?fupcat.fup:(fup1cat.fup?fup1cat.fup:fup2cat.fup)
        // var f2=fup1cat.fup?fup1cat.fup:(fup2cat.fup?fup2cat.fup:fup3cat.fup)
        if (f == 1) {
          if (f2 == 9) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(4);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(4);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(5);
              }
            }
          } else {
            if (ttt2 > 0 && ttt2 < 45) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 45 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              }
            }
          }
        } else if (f == 2) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          } else if (ttt2 >= 61) {
            temp =
              "Send updated quote and Set next fup at 17:30pm on " +
              DateCalc(0);
          }
        } else if (f == 5) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 3 || f == 20) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 4) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 17:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          }
        } else if (f == 6) {
          let ret2 = await quotecheck2();
          if (ret2) {
            alert("Updated quote not found");
            temp = "Set next fup at 17:30pm on " + DateCalc(0);
          } else {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          }
        } else if (f == 7) {
          temp = "Take action as per conversation";
        } else if (f == 8) {
          temp = "";
        } else if (f == 9) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(4);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 10) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
          } else if (ttt2 >= 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (ttt2 >= 61) {
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || q == "Gold" || p == true) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else {
              temp = "Set next fup at 12:30pm on " + DateCalc(7);
            }
          }
        } else if (f == 11) {
          /////email
          if (ttt2 > 0 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 17:30pm on " + DateCalc(1);
          }
        } else if (f == 12) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 13) {
          if (ttt2 > 0 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(45);
          } else if (ttt2 >= 31 && ttt2 < 31) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(50);
          } else if (ttt2 >= 61) {
            temp =
              "Mark as postponed and Set next fup at 12:30pm on " +
              DateCalc(60);
          }
        } else if (f == 14) {
          temp =
            "Try to convert by offering the lowest quote possible and take next fup at 17:30pm on " +
            DateCalc(0);
        } else if (f == 15) {
          temp = "Mark as BO and report reason to TL";
        } else if (f == 16) {
          temp = "Set next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 17) {
          temp = "Mark as Hot and Set next fup at 17:30pm on " + DateCalc(0);
        } else if (f == 18) {
          if (ttt2 > 0 && ttt2 < 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(2);
          } else if (ttt2 > 16 && ttt2 < 31) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 31 && ttt2 < 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(3);
          } else if (ttt2 >= 61) {
            temp = "Set next fup at 12:30pm on " + DateCalc(5);
          }
        } else if (f == 19) {
          if (ttt2 > 0 && ttt2 < 21) {
            temp =
              "Set first quote and take next fup at 17:30pm on " + DateCalc(0);
          } else if (ttt2 >= 21 && ttt2 < 31) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          } else if (ttt2 >= 61) {
            temp =
              "Set first quote and take next fup at 12:30pm on " + DateCalc(1);
          }
        } else if (f == 21) {
          temp = "Take next fup at 12:30pm on " + DateCalc(1);
        } else if (f == 22) {
          temp = "Take next fup at 20:00pm on " + DateCalc(0);
        }
      }
    }

    // if(role=="Sales"){
    // settripData({...tripData, prev_next_action:temp})
    // }
    console.log(temp);
    return temp;

    // setnextaction(temp)
  };

  const apicall = async () => {
    setclickcall(true);
    const emp = emplist.filter(
      (e) => e.short_name == cuser && e.role !== "Ex-employee",
    );
    console.log(emp);
    if (custData.primary_mobile_number && emp[0].contact) {
      const calldata = {
        emp_number: String(emp[0].contact),
        cust_number: String(custData.primary_mobile_number),
        token: svtoken,
        entity_type: "Trip",
        entity_id: tripData.trip_id,
      };
      // console.log(calldata)
      try {
        const responsedata = await makecall(calldata);
        if (responsedata.data.message == "Originate successfully queued") {
          setAttempted(true);
          setOpen7(true);
        }
        //console.log(responsedata.data)
        alert(responsedata.data.message);
        //window.location.reload()
      } catch (error) {
        console.log(error);
        setAttempted(true);
        alert("Error: Call manually ");
        //window.location.reload()
      }
    } else {
      alert("Try again");
    }
  };

  const nextactioncall = async (td) => {
    var temp = "";
    const ttt2 = td.trip_start_date
      ? (
          (new Date(td.trip_start_date).getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
        ).toFixed(0)
      : 0;
    let q =
      "lead" in td
        ? getquality(
            td.lead.lead_status,
            td.lead.time_to_book,
            td.trip_channel,
            td.trip_start_date,
            td.lead.quality_upgrade,
            null,
          )
        : getquality(
            null,
            null,
            td.trip_channel,
            td.trip_start_date,
            null,
            null,
          );
    let p =
      "lead" in td && "potential" in td.lead
        ? " - " + "Potential: " + td.lead.potential
        : "";
    let fup1 =
      td.follow_up.length > 0
        ? td.follow_up[td.follow_up.length - 1].fupautonote
        : "";
    let fup2 =
      td.follow_up.length > 1
        ? td.follow_up[td.follow_up.length - 2].fupautonote
        : "";
    let fup3 =
      td.follow_up.length > 2
        ? td.follow_up[td.follow_up.length - 3].fupautonote
        : "";
    let status = td.trip_status;
    let fup1time =
      td.follow_up.length > 0 ? td.follow_up[td.follow_up.length - 1].time : "";
    let fup1date =
      td.follow_up.length > 0 ? td.follow_up[td.follow_up.length - 1].date : "";
    let fup1cat = classifyfup(fup1);
    let fup2cat = classifyfup(fup2);
    let fup3cat = classifyfup(fup3);
    //console.log(fup1cat)
    // if(fup1cat.qp){
    //   //console.log(fup1cat.qp)
    //   setquotepending(true)
    // }
    // console.log(p)
    // console.log(q)
    //console.log(ttt2)
    // console.log(fup1)
    // console.log(fup1time)
    // console.log(fup2)
    // console.log(status)
    //console.log(fup1cat)
    if (fup1time == "12:30" || fup1time == "12:00") {
      if (new Date(td.createdAt).getTime() > new Date(today).getTime()) {
        temp = "Set next fup at 5:30pm on " + DateCalc(1);
      } else {
        temp = "Set next fup at 5:30pm on " + DateCalc2(fup1date, 0);
      }
      //temp="Set next fup at 5:30pm on "+DateCalc(0)
    } else {
      if (status == "Active" || status == "New") {
        if (fup1cat.qp || quotepending || tripData.quote_pending) {
          temp =
            "Send updated quote and Set next fup at 17:30pm on " + DateCalc(0);
        } else {
          var f = fup1cat.fup
            ? fup1cat.fup
            : fup2cat.fup
              ? fup2cat.fup
              : fup3cat.fup;
          if (f == 1) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              }
            }
          } else if (f == 2) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            }
          } else if (f == 5) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (f == 3) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          } else if (f == 4) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            }
          } else if (f == 6) {
            // let ret2=await quotecheck2()
            // if(ret2){}
            if (q == "Platinum" ||  q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          } else if (f == 7) {
            temp = "Take action as per conversation";
          } else if (f == 8) {
            temp = "";
          } else if (f == 9) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 > 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(10);
            }
          } else if (f == 10) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
            } else if (ttt2 >= 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(5);
              }
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(7);
              }
            }
          } else if (f == 11) {
            /////email
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            }
          } else if (f == 12) {
            temp = "Mention cancellation reason and save";
          } else if (f == 13) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(45);
            } else if (ttt2 >= 31 && ttt2 < 31) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(50);
            } else if (ttt2 >= 61) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(60);
            }
          } else if (f == 14) {
            temp = "Try to convert by offering the lowest quote possible";
          } else if (f == 15) {
            temp = "Mark as BO and report reason to TL";
          } else if (f == 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (f == 17) {
            temp = "Mark as Hot and Set next fup at 17:30pm on " + DateCalc(0);
          } else if (f == 18) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 > 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(6);
            }
          } else if (f == 19) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Set first quote and take next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 31) {
              temp =
                "Set first quote and take next fup at 12:30pm on " +
                DateCalc(1);
            } else if (ttt2 >= 61) {
              temp =
                "Set first quote and take next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else if (f == 20) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          }
        }
      } else if (status == "Hot") {
        if (fup1cat.qp || quotepending || tripData.quote_pending) {
          temp =
            "Send updated quote and Set next fup at 17:30pm on " + DateCalc(0);
        } else {
          var f = fup1cat.fup
            ? fup1cat.fup
            : fup2cat.fup
              ? fup2cat.fup
              : fup3cat.fup;
          if (f == 1) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 21 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(2);
              }
            }
          } else if (f == 2) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 61) {
              temp =
                "Send updated quote and Set next fup at 17:30pm on " +
                DateCalc(0);
            }
          } else if (f == 5) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (f == 3) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          } else if (f == 4) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            }
          } else if (f == 6) {
            // let ret2=await quotecheck2()
            // if(ret2){}
            if (q == "Platinum" ||   q == "Rhodium" || q == "Diamond" || p == true) {
              if (ttt2 > 0 && ttt2 < 21) {
                temp =
                  "Call after sharing quote and Set next fup at 17:30pm on " +
                  DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              } else if (ttt2 >= 61) {
                temp =
                  "Call after sharing quote and Set next fup at 12:30pm on " +
                  DateCalc(1);
              }
            } else {
              if (ttt2 > 0 && ttt2 < 21) {
                temp = "Set next fup at 17:30pm on " + DateCalc(0);
              } else if (ttt2 >= 21 && ttt2 < 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              } else if (ttt2 >= 61) {
                temp = "Set next fup at 12:30pm on " + DateCalc(1);
              }
            }
          } else if (f == 7) {
            temp = "Take action as per conversation";
          } else if (f == 8) {
            temp = "";
          } else if (f == 9) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 > 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(4);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (f == 10) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Postpone and Set next fup at 12:30pm on " + DateCalc(60);
            } else if (ttt2 >= 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(5);
              }
            } else if (ttt2 >= 61) {
              if (
                q == "Platinum" ||
                  q == "Rhodium" ||
                q == "Diamond" ||
                q == "Gold" ||
                p == true
              ) {
                temp = "Set next fup at 12:30pm on " + DateCalc(3);
              } else {
                temp = "Set next fup at 12:30pm on " + DateCalc(7);
              }
            }
          } else if (f == 11) {
            /////email
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 17:30pm on " + DateCalc(0);
            } else if (ttt2 >= 31 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 17:30pm on " + DateCalc(1);
            }
          } else if (f == 12) {
            temp =
              "Mention cancellation reason and save. System will cancel automatically";
          } else if (f == 13) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(45);
            } else if (ttt2 >= 31 && ttt2 < 31) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(50);
            } else if (ttt2 >= 61) {
              temp =
                "Mark as postponed and Set next fup at 12:30pm on " +
                DateCalc(60);
            }
          } else if (f == 14) {
            temp =
              "Try to convert by offering the lowest quote possible and take next fup at 17:30pm on " +
              DateCalc(0);
          } else if (f == 15) {
            temp = "Mark as BO and report reason to TL";
          } else if (f == 16) {
            temp = "Set next fup at 12:30pm on " + DateCalc(1);
          } else if (f == 17) {
            temp = "Mark as Hot and Set next fup at 17:30pm on " + DateCalc(0);
          } else if (f == 18) {
            if (ttt2 > 0 && ttt2 < 16) {
              temp = "Set next fup at 12:30pm on " + DateCalc(2);
            } else if (ttt2 > 16 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(3);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(5);
            }
          } else if (f == 19) {
            if (ttt2 > 0 && ttt2 < 21) {
              temp =
                "Set first quote and take next fup at 17:30pm on " +
                DateCalc(0);
            } else if (ttt2 >= 21 && ttt2 < 31) {
              temp =
                "Set first quote and take next fup at 12:30pm on " +
                DateCalc(1);
            } else if (ttt2 >= 61) {
              temp =
                "Set first quote and take next fup at 12:30pm on " +
                DateCalc(1);
            }
          } else if (f == 20) {
            if (ttt2 > 0 && ttt2 < 31) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 31 && ttt2 < 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            } else if (ttt2 >= 61) {
              temp = "Set next fup at 12:30pm on " + DateCalc(1);
            }
          }
        }
      }
    }
    // if(role=="Sales"){
    // settripData({...tripData, prev_next_action:temp})
    // }
    return temp;
    // console.log(temp)
    // setnextaction(temp)
  };

  const cancidentify = (e) => {
    if (
      tripData.trip_status == "Active" ||
      tripData.trip_status == "New" ||
      tripData.trip_status == "Hot"
    ) {
      let cflag = 0;
      let reasonshort = "";
      //let cflagtime=null
      let fup = [];
      for (let j = 0; j < tripData.follow_up.length; j++) {
        let id = 0;
        if (
          tripData.follow_up[j].fupautonote ==
            "Call not picked and no response on Whatsapp" ||
          tripData.follow_up[j].fupautonote ==
            "No response after multiple follow ups" ||
          tripData.follow_up[j].fupautonote ==
            "Will call you back if we are interested" ||
          tripData.follow_up[j].fupautonote == "Plan on hold" ||
          tripData.follow_up[j].fupautonote ==
            "Asked to call later after a week" ||
          tripData.follow_up[j].fupautonote == "Asked to call later" ||
          tripData.follow_up[j].fupautonote ==
            "Asked to call later after a few days" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-3" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-4" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-5 Hot client" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-4 Hot client" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-3 Hot client"
        ) {
          id = 1;
          fup = [...fup, "NR"];
        }
        if (
          tripData.follow_up[j].fupautonote == "Call not picked. WA sent" ||
          tripData.follow_up[j].fupautonote == "Call disconnected by client" ||
          tripData.follow_up[j].fupautonote == "Yet to view quote" ||
          tripData.follow_up[j].fupautonote == "Will let you know" ||
          tripData.follow_up[j].fupautonote == "Call not picked" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-1" ||
          tripData.follow_up[j].fupautonote == "" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-2" ||
          tripData.follow_up[j].fupautonote ==
            "Okay with package. Will tell the final decision" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Generic Fup-1" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Generic Fup-2" ||
          tripData.follow_up[j].fupautonote == "Call not needed. Msg dropped" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Discuss with partner" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Flight price rise" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup-2 Hot client" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Generic Fup-3" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Hotel selling out" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will let you know-2" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will let you know" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Urgency Creation" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote-sample" ||
          tripData.follow_up[j].fupautonote == "Extra attempt to be made" ||
          tripData.follow_up[j].fupautonote == "Will contact you on my own"
        ) {
          id = 1;
          fup = [...fup, "Normal"];
        }
        if (
          tripData.follow_up[j].fupautonote ==
            "Asked to add flights. Shared quote with flights" ||
          tripData.follow_up[j].fupautonote ==
            "Need changes. Need to share updated quote" ||
          tripData.follow_up[j].fupautonote ==
            "Needed changes. Shared updated quote" ||
          tripData.follow_up[j].fupautonote == "Will let you know tomorrow" ||
          tripData.follow_up[j].fupautonote ==
            "Will let you know within 2-3 days" ||
          tripData.follow_up[j].fupautonote ==
            "Will let you know within a week" ||
          tripData.follow_up[j].fupautonote ==
            "Our quote is costly. Shared other options" ||
          tripData.follow_up[j].fupautonote ==
            "Budget issue. Will let us know" ||
          tripData.follow_up[j].fupautonote ==
            "Budget issue. Shared other options" ||
          tripData.follow_up[j].fupautonote ==
            "Comparing packages with other agencies" ||
          tripData.follow_up[j].fupautonote ==
            "Everything finalized. Awaiting payment" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Already book - not paid yet" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Asking old client for reference" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Change hotels" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Denying OG payment" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Trust issue" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Request competitor quote-2" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Request competitor quote" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Price is high" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote-budget constraints" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote-destination not sure" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote-honeymoon" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote-new hotels" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Will share quote-premium properties" ||
          tripData.follow_up[j].fupautonote ==
            "Asked to call at a specific time" ||
          tripData.follow_up[j].fupautonote ==
            "Need more time-client is positive" ||
          tripData.follow_up[j].fupautonote == "Waiting for rates" ||
          tripData.follow_up[j].fupautonote == "Discussion going on over WA" ||
          tripData.follow_up[j].fupautonote == "Quote shared"
        ) {
          fup = [...fup, "Progressive"];
          id = 1;
        }
        if (tripData.follow_up[j].fupautonote == "Fup done manually") {
          fup = [...fup, "Manual"];
          id = 1;
        }
        if (
          tripData.follow_up[j].fupautonote ==
            "Need to share voucher or tickets" ||
          tripData.follow_up[j].fupautonote == "Need to share insurance" ||
          tripData.follow_up[j].fupautonote ==
            "Need to confirm booking with supplier" ||
          tripData.follow_up[j].fupautonote ==
            "Need to make payment to supplier"
        ) {
          fup = [...fup, "PS"];
          id = 1;
        }
        if (
          tripData.follow_up[j].fupautonote == "Asked to cancel-on call" ||
          tripData.follow_up[j].fupautonote == "Asked to cancel-on whatsapp" ||
          tripData.follow_up[j].fupautonote == "Manual Cancellation" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Already book - paid" ||
          tripData.follow_up[j].fupautonote ==
            "Unable to meet guest requirements on product" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Asked to cancel-on call" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Asked to cancel-on whatsapp"
        ) {
          fup = [...fup, "Cancel"];
          id = 1;
        }
        if (
          tripData.follow_up[j].fupautonote == "Asked to postpone" ||
          tripData.follow_up[j].fupautonote == "Plan on hold"
        ) {
          fup = [...fup, "Postpone"];
          id = 1;
        }
        if (
          tripData.follow_up[j].fupautonote == "Data entry only" ||
          tripData.follow_up[j].fupautonote == "Data entry only - Msg sent" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -After quote sent" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -After quote sent-other options" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -After revised quote" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Cancelled-3" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Cancelled-2" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Cancelled-1" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Fup responses" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Hot NR" ||
          tripData.follow_up[j].fupautonote ==
            "System fup - WA msg sent -Quote sent responses"
        ) {
          id = 1;
        }
        // if(id==0){
        //   fup=[...fup, "Unidentified"]
        // }
      }

      if (
        e.target.value == "Call not picked and no response on Whatsapp" ||
        e.target.value == "No response after multiple follow ups" ||
        e.target.value == "Will call you back if we are interested" ||
        e.target.value == "Plan on hold" ||
        e.target.value == "Asked to call later after a week" ||
        e.target.value == "Asked to call later" ||
        e.target.value == "Asked to call later after a few days" ||
        e.target.value == "System fup - WA msg sent -Fup-3" ||
        e.target.value == "System fup - WA msg sent -Fup-4" ||
        e.target.value == "System fup - WA msg sent -Fup-5 Hot client" ||
        e.target.value == "System fup - WA msg sent -Fup-4 Hot client" ||
        e.target.value == "System fup - WA msg sent -Fup-3 Hot client"
      ) {
        // id=1
        fup = [...fup, "NR"];
      }
      if (
        e.target.value == "Call not picked. WA sent" ||
        e.target.value == "Call disconnected by client" ||
        e.target.value == "Yet to view quote" ||
        e.target.value == "Will let you know" ||
        e.target.value == "Call not picked" ||
        e.target.value == "System fup - WA msg sent -Fup-1" ||
        e.target.value == "" ||
        e.target.value == "System fup - WA msg sent -Fup-2" ||
        e.target.value == "Okay with package. Will tell the final decision" ||
        e.target.value == "System fup - WA msg sent -Generic Fup-1" ||
        e.target.value == "System fup - WA msg sent -Generic Fup-2" ||
        e.target.value == "Call not needed. Msg dropped" ||
        e.target.value == "System fup - WA msg sent -Discuss with partner" ||
        e.target.value == "System fup - WA msg sent -Flight price rise" ||
        e.target.value == "System fup - WA msg sent -Fup-2 Hot client" ||
        e.target.value == "System fup - WA msg sent -Generic Fup-3" ||
        e.target.value == "System fup - WA msg sent -Hotel selling out" ||
        e.target.value == "System fup - WA msg sent -Will let you know-2" ||
        e.target.value == "System fup - WA msg sent -Will let you know" ||
        e.target.value == "System fup - WA msg sent -Urgency Creation" ||
        e.target.value == "System fup - WA msg sent -Will share quote-sample" ||
        e.target.value == "Extra attempt to be made" ||
        e.target.value == "Will contact you on my own"
      ) {
        // id=1
        fup = [...fup, "Normal"];
      }
      if (
        e.target.value == "Asked to add flights. Shared quote with flights" ||
        e.target.value == "Need changes. Need to share updated quote" ||
        e.target.value == "Needed changes. Shared updated quote" ||
        e.target.value == "Will let you know tomorrow" ||
        e.target.value == "Will let you know within 2-3 days" ||
        e.target.value == "Will let you know within a week" ||
        e.target.value == "Our quote is costly. Shared other options" ||
        e.target.value == "Budget issue. Will let us know" ||
        e.target.value == "Budget issue. Shared other options" ||
        e.target.value == "Comparing packages with other agencies" ||
        e.target.value == "Everything finalized. Awaiting payment" ||
        e.target.value ==
          "System fup - WA msg sent -Already book - not paid yet" ||
        e.target.value ==
          "System fup - WA msg sent -Asking old client for reference" ||
        e.target.value == "System fup - WA msg sent -Change hotels" ||
        e.target.value == "System fup - WA msg sent -Denying OG payment" ||
        e.target.value == "System fup - WA msg sent -Trust issue" ||
        e.target.value ==
          "System fup - WA msg sent -Request competitor quote-2" ||
        e.target.value ==
          "System fup - WA msg sent -Request competitor quote" ||
        e.target.value == "System fup - WA msg sent -Price is high" ||
        e.target.value == "System fup - WA msg sent -Will share quote" ||
        e.target.value ==
          "System fup - WA msg sent -Will share quote-budget constraints" ||
        e.target.value ==
          "System fup - WA msg sent -Will share quote-destination not sure" ||
        e.target.value ==
          "System fup - WA msg sent -Will share quote-honeymoon" ||
        e.target.value ==
          "System fup - WA msg sent -Will share quote-new hotels" ||
        e.target.value ==
          "System fup - WA msg sent -Will share quote-premium properties" ||
        e.target.value == "Asked to call at a specific time" ||
        e.target.value == "Need more time-client is positive" ||
        e.target.value == "Waiting for rates" ||
        e.target.value == "Discussion going on over WA" ||
        e.target.value == "Quote shared"
      ) {
        fup = [...fup, "Progressive"];
        // id=1
      }
      if (e.target.value == "Fup done manually") {
        fup = [...fup, "Manual"];
        // id=1
      }
      if (
        e.target.value == "Need to share voucher or tickets" ||
        e.target.value == "Need to share insurance" ||
        e.target.value == "Need to confirm booking with supplier" ||
        e.target.value == "Need to make payment to supplier"
      ) {
        fup = [...fup, "PS"];
        // id=1
      }
      if (
        e.target.value == "Asked to cancel-on call" ||
        e.target.value == "Asked to cancel-on whatsapp" ||
        e.target.value == "Manual Cancellation" ||
        e.target.value == "System fup - WA msg sent -Already book - paid" ||
        e.target.value == "Unable to meet guest requirements on product" ||
        e.target.value ==
          "System fup - WA msg sent -Asked to cancel-on whatsapp" ||
        e.target.value == "System fup - WA msg sent -Asked to cancel-on call"
      ) {
        fup = [...fup, "Cancel"];
        // id=1
      }
      if (
        e.target.value == "Asked to postpone" ||
        e.target.value == "Plan on hold"
      ) {
        fup = [...fup, "Postpone"];
        // id=1
      }
      // if( (e.target.value=="Data entry only" || e.target.value=="System fup - WA msg sent -After quote sent" || e.target.value=="System fup - WA msg sent -After quote sent-other options" || e.target.value=="System fup - WA msg sent -After revised quote" || e.target.value=="System fup - WA msg sent -Cancelled-3" || e.target.value=="System fup - WA msg sent -Cancelled-2" || e.target.value=="System fup - WA msg sent -Cancelled-1" || e.target.value=="System fup - WA msg sent -Fup responses" || e.target.value=="System fup - WA msg sent -Hot NR" || e.target.value=="System fup - WA msg sent -Quote sent responses")){

      //   id=1
      // }

      // if((new Date(tripData.trip_start_date).getTime()-new Date().getTime())/(1000*60*60)<48){
      //   cflag=1
      //   reasonshort="System-travel date too close"
      // }
      if (fup[fup.length - 1] == "Cancel") {
        cflag = 1;
        reasonshort = "System-manual cancellation";
      }
      if (
        fup.length >= 10 &&
        (fup[fup.length - 1] == "NR" || fup[fup.length - 1] == "Normal") &&
        (fup[fup.length - 2] == "NR" || fup[fup.length - 2] == "Normal") &&
        (fup[fup.length - 3] == "NR" || fup[fup.length - 3] == "Normal") &&
        (fup[fup.length - 4] == "NR" || fup[fup.length - 4] == "Normal") &&
        (fup[fup.length - 5] == "NR" || fup[fup.length - 5] == "Normal") &&
        (fup[fup.length - 6] == "NR" || fup[fup.length - 6] == "Normal") &&
        (fup[fup.length - 7] == "NR" || fup[fup.length - 7] == "Normal") &&
        (fup[fup.length - 8] == "NR" || fup[fup.length - 8] == "Normal") &&
        (fup[fup.length - 9] == "NR" || fup[fup.length - 9] == "Normal") &&
        (fup[fup.length - 10] == "NR" || fup[fup.length - 10] == "Normal")
      ) {
        cflag = 1;
        reasonshort = "System-no response category 1";
      }
      // if(fup.length>=6 && fup[fup.length-1]=="NR" && fup[fup.length-2]=="NR" && fup[fup.length-3]=="NR" && fup[fup.length-4]=="NR" && (fup[fup.length-5]=="Normal" || fup[fup.length-5]=="Manual") && fup[fup.length-6]=="NR"){
      //   cflag=1
      //   reasonshort="System-no response category 2"
      //console.log(fup)
      //console.log(tripData.trip_id, cflag)
      if (cflag) {
        setshowsave(false);
      } else {
        setshowsave(true);
      }
    }
  };

  async function sendmail1() {
    let from = "care@jetovacations.com";
    const data2 = await fetchEmployeebyName(tripData.trip_owner);
    const data = await searchCustomersbyNumber(tripData.primary_mobile_number);
    let to = [data[0].data.primary_email_id, data2.data.email]; //data.data.primary_email_id,//data2.data.email
    let subject = "Unable to reach you - Jeto Vacations";

    let body = `<p>Hello ${tripData.cust_name}
    <p>Greetings from Jeto Vacations!</p>

    <p>I am sorry that we are unable to connect with you because the phone number and whatsapp. If you have any questions/doubts or you need more tyime to finalize, please let us know a good time to have a conversation.</p>
    <p>Kindly let us know the status of your trip so that we can move forward accordingly.</p>
    `;
    let receiptmail = gmailSend(from, to, subject, body);
  }

  const changetransferstate = (e) => {
    let flag = 0;
    if(oldbookingData.transfer_state=="Back to Sales" && e.target.value=="Just Converted"){
      alert("Cannot change from B2S to JC. Must be changed to Requested")
      return
    }else{
    if (e.target.value == "Requested" || e.target.value == "Accepted") {
      if ("mail_sent" in bookingData && bookingData.mail_sent == "Yes") {
        var received=total(tripData.cust_payments)-pending(tripData.cust_payments)
        //console.log(received, ((new Date().getTime()-new Date(tripData.converted_date).getTime())/(1000*60*60*24)) )
       if(received<9500 && ((new Date().getTime()-new Date(tripData.converted_date).getTime())/(1000*60*60*24))>15){
        alert("10k not received and 15 days have passed")
       }else{
        flag=1
       }
        
      } else {
        alert("Customer mail not found by ops team");
      }
    } else {
      flag = 1;
    }
    }
    if (flag) {
      setbookingData({ ...bookingData, transfer_state: e.target.value });
    }
  };

  const sendcancelmsg = () => {
    setwalist2b(walist.filter((wa) => wa.group_id == 16));
    setOpen2b(true);
    setshowsave(true);
  };

  const qpqs = (e) => {
    setquotepending(!quotepending);
    setquotesent(e.target.checked);
    console.log(e.target.checked);
  };

  const qmqs = (e) => {
    setquotemissing(!quotemissing);

    console.log(e.target.checked);
  };

  const markconv = (e) => {
    console.log(e);
    settripData({
      ...tripData,
      trip_status: e.target.value,
      jc_date: new Date(),
    });
    if (e.target.value == "Converted" && e.target.value !== oldstatus) {
      // const quotedata=await fetchQuotebyId(tripData.conv_quote)
      //     setquotedetails(quotedata.data)
      //setOpen15(true)
      //console.log(cp)
    }
  };

  const changemultidest = (e) => {
    if (e.target.value == "No") {
      settripData({
        ...tripData,
        secondary_destinations: "",
        tertiary_destinations: "",
        multi_destinations: e.target.value,
      });
    } else {
      settripData({ ...tripData, multi_destinations: e.target.value });
    }
  };

  const opendocmgmt = () => {
    setdocmgmt(true);
  };

  const handleClose9 = () => {
    setdocmgmt(false);
  };

  const handleClose11 = () => {
    setOpen10(false);
  };

  const uploadfile = async () => {
    //console.log(filedetails)
    try {
      const data = await uploadsinglefile(filedetails.file);
      console.log(data.data);
      if (data.data.name) {
        alert("File " + data.data.name + " uploaded succesfully");
      } else {
        alert("Error while uploading");
      }
      const temp = {
        location: data.data.location,
        name: data.data.name,
        type_of_doc: filecategory,
        uploadtime: new Date(),
      };
      setfinalfiledetails([...finalfiledetails, temp]);
    } catch (e) {
      console.log(e);
    }
  };

  const deletefile2 = async (name) => {
    try {
      //console.log(name)
      const data = await deletefile({ name: name });
      alert(data.data.msg);
      if (data.data.msg == "File deleted successfully") {
        const temp = finalfiledetails.filter((f) => f.name !== name);
        // setfinalfiledetails(temp)
        handleSubmit3(temp);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const changehotelstatus2 = (e, data) => {
    var temp = { ...bookingData };
    console.log(temp);
    let flag = 0,
      count = 0,
      count2 = 0;
    for (let i = 0; i < bookingData.hotellist.length; i++) {
      if (bookingData.hotellist[i].status == "No") {
        flag = 1;
      } else if (bookingData.hotellist[i].status == "NA") {
        count++;
      } else if (bookingData.hotellist[i].status == "Yes") {
        count2++;
      }
    }
    console.log(flag, count, count2);
    if (flag) {
      //setbookingData({ ...bookingData, hotel:"No" })
      temp = { ...temp, hotel: "No" };
    } else {
      console.log("Here");
      if (bookingData.hotellist.length == count) {
        console.log("here2");
        temp = { ...temp, hotel: "NA" };
        //setbookingData({ ...bookingData, hotel:"NA" })
      } else if (
        bookingData.hotellist.length == count2 ||
        bookingData.hotellist.length == count2 + count
      ) {
        //setbookingData({ ...bookingData, hotel:"Yes" })
        temp = { ...temp, hotel: "Yes" };
        settripData({ ...tripData, hotel_booking_date: new Date() });
      }
    }
    if (
      temp.fup.length > 0 &&
      temp.fup[temp.fup.length - 1].note == "" &&
      temp.fup[temp.fup.length - 1].category == "" &&
      temp.fup[temp.fup.length - 1].assigned == ""
    ) {
      temp = { ...temp, fup: temp.fup.slice(0, temp.fup.length - 1) };
    }
    console.log(temp);
    // setbookingData(temp)
    return temp;
  };

  const changehotelstatus = (e, data) => {
    if (e.target.value == "Yes") {
      setbookconfirm({ ...bookconfirm, hotel: data.name });
      setOpen18(true);
    } else {
      setbookingData({
        ...bookingData,
        hotellist: bookingData.hotellist.map((d) =>
          d.name == data.name ? { ...d, status: e.target.value } : d,
        ),
      });
    }
  };

  const handleFileInput = (e) => {
    console.log(e);
    const formdata = new FormData();
    formdata.append("myFile", e.target.files[0], e.target.files[0].name);
    setfiledetails({ ...filedetails, file: formdata, filetype: filecategory });
  };

  const handleFileInput2 = (e) => {
    //console.log(e)
    if (filecategory) {
      var tempfile = filedetails.length > 0 ? [...filedetails] : [];
      console.log(tempfile);
      for (let i = 0; i < e.target.files.length; i++) {
        const formdata = new FormData();
        formdata.append("myFile", e.target.files[i], e.target.files[i].name);
        const temp = {
          file: formdata,
          filetype: filecategory,
        };
        tempfile = [...tempfile, temp];
      }
      console.log(tempfile);
      setfiledetails(tempfile);
    } else {
      alert("Filetype not selected");
    }
    // const formdata=new FormData()
    // formdata.append("myFile",e.target.files[0],e.target.files[0].name)
    // setfiledetails({...filedetails, file:formdata});
  };

  const scandocs = async (f) => {
    //console.log(f)
    const temp = f.location.split("amazonaws.com/");
    const temp2 = temp[temp.length - 1];
    const documentKey = temp2
      .replaceAll("%20", " ")
      .replaceAll("%28", "(")
      .replaceAll("%29", ")");
    console.log(documentKey);
    const extension = documentKey.split(".").pop().toLowerCase();
    //console.log(extension)
    const panpattern = /\b[a-zA-Z]{5}\d{4}[a-zA-Z]\b/g;
    const passportpattern = /\b[a-zA-Z]\d{7}\b/g;
    const datepattern = /\b(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}\b/g;
    if (extension == "pdf") {
      const data = await analyzedocs(documentKey);
      console.log(data.data);
      setscannedwords("Please wait 15-20 secs");
      setOpen9(false);
      setdocmgmt(false);
      setOpen12(true);
      const data2 = await getanalyzedocsresult(data.data.blocks);
      console.log(data2.data);
      if ("results" in data2.data && "Blocks" in data2.data.results) {
        var text = "";
        for (let i = 0; i < data2.data.results.Blocks.length; i++) {
          if (
            data2.data.results.Blocks[i].BlockType == "WORD" ||
            data2.data.results.Blocks[i].BlockType == "LINE"
          ) {
            text = text + data2.data.results.Blocks[i].Text + " || ";
          }
        }

        setscannedwords(text);
      }
    } else {
      const data = await analyzedocs(documentKey);
      console.log(data.data);
      if ("blocks" in data.data) {
        const temp3 = data.data.blocks.filter((b) => b.BlockType == "WORD");
        console.log(temp3);
        var text = "";
        for (let i = 0; i < temp3.length; i++) {
          text = text + temp3[i].Text + " || ";
        }
        const panmatches = text.match(panpattern);
        console.log(panmatches);
        const psmatches = text.match(passportpattern);
        console.log(psmatches);
        if (panmatches && panmatches.length > 0) {
          setpanstring(panmatches.toString());
        } else {
          setpanstring("");
        }
        if (psmatches && psmatches.length > 0) {
          setpassportstring(psmatches.toString());
        } else {
          setpassportstring("");
        }
        console.log(text);
        setscannedwords(text);
      } else {
        setscannedwords("Scan failed");
      }
      setOpen9(false);
      setdocmgmt(false);
      setOpen12(true);
    }
  };

  const uploadmultifile = async () => {
    console.log(filedetails);
    var tempfiledetails = [...finalfiledetails];
    try {
      for (let i = 0; i < filedetails.length; i++) {
        const data = await uploadsinglefile(filedetails[i].file);
        console.log(data.data);
        if (data.data.name) {
          alert("File " + data.data.name + " uploaded succesfully");
        } else {
          alert("Error while uploading");
        }
        const temp = {
          location: data.data.location,
          name: data.data.name,
          type_of_doc: filedetails[i].filetype,
          uploadtime: new Date(),
        };
        tempfiledetails = [...tempfiledetails, temp];
      }
      setfinalfiledetails(tempfiledetails);
      console.log(tempfiledetails);
    } catch (e) {
      console.log(e);
    }
  };

  const competition = (e) => {
    settripData({
      ...tripData,
      competition: e.target.checked,
      competition_date: new Date(),
    });
    const finalarray = {
      to: [
        "debayan.ghosh@jetovacations.com",
        "product1@jetovacations.com",
        "product2@jetovacations.com",
        "product3@jetovacations.com",
        "amit.singh@jetovacations.com",
        "abhishek.sharma@jetovacations.com",
      ],
      sub:
        "Facing competition- " +
        tripData.trip_id +
        "(" +
        tripData.trip_owner +
        ")",
      body: "Agent claims that he/she is facing competition. Please check.",
    };
    const data = sendmailtoteam(finalarray);
  };

  const closeobjections = () => {
    setObj1(false);
    setObj2(false);
    setObj3(false);
    setObj4(false);
    setObj5(false);
  };

  const closescan = () => {
    setOpen12(false);
    setdocmgmt(true);
    setOpen9(false);
  };

  const gethoteltime = () => {
    var temp = "";
    //console.log(getconvdate(tripData))
    var temp2 = getconvdate(tripData)
      ? new Date(getconvdate(tripData)).getTime()
      : 0;
    //console.log(temp2)
    if ("file" in tripData && tripData.file.length > 0) {
      for (let i = 0; i < tripData.file.length; i++) {
        if (
          tripData.file[i].type_of_doc == "Hotel Voucher" ||
          tripData.file[i].type_of_doc == "Hotel & Land Voucher"
        ) {
          temp = (
            (new Date(tripData.file[i].uploadtime).getTime() -
              (temp2
                ? temp2
                : new Date(tripData.file[i].uploadtime).getTime())) /
            (1000 * 60 * 60 * 24)
          ).toFixed(1);
        }
      }
    } else {
      temp = "";
    }
    return temp;
  };

  const getlandtime = () => {
    var temp = "";
    var temp2 = getconvdate(tripData)
      ? new Date(getconvdate(tripData)).getTime()
      : 0;
    //console.log(temp2)
    if ("file" in tripData) {
      for (let i = 0; i < tripData.file.length; i++) {
        if (
          tripData.file[i].type_of_doc == "Land Voucher" ||
          tripData.file[i].type_of_doc == "Hotel & Land Voucher"
        ) {
          temp = (
            (new Date(tripData.file[i].uploadtime).getTime() -
              (temp2
                ? temp2
                : new Date(tripData.file[i].uploadtime).getTime())) /
            (1000 * 60 * 60 * 24)
          ).toFixed(1);
        }
      }
    } else {
      temp = "";
    }
    return temp;
  };

  const addquotetotrip = () => {
    const data = prompt("Enter quote id (number only. no text):");
    console.log(data);
    if (data) {
      settripData({
        ...tripData,
        quote: [...tripData.quote, Number(data.trim())],
      });
    }
  };

  const viewstatushistory = async () => {
    //const metadata=await sendpurchasetoMeta(tripData)
    setshowsh(true);
  };

  function getUniqueNames(arr) {
    if (arr && arr.length > 0) {
      const nameSet = new Set();

      for (const obj of arr) {
        if (obj.name) {
          nameSet.add(obj.name);
        }
      }

      return Array.from(nameSet);
    } else {
      return "";
    }
  }

  const vmcheck = () => {
    const values = Object.values(vm);

    const allNA = values.every((val) => val === "NA");
    const allNAorYes = values.every((val) => val === "NA" || val === "Yes");

    if (allNA) {
      setbookingData({ ...bookingData, voucher_matched: "NA" });
      setOpen16(false);
    } else if (allNAorYes) {
      setbookingData({
        ...bookingData,
        voucher_matched: "Yes",
        voucher_matched_date: new Date(),
      });
      setOpen16(false);
    } else {
      setbookingData({ ...bookingData, voucher_matched: "No" });
      setOpen16(false);
    }
  };

  function allYesExceptHotel(obj) {
    return Object.entries(obj).every(([key, value]) => {
      if (key === "hotel") return true; // skip "hotel"
      return value === "Yes";
    });
  }

  const bookingcheck = () => {
    //const values = Object.values(bookconfirm);

    const allYes = allYesExceptHotel(bookconfirm);

    if (allYes) {
      setbookingData({
        ...bookingData,
        hotellist: bookingData.hotellist.map((d) =>
          d.name == bookconfirm.hotel ? { ...d, status: "Yes" } : d,
        ),
      });
      setOpen18(false);
    } else {
      alert("Hotel booking status not changed");
      setOpen18(false);
    }
  };

  const senddatatometa = async () => {
    try {
      const data = await sendpurchasetoMeta(tripData);
      console.log(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const canccheck = async () => {
    try {
      const data = await runcancflagcheck(tripData.trip_id);
      console.log(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const changestartdate = (value) => {
    settripData({ ...tripData, trip_start_date: value });
    if (tripData.trip_status == "Converted") {
      setbookingData({
        ...bookingData,
        hotel: "No",
        land: "No",
        voucher_matched: "No",
        voucher_explained: "No",
        voucher_matched_date: null,
      });
    }
  };

  const extractviaai = async (f) => {
    setOpen20(true);
    setAIdata("loading");
    const data = await analyzeDocumentviaAI({ location: f.location });
    console.log(data.data);
    if (data.data.status == "success") {
      setAIdata(data.data);
    }
  };
  //console.log(bookingData)
  const getaiinsight = async () => {
    const gettripdata = await getaiinfo({ trip_id: tripData.trip_id });
    console.log(gettripdata.data);
  };

  const briefingcallchange = (e) => {
    setbookingData({ ...bookingData, briefing_call: e.target.value });
    if (e.target.value == "Yes") {
      window.open(url + "/taskdataentry", "_blank");
    }
  };

  const skipfupcall = () => {
    setOpen19(true);
  };

  const setskipcall = (e) => {
    setfollowupData({ ...followupData, skip_call_reason: e.target.value });
    setfollowupData2({ ...followupData2, skip_call_reason: e.target.value });
  };

  const skipfupcall2 = () => {
    if (
      "skip_call_reason" in followupData &&
      followupData.skip_call_reason.length > 0
    ) {
      setOpen19(false);
      setshownewfup(true);
    } else {
      alert("No reason found to skip call");
    }
  };

  const saveextracteddata = async () => {
    try {
      if (AIdata.document_type == "passport") {
        var newdata = {};
        newdata.date_of_birth =
          "date_of_birth" in AIdata.data && AIdata.data.date_of_birth
            ? converttoISO(AIdata.data.date_of_birth)
            : null;
        newdata.date_of_expiry =
          "date_of_expiry" in AIdata.data && AIdata.data.date_of_expiry
            ? converttoISO(AIdata.data.date_of_expiry)
            : null;
        newdata.date_of_issue =
          "date_of_issue" in AIdata.data && AIdata.data.date_of_issue
            ? converttoISO(AIdata.data.date_of_issue)
            : null;
        newdata.passport_holder_name = AIdata.data.passport_holder_name;
        newdata.passport_number = AIdata.data.passport_number;
        newdata.address = AIdata.data.address;
        console.log(newdata);
        if (
          "passport_details" in tripData &&
          tripData.passport_details.length > 0
        ) {
          var existingdata = [];
          const index = tripData.passport_details.findIndex(
            (obj) => obj.passport_number === newdata.passport_number,
          );

          if (index !== -1) {
            existingdata = tripData.passport_details.map((p) =>
              p.passport_number == newdata.passport_number
                ? { ...p, ...newdata }
                : p,
            );
          } else {
            existingdata = [...tripData.passport_details, newdata];
          }

          settripData({ ...tripData, passport_details: existingdata });
          //handleSubmit3()
        } else {
          settripData({ ...tripData, passport_details: [newdata] });
          //handleSubmit3()
        }
      }else if (AIdata.document_type == "aadhar_card"){
         var newdata = {};
        newdata.date_of_birth =
          "date_of_birth" in AIdata.data && AIdata.data.date_of_birth
            ? converttoISO(AIdata.data.date_of_birth)
            : null;
      
        newdata.passport_holder_name = AIdata.data.name;
        newdata.address = AIdata.data.address;
        console.log(newdata);
        if (
          "passport_details" in tripData &&
          tripData.passport_details.length > 0
        ) {
          var existingdata = [];
            existingdata = [...tripData.passport_details, newdata];

          settripData({ ...tripData, passport_details: existingdata });
          //handleSubmit3()
        } else {
          settripData({ ...tripData, passport_details: [newdata] });
          //handleSubmit3()
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  //console.log(tripData)

  return (
    <div>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="right">
          {/* <FormGroup row className={classes.formgroup}> */}
          <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Destination">Destination</InputLabel>
            <Select
              displayEmpty
              className={classes.textField2}
              InputLabelProps={{ shrink: true }}
              labelId="Destination"
              value={leadfilterData.destination}
              onChange={(e) =>
                setleadfilterData({
                  ...leadfilterData,
                  destination: e.target.value,
                })
              }
            >
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <Button
            href={"/knowledge/" + leadfilterData.destination}
            variant="contained"
            target="_blank"
            color="inherit"
            className={classes.smallbutton2}
          >
            Go
          </Button>
          {/* <Button
            onClick={()=>senddatatometa()}
            variant="contained"
            color="inherit"
            className={classes.smallbutton2}
          >
          Test
          </Button> */}
          {/* </FormGroup> */}
          {!(role == "Sales" || role == "SME") ? (
            <span>
              <FormControlLabel
                control={<Checkbox color="primary" />}
                checked={quotepending}
                label="Toggle QP"
                onChange={(e) => qpqs(e)}
              />
              <FormControlLabel
                control={<Checkbox color="primary" />}
                checked={quotemissing}
                label="Toggle QM"
                onChange={(e) => qmqs(e)}
              />
              {/* <FormControlLabel control={<Checkbox color="secondary"/>}  checked={"red_flag" in tripData?tripData.red_flag:false} label="Red Flag?" onChange={(e)=> settripData({...tripData, red_flag:e.target.checked})}/> */}
              <FormControlLabel
                control={<Checkbox color="secondary" />}
                checked={"pin_flag" in tripData ? tripData.pin_flag : false}
                label="Pin Trip"
                onChange={(e) =>
                  settripData({
                    ...tripData,
                    pin_flag: e.target.checked,
                    pin_person: cuser,
                    pin_date: e.target.checked ? new Date() : null,
                  })
                }
              />
              <FormControlLabel
                control={<Checkbox color="primary" />}
                checked={
                  "booker_flag" in tripData ? tripData.booker_flag : false
                }
                label="Booker Flag?"
                onChange={(e) =>
                  settripData({ ...tripData, booker_flag: e.target.checked })
                }
              />
            </span>
          ) : (
            ""
          )}
          {(role && !(role == "Sales" || role == "SME" || role == "TL")) ||
          (role &&
            (role == "Sales" ||
              role == "SME" ||
              role == "TL" ||
              role == "Sales Support") &&
            "trip_status" in tripData &&
            tripData.trip_status !== "Cancelled" &&
            shownewfup) ? (
            <Button
              onClick={dialogopen2}
              variant="contained"
              color="primary"
              className={classes.smallbutton}
            >
              <h6>Whatsapp</h6>
            </Button>
          ) : (
            ""
          )}
          <Button
            //href={"tel:+91" + tripData.primary_mobile_number}
            onClick={apicall}
            variant="contained"
            color="secondary"
            align="right"
            className={classes.smallbutton}
          >
            <h6>
              {"lead" in tripData &&
              "only_whatsapp" in tripData.lead &&
              tripData.lead.only_whatsapp
                ? "Whatsapp Only"
                : "Call"}
            </h6>
          </Button>
          <Button
            onClick={dialogopen3}
            variant="contained"
            color="inherit"
            align="right"
            className={classes.smallbutton}
          >
            <h6>Script</h6>
          </Button>

          <Button
            onClick={sendmail1}
            variant="contained"
            color="inherit"
            align="right"
            className={classes.smallbutton}
          >
            <h6>NR Mail</h6>
          </Button>
          <Button
            onClick={canccheck}
            variant="contained"
            color="inherit"
            align="right"
            className={classes.smallbutton}
          >
            <h6>Cancellation Check</h6>
          </Button>
          <Button
            onClick={() => dialogopen5()}
            variant="contained"
            color="inherit"
            align="right"
            className={classes.smallbutton}
          >
            <h6>Call History</h6>
          </Button>
          <Button
            onClick={() => setOpen7(true)}
            variant="contained"
            color="inherit"
            align="right"
            className={classes.smallbutton}
          >
            <h6>Help Text</h6>
          </Button>
          <Button
            onClick={() => setOpen10(true)}
            variant="contained"
            color="secondary"
            align="right"
            className={classes.smallbutton}
          >
            <h6>Closing</h6>
          </Button>

          {role == "Admin" || role == "Manager" ? (
            <div>
              <Button
                onClick={() => addquotetotrip()}
                variant="contained"
                color="secondary"
                align="right"
                className={classes.smallbutton}
              >
                <h6>Add Quote</h6>
              </Button>
              <Button
                onClick={() => viewstatushistory()}
                variant="contained"
                color="secondary"
                align="right"
                className={classes.smallbutton}
              >
                <h6>View SH</h6>
              </Button>
              <Button
                onClick={changeTL}
                variant="contained"
                color="inherit"
                align="right"
                className={classes.smallbutton}
              >
                <h6>Change TL</h6>
              </Button>
              <Button
                onClick={() => opendocmgmt()}
                variant="contained"
                color="secondary"
                align="right"
                className={classes.smallbutton}
              >
                <h6>View Docs</h6>
              </Button>
              <Button
                onClick={() => getaiinsight()}
                variant="contained"
                color="secondary"
                align="right"
                className={classes.smallbutton}
              >
                <h6>AI Insights</h6>
              </Button>
              <Button
                onClick={() => setOpen20(true)}
                variant="contained"
                color="secondary"
                align="right"
                className={classes.smallbutton}
              >
                <h6>Doc Details</h6>
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
        <Dialog fullWidth maxWidth="xl" open={Open16} onClose={handleClose16}>
          <DialogContent sx={{ ml: 3 }}>
            {bookingData &&
            "hotellist" in bookingData &&
            getUniqueNames(bookingData.hotellist).length > 0 ? (
              <div>
                {getUniqueNames(bookingData.hotellist).map((h) => (
                  <div>
                    <Typography
                      variant="h6"
                      align="center"
                      className={classes.headertext2}
                    >
                      {h}
                    </Typography>
                    <FormControl>
                      <FormLabel>Check Hotel name and dates?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "hotel_name_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "hotel_name_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["hotel_name_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check Hotel address & city?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "hotel_address_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "hotel_address_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["hotel_address_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions2.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check Number of rooms booked?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "number_rooms_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "number_rooms_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["number_rooms_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions3.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check Room Category of each room?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "room_category_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "room_category_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["room_category_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions4.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check check-in and check-out date?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "date_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "date_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["date_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check Meal type?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "meal_type_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "meal_type_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["meal_type_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions2.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>
                        Check salutation & name of lead pax?
                      </FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "pax_name_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "pax_name_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["pax_name_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions3.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check requirement for extra bed?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "extra_bed_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "extra_bed_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["extra_bed_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions4.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>
                        Check if all pax can be accommodated in room?
                      </FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "pax_acc_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "pax_acc_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["pax_acc_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>
                        Check additional services like floating breakfast,
                        decoration, cake, free shuttle etc.?
                      </FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm &&
                          vm[
                            "additional_" +
                              (getUniqueNames(bookingData.hotellist).indexOf(
                                h,
                              ) +
                                1)
                          ]
                            ? vm[
                                "additional_" +
                                  (getUniqueNames(
                                    bookingData.hotellist,
                                  ).indexOf(h) +
                                    1)
                              ]
                            : ""
                        }
                        onChange={(e) =>
                          setvm({
                            ...vm,
                            ["additional_" +
                            (getUniqueNames(bookingData.hotellist).indexOf(h) +
                              1)]: e.target.value,
                          })
                        }
                      >
                        {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                        {shuffledOptions2.map((opt) => (
                          <FormControlLabel
                            key={opt}
                            value={opt}
                            control={<Radio />}
                            label={opt}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <Divider></Divider>
                    <br></br>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}
            <br></br>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext2}
            >
              {"primary_destination" in tripData
                ? tripData.primary_destination
                : ""}
            </Typography>
            <div>
              <FormControl>
                <FormLabel>
                  Check Tour inclusions from customer quote?
                </FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "tour_name" in vm ? vm.tour_name : ""}
                  onChange={(e) => setvm({ ...vm, tour_name: e.target.value })}
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions3.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <FormControl>
                <FormLabel>Check if converted quote has been edited?</FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={
                    vm && "conv_quote_edit" in vm ? vm.conv_quote_edit : ""
                  }
                  onChange={(e) =>
                    setvm({ ...vm, conv_quote_edit: e.target.value })
                  }
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <FormControl>
                <FormLabel>
                  Check if every day timings have been mentioned?
                </FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "timings" in vm ? vm.timings : ""}
                  onChange={(e) => setvm({ ...vm, timings: e.target.value })}
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions2.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <br></br>
              <br></br>
              <FormControl>
                <FormLabel>Check Tour meals?</FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "tour_meals" in vm ? vm.tour_meals : ""}
                  onChange={(e) => setvm({ ...vm, tour_meals: e.target.value })}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="No" control={<Radio />} label="No" />
                  <FormControlLabel value="NA" control={<Radio />} label="NA" />
                </RadioGroup>
              </FormControl>
              <br></br>
              <br></br>
              <FormControl>
                <FormLabel>
                  Got feasibility of tour with flight timing?
                </FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "feasibility" in vm ? vm.feasibility : ""}
                  onChange={(e) =>
                    setvm({ ...vm, feasibility: e.target.value })
                  }
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions4.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <br></br>
              <br></br>
              <FormControl>
                <FormLabel>Got itinerary confirmation from client?</FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "itinerary" in vm ? vm.itinerary : ""}
                  onChange={(e) => setvm({ ...vm, itinerary: e.target.value })}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="No" control={<Radio />} label="No" />
                  <FormControlLabel value="NA" control={<Radio />} label="NA" />
                </RadioGroup>
              </FormControl>
              <br></br>
              <br></br>
              <FormControl>
                <FormLabel>Check inclusions from customer notes?</FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "customer_notes" in vm ? vm.customer_notes : ""}
                  onChange={(e) =>
                    setvm({ ...vm, customer_notes: e.target.value })
                  }
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions4.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <br></br>
              <br></br>
              <FormControl>
                <FormLabel>Check any special request from customer?</FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "special" in vm ? vm.special : ""}
                  onChange={(e) => setvm({ ...vm, special: e.target.value })}
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions2.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
            <br></br>
            <br></br>
            {"number_child" in tripData && tripData.number_child > 0 ? (
              <FormControl>
                <FormLabel>
                  Check if child tickets and meals are included?
                </FormLabel>
                <RadioGroup
                  row
                  name="travel-mode"
                  value={vm && "child_tickets" in vm ? vm.child_tickets : ""}
                  onChange={(e) =>
                    setvm({ ...vm, child_tickets: e.target.value })
                  }
                >
                  {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                  {shuffledOptions.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio />}
                      label={opt}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            ) : (
              ""
            )}
            <br></br>
            {"primary_destination" in tripData &&
            !identifydest(tripData.primary_destination) ? (
              <div>
                <FormControl>
                  <FormLabel>
                    Check all registrations & permissions required are done?
                  </FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "registartion" in vm ? vm.registartion : ""}
                    onChange={(e) =>
                      setvm({ ...vm, registartion: e.target.value })
                    }
                  >
                    {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                    {shuffledOptions4.map((opt) => (
                      <FormControlLabel
                        key={opt}
                        value={opt}
                        control={<Radio />}
                        label={opt}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
                <FormControl>
                  <FormLabel>Check pickup time of guests?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "pick_up_time" in vm ? vm.pick_up_time : ""}
                    onChange={(e) =>
                      setvm({ ...vm, pick_up_time: e.target.value })
                    }
                  >
                    {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                    {shuffledOptions2.map((opt) => (
                      <FormControlLabel
                        key={opt}
                        value={opt}
                        control={<Radio />}
                        label={opt}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </div>
            ) : (
              ""
            )}
            <br></br>
            <Divider></Divider>
            <br></br>
            {"secondary_destinations" in tripData &&
            tripData.secondary_destinations ? (
              <div>
                <Typography
                  variant="h6"
                  align="center"
                  className={classes.headertext2}
                >
                  {tripData.secondary_destinations}
                </Typography>
                <FormControl>
                  <FormLabel>Check Tour inclusions?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "tour_name2" in vm ? vm.tour_name2 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, tour_name2: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>Check Tour meals?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "tour_meals2" in vm ? vm.tour_meals2 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, tour_meals2: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>
                    Got feasibility of tour with flight timing?
                  </FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "feasibility2" in vm ? vm.feasibility2 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, feasibility2: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>Got itinerary confirmation from client?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "itinerary2" in vm ? vm.itinerary2 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, itinerary2: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>Check inclusions from customer notes?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={
                      vm && "customer_notes2" in vm ? vm.customer_notes2 : ""
                    }
                    onChange={(e) =>
                      setvm({ ...vm, customer_notes2: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>
                    Check any special request from customer?
                  </FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "special2" in vm ? vm.special2 : ""}
                    onChange={(e) => setvm({ ...vm, special2: e.target.value })}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                {"number_child" in tripData && tripData.number_child > 0 ? (
                  <FormControl>
                    <FormLabel>
                      Check if child tickets and meals are included?
                    </FormLabel>
                    <RadioGroup
                      row
                      name="travel-mode"
                      value={
                        vm && "child_tickets2" in vm ? vm.child_tickets2 : ""
                      }
                      onChange={(e) =>
                        setvm({ ...vm, child_tickets2: e.target.value })
                      }
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                      <FormControlLabel
                        value="NA"
                        control={<Radio />}
                        label="NA"
                      />
                    </RadioGroup>
                  </FormControl>
                ) : (
                  ""
                )}
                <br></br>
                <br></br>
                {identifydest(tripData.secondary_destinations) ? (
                  ""
                ) : (
                  <div>
                    <FormControl>
                      <FormLabel>
                        Check all registrations & permissions required are done?
                      </FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm && "registartion2" in vm ? vm.registartion2 : ""
                        }
                        onChange={(e) =>
                          setvm({ ...vm, registartion2: e.target.value })
                        }
                      >
                        <FormControlLabel
                          value="Yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="No"
                          control={<Radio />}
                          label="No"
                        />
                        <FormControlLabel
                          value="NA"
                          control={<Radio />}
                          label="NA"
                        />
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check pickup time of guests?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm && "pick_up_time2" in vm ? vm.pick_up_time2 : ""
                        }
                        onChange={(e) =>
                          setvm({ ...vm, pick_up_time2: e.target.value })
                        }
                      >
                        <FormControlLabel
                          value="Yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="No"
                          control={<Radio />}
                          label="No"
                        />
                        <FormControlLabel
                          value="NA"
                          control={<Radio />}
                          label="NA"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            <br></br>
            <Divider></Divider>
            <br></br>
            {"tertiary_destinations" in tripData &&
            tripData.tertiary_destinations ? (
              <div>
                <Typography
                  variant="h6"
                  align="center"
                  className={classes.headertext2}
                >
                  {tripData.tertiary_destinations}
                </Typography>
                <FormControl>
                  <FormLabel>Check Tour inclusions?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "tour_name3" in vm ? vm.tour_name3 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, tour_name3: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>Check Tour meals?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "tour_meals3" in vm ? vm.tour_meals3 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, tour_meals3: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>
                    Got feasibility of tour with flight timing?
                  </FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "feasibility3" in vm ? vm.feasibility3 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, feasibility3: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>Got itinerary confirmation from client?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "itinerary3" in vm ? vm.itinerary3 : ""}
                    onChange={(e) =>
                      setvm({ ...vm, itinerary3: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>Check inclusions from customer notes?</FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={
                      vm && "customer_notes3" in vm ? vm.customer_notes3 : ""
                    }
                    onChange={(e) =>
                      setvm({ ...vm, customer_notes3: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                <FormControl>
                  <FormLabel>
                    Check any special request from customer?
                  </FormLabel>
                  <RadioGroup
                    row
                    name="travel-mode"
                    value={vm && "special3" in vm ? vm.special3 : ""}
                    onChange={(e) => setvm({ ...vm, special3: e.target.value })}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="NA"
                      control={<Radio />}
                      label="NA"
                    />
                  </RadioGroup>
                </FormControl>
                <br></br>
                <br></br>
                {"number_child" in tripData && tripData.number_child > 0 ? (
                  <FormControl>
                    <FormLabel>
                      Check if child tickets and meals are included?
                    </FormLabel>
                    <RadioGroup
                      row
                      name="travel-mode"
                      value={
                        vm && "child_tickets3" in vm ? vm.child_tickets3 : ""
                      }
                      onChange={(e) =>
                        setvm({ ...vm, child_tickets3: e.target.value })
                      }
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                      <FormControlLabel
                        value="NA"
                        control={<Radio />}
                        label="NA"
                      />
                    </RadioGroup>
                  </FormControl>
                ) : (
                  ""
                )}
                <br></br>
                {identifydest(tripData.tertiary_destinations) ? (
                  ""
                ) : (
                  <div>
                    <FormControl>
                      <FormLabel>
                        Check all registrations & permissions required are done?
                      </FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm && "registartion3" in vm ? vm.registartion3 : ""
                        }
                        onChange={(e) =>
                          setvm({ ...vm, registartion3: e.target.value })
                        }
                      >
                        <FormControlLabel
                          value="Yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="No"
                          control={<Radio />}
                          label="No"
                        />
                        <FormControlLabel
                          value="NA"
                          control={<Radio />}
                          label="NA"
                        />
                      </RadioGroup>
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl>
                      <FormLabel>Check pickup time of guests?</FormLabel>
                      <RadioGroup
                        row
                        name="travel-mode"
                        value={
                          vm && "pick_up_time3" in vm ? vm.pick_up_time3 : ""
                        }
                        onChange={(e) =>
                          setvm({ ...vm, pick_up_time3: e.target.value })
                        }
                      >
                        <FormControlLabel
                          value="Yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="No"
                          control={<Radio />}
                          label="No"
                        />
                        <FormControlLabel
                          value="NA"
                          control={<Radio />}
                          label="NA"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            <br></br>
            <FormControl>
              <FormLabel>
                Check if these cases are handles properly?<br></br>
                <br></br>
                A. Burj Khalifa slot timing <br></br>
                B. MOF Tickets <br></br>
                C. Gulmarg Gondola Tickets <br></br>
                D. Tiger Kingdom tiger size <br></br>
                E. Floating breakfast/Cake/Flower/Bed decoration <br></br>
                F. Morning/Late night surcharge for flight
              </FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={vm && "usual_suspects" in vm ? vm.usual_suspects : ""}
                onChange={(e) =>
                  setvm({ ...vm, usual_suspects: e.target.value })
                }
              >
                {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
        <FormControlLabel value="NA" control={<Radio />} label="NA" /> */}
                {shuffledOptions4.map((opt) => (
                  <FormControlLabel
                    key={opt}
                    value={opt}
                    control={<Radio />}
                    label={opt}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <br></br>
            <Divider></Divider>
            <br></br>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext2}
            >
              Post Voucher Uploaded msg in group
            </Typography>
            <br></br>
            <Button
              onClick={() => vmcheck()}
              variant="outlined"
              color="secondary"
              className={classes.button2}
            >
              Check Done
            </Button>
            <br></br>
            <br></br>
          </DialogContent>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={Open19} onClose={handleClose19}>
          <FormControl
            style={{
              minWidth: 450,
              marginTop: 16,
              marginRight: 24,
              marginLeft: 5,
            }}
          >
            <InputLabel id="Skip Reason">Skip Reason</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Skip Reason"
              onChange={(e) => setskipcall(e)}
            >
              <MenuItem value={"WA Call done"}>{"WA Call done"}</MenuItem>
              <MenuItem value={"Manual Call done"}>
                {"Manual Call done"}
              </MenuItem>
              <MenuItem value={"Asked to cancel"}>{"Asked to Cancel"}</MenuItem>
              <MenuItem value={"Call not needed"}>{"Call not needed"}</MenuItem>
              <MenuItem value={"Guest disconnected before time"}>
                {"Guest disconnected before time"}
              </MenuItem>
            </Select>
          </FormControl>
          <Button
            onClick={() => skipfupcall2()}
            variant="contained"
            color="primary"
            className={classes.smallbutton}
          >
            <h6>Save</h6>
          </Button>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={Open17} onClose={handleClose17}>
          <DialogContent sx={{ ml: 3 }}>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Driver Number">
                Did you add supplier and change group name?
              </InputLabel>
              <Select
                classname={classes.textField}
                labelId="Group Name"
                value={tripData.group_name}
                onChange={(e) =>
                  settripData({ ...tripData, group_name: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <br></br>
            <br></br>
            <br></br>
            <TextField
              variant="outlined"
              label="Supplier Reference"
              value={tripData.supplier_reference_number}
              className={classes.textField}
              onChange={(e) =>
                settripData({
                  ...tripData,
                  supplier_reference_number: e.target.value,
                })
              }
            />
            <br></br>
            <br></br>
            <br></br>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Driver Number">Driver Number</InputLabel>
              <Select
                disabled={
                  "supplier_reference_number" in tripData &&
                  "group_name" in tripData &&
                  tripData.group_name !== "No"
                    ? 0
                    : 1
                }
                classname={classes.textField}
                labelId="Driver Number"
                value={tripData.driver_number}
                onChange={(e) =>
                  settripData({ ...tripData, driver_number: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
                <MenuItem value={"NR"}>NR</MenuItem>
              </Select>
            </FormControl>
            <br></br>
            <br></br>
            <br></br>
          </DialogContent>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={Open18} onClose={handleClose18}>
          <DialogContent sx={{ ml: 3 }}>
            <FormControl>
              <FormLabel>Check Hotel name?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "hotel_name" in bookconfirm ? bookconfirm.hotel_name : ""
                }
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, hotel_name: e.target.value })
                }
              >
                {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" /> */}
                {shuffledOptions.map((opt) => (
                  <FormControlLabel
                    key={opt}
                    value={opt}
                    control={<Radio />}
                    label={opt}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check Hotel address & city?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "hotel_address" in bookconfirm
                    ? bookconfirm.hotel_address
                    : ""
                }
                onChange={(e) =>
                  setbookconfirm({
                    ...bookconfirm,
                    hotel_address: e.target.value,
                  })
                }
              >
                {/* <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" /> */}
                {shuffledOptions.map((opt) => (
                  <FormControlLabel
                    key={opt}
                    value={opt}
                    control={<Radio />}
                    label={opt}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check Number of rooms booked?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "number_rooms" in bookconfirm ? bookconfirm.number_rooms : ""
                }
                onChange={(e) =>
                  setbookconfirm({
                    ...bookconfirm,
                    number_rooms: e.target.value,
                  })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check Room Category of each room?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "room_category" in bookconfirm
                    ? bookconfirm.room_category
                    : ""
                }
                onChange={(e) =>
                  setbookconfirm({
                    ...bookconfirm,
                    room_category: e.target.value,
                  })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check check-in and check-out date?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={"check_in" in bookconfirm ? bookconfirm.check_in : ""}
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, check_in: e.target.value })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check Meal type?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={"meal_type" in bookconfirm ? bookconfirm.meal_type : ""}
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, meal_type: e.target.value })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check salutation & name of lead pax?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "check_name" in bookconfirm ? bookconfirm.check_name : ""
                }
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, check_name: e.target.value })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Check requirement for extra bed?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={"extra_bed" in bookconfirm ? bookconfirm.extra_bed : ""}
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, extra_bed: e.target.value })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>
                Check if all pax can be accommodated in room?
              </FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={"pax_acc" in bookconfirm ? bookconfirm.pax_acc : ""}
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, pax_acc: e.target.value })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>
                Check additional services like floating breakfast, decoration,
                cake, free shuttle etc.?
              </FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "additional" in bookconfirm ? bookconfirm.additional : ""
                }
                onChange={(e) =>
                  setbookconfirm({ ...bookconfirm, additional: e.target.value })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <FormControl>
              <FormLabel>Did you send booking confirmation in group?</FormLabel>
              <RadioGroup
                row
                name="travel-mode"
                value={
                  "send_confirm" in bookconfirm ? bookconfirm.send_confirm : ""
                }
                onChange={(e) =>
                  setbookconfirm({
                    ...bookconfirm,
                    send_confirm: e.target.value,
                  })
                }
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <br></br>
            <br></br>
            <Typography variant="h6">
              Place request for double bed or special occassion arrangements
              while booking
            </Typography>
            <br></br>
            <br></br>
            <Button
              onClick={() => bookingcheck()}
              variant="outlined"
              color="secondary"
              className={classes.button2}
            >
              Check Done
            </Button>
            <br></br>
            <br></br>
            <br></br>
          </DialogContent>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth="xl"
          open={Open9}
          onClose={handleClose10}
          style={{
            backgroundColor: tripData.no_tax ? "#d0f0c0" : "#f8f8f8",
            transition: "background-color 0.5s ease",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Operations-Booking
          </Typography>
          <Divider></Divider>
          <p>WA Group is created by Support team not operations team</p>
          <p>Accepted On: {tripData.accepted_date}</p>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Assigned To
          </Typography>
          <Divider></Divider>
          <br></br>

          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="ops">Ops</InputLabel>
              <Select
                classname={classes.textField}
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product"
                    ? 0
                    : 1
                }
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                labelId="ops"
                value={bookingData ? bookingData.ops_assigned : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    ops_assigned: e.target.value,
                  })
                }
              >
                {empops.map((emp) => (
                  <MenuItem value={emp}>{emp}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="ops">Upsell Ops</InputLabel>
              <Select
                classname={classes.textField}
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product"
                    ? 0
                    : 1
                }
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                labelId="ops"
                value={bookingData ? bookingData.upsell_ops_assigned : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    upsell_ops_assigned: e.target.value,
                  })
                }
              >
                {empops.map((emp) => (
                  <MenuItem value={emp}>{emp}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Flight & Land
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Flightbook">All flights booked?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="Flightbook"
                value={bookingData ? bookingData.flight : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, flight: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Landbook">All landpart booked?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  tripData.hold_ops
                    ? 1
                    : role == "Admin" ||
                        role == "Operations-TL" ||
                        role == "Product" ||
                        role == "Operations"
                      ? 0
                      : 1
                }
                labelId="Landbook"
                value={bookingData ? bookingData.land : ""}
                onChange={(e) => landstatuschange(e)}
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Visa
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Visabook">All visa applied?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="Visabook"
                value={bookingData ? bookingData.visa_applied : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    visa_applied: e.target.value,
                    visa_applied_date:
                      "visa_applied" in oldbookingData &&
                      oldbookingData.visa_applied !== "Yes" &&
                      e.target.value == "Yes"
                        ? new Date()
                        : null,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
              <FormHelperText className={classes.red}>
                {"booking" in tripData &&
                "visa_applied_date" in tripData.booking
                  ? "Visa has been apllied on " +
                    tripData.booking.visa_applied_date
                  : ""}
              </FormHelperText>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Visabook">All visa booked?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="Visabook"
                value={bookingData ? bookingData.visa : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, visa: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Advance">Advance Tickets?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  tripData.hold_ops
                    ? 1
                    : role == "Admin" ||
                        role == "Operations-TL" ||
                        role == "Product" ||
                        role == "Operations"
                      ? 0
                      : 1
                }
                labelId="Advance"
                value={bookingData ? bookingData.advance_tickets : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    advance_tickets: e.target.value,
                  })
                }
              >
                <MenuItem value={"Not Done"}>Not Done</MenuItem>
                <MenuItem value={"Done"}>Done</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Hotel (
            {"hotel_booking_date" in tripData
              ? tripData.hotel_booking_date
              : ""}
            )
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            {"conv_quote" in tripData && tripData.conv_quote == 1 ? (
              <div>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="Hotelbook">All hotels booked?</InputLabel>
                  <Select
                    classname={classes.textField}
                    required={
                      tripData.trip_status == "Converted" ||
                      tripData.trip_status == "Closed"
                        ? 1
                        : 0
                    }
                    disabled={
                      tripData.hold_ops
                        ? 1
                        : role == "Admin" ||
                            role == "Operations-TL" ||
                            role == "Product" ||
                            role == "Operations"
                          ? 0
                          : 1
                    }
                    labelId="Hotelbook"
                    value={bookingData ? bookingData.hotel : ""}
                    onChange={(e) =>
                      setbookingData({ ...bookingData, hotel: e.target.value })
                    }
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"NA"}>NA</MenuItem>
                  </Select>
                </FormControl>
              </div>
            ) : (
              <div>
                <Link to="/hotelvoucher" state={{ tripData }}>
                  Voucher
                </Link>
                {bookingData &&
                  "hotellist" in bookingData &&
                  bookingData.hotellist.map((data) => {
                    return (
                      <FormGroup row className={classes.formgroup}>
                        <TextField
                          variant="standard"
                          disabled
                          required
                          value={data.date}
                          label="Date"
                          className={classes.textField4}
                          InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                          variant="standard"
                          disabled
                          required
                          value={data.name}
                          label="Hotel Name"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                        />
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="status">Status</InputLabel>
                          <Select
                            className={classes.textField4}
                            labelId="status"
                            value={data.status}
                            onChange={(e) => changehotelstatus(e, data)}
                            disabled={
                              role == "Admin" ||
                              role == "Operations-TL" ||
                              role == "Product" ||
                              role == "Operations"
                                ? 0
                                : 1
                            }
                          >
                            <MenuItem value={"Yes"}>Yes</MenuItem>
                            <MenuItem value={"No"}>No</MenuItem>
                            <MenuItem value={"NA"}>NA</MenuItem>
                          </Select>
                        </FormControl>
                      </FormGroup>
                    );
                  })}
              </div>
            )}
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Other
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Insurancebook">All insurance booked?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="Insurancebook"
                value={bookingData ? bookingData.insurance : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, insurance: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Otherbook">
                All additonal items booked?
              </InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="Otherbook"
                value={bookingData ? bookingData.others : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, others: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <br></br>
          <Divider></Divider>

          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Refund Details
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="due">Refund Due</InputLabel>
              <Select
                classname={classes.textField}
                labelId="due"
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                value={bookingData ? bookingData.refund_due : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, refund_due: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              label="Refund Details"
              disabled={
                role == "Admin" ||
                role == "Operations-TL" ||
                role == "Product" ||
                role == "Operations"
                  ? 0
                  : 1
              }
              value={bookingData ? bookingData.refund_reason : ""}
              className={classes.textField}
              onChange={(e) =>
                setbookingData({
                  ...bookingData,
                  refund_reason: e.target.value,
                })
              }
            />
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Fup
          </Typography>
          <Button
            onClick={() => scrollshow2()}
            variant="outlined"
            color="secondary"
            className={classes.button2}
          >
            {scroll ? "Show 3 fups" : "Show all fups"}
          </Button>
          <Divider></Divider>
          <br></br>
          {bookingData &&
            "fup" in bookingData &&
            bookingData.fup.map((data) => {
              return (
                <div>
                  {!scroll2 ? (
                    <div>
                      {bookingData.fup.indexOf(data) <
                      bookingData.fup.length - 5 ? (
                        ""
                      ) : (
                        <div>
                          <FormGroup row className={classes.formgroup}>
                            <TextField
                              variant="standard"
                              disabled={
                                bookingData.fup.length ==
                                bookingData.fup.indexOf(data) + 1
                                  ? 0
                                  : 1
                              }
                              type={
                                bookingData.fup.length ==
                                bookingData.fup.indexOf(data) + 1
                                  ? "Date"
                                  : ""
                              }
                              required
                              inputProps={{ min: fupfinalDate2 }}
                              value={data.date}
                              label="Date"
                              className={classes.textField4}
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) =>
                                setbookingData({
                                  ...bookingData,
                                  follow_up_date_text: e.target.value,
                                  fup: [
                                    ...bookingData.fup.slice(
                                      0,
                                      bookingData.fup.length - 1,
                                    ),
                                    {
                                      ...bookingData.fup[
                                        bookingData.fup.length - 1
                                      ],
                                      date: e.target.value,
                                    },
                                  ],
                                })
                              }
                            />
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 24,
                                marginLeft: 5,
                              }}
                            >
                              <InputLabel>Updated By</InputLabel>
                              <Select
                                className={classes.textField4}
                                required
                                disabled={
                                  bookingData.fup.length ==
                                  bookingData.fup.indexOf(data) + 1
                                    ? 0
                                    : 1
                                }
                                value={data.assigned}
                                onChange={(e) =>
                                  setbookingData({
                                    ...bookingData,
                                    fup: [
                                      ...bookingData.fup.slice(
                                        0,
                                        bookingData.fup.length - 1,
                                      ),
                                      {
                                        ...bookingData.fup[
                                          bookingData.fup.length - 1
                                        ],
                                        assigned: e.target.value,
                                      },
                                    ],
                                  })
                                }
                              >
                                {empops.map((emp) => (
                                  <MenuItem value={emp}>{emp}</MenuItem>
                                ))}
                              </Select>
                              <FormHelperText>
                                Please fill value to avoid deletion
                              </FormHelperText>
                            </FormControl>

                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="status">Category</InputLabel>
                              <Select
                                className={classes.textField}
                                labelId="status"
                                value={data.category}
                                disabled={
                                  bookingData.fup.length ==
                                  bookingData.fup.indexOf(data) + 1
                                    ? 0
                                    : 1
                                }
                                onChange={(e) =>
                                  setbookingData({
                                    ...bookingData,
                                    fup: [
                                      ...bookingData.fup.slice(
                                        0,
                                        bookingData.fup.length - 1,
                                      ),
                                      {
                                        ...bookingData.fup[
                                          bookingData.fup.length - 1
                                        ],
                                        category: e.target.value,
                                      },
                                    ],
                                  })
                                }
                              >
                                <MenuItem value={"Payment Collection"}>
                                  Payment Collection
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Booking inventory"}>
                                  Booking inventory
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Providing information"}>
                                  Providing information
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Change request"}>
                                  Change request
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Visa processing"}>
                                  Visa processing
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Booking additional items"}>
                                  Booking additional items
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Voucher match/explanation"}>
                                  Voucher match/explanation
                                </MenuItem>
                                //{" "}
                                <MenuItem value={"Driver details"}>
                                  Driver details
                                </MenuItem>
                                // <MenuItem value={"Others"}>Others</MenuItem>
                              </Select>
                              <FormHelperText>
                                Please fill value to avoid deletion
                              </FormHelperText>
                            </FormControl>
                          </FormGroup>
                          <TextField
                            variant="standard"
                            disabled={
                              bookingData.fup.length ==
                              bookingData.fup.indexOf(data) + 1
                                ? 0
                                : 1
                            }
                            fullWidth
                            required
                            value={data.note}
                            className={classes.textArea}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) =>
                              setbookingData({
                                ...bookingData,
                                fup: [
                                  ...bookingData.fup.slice(
                                    0,
                                    bookingData.fup.length - 1,
                                  ),
                                  {
                                    ...bookingData.fup[
                                      bookingData.fup.length - 1
                                    ],
                                    note: e.target.value,
                                  },
                                ],
                              })
                            }
                          />
                          <br></br>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <FormGroup row className={classes.formgroup}>
                        <TextField
                          variant="standard"
                          disabled={
                            bookingData.fup.length ==
                            bookingData.fup.indexOf(data) + 1
                              ? 0
                              : 1
                          }
                          type={
                            bookingData.fup.length ==
                            bookingData.fup.indexOf(data) + 1
                              ? "Date"
                              : ""
                          }
                          required
                          inputProps={{ min: fupfinalDate2 }}
                          value={data.date}
                          label="Date"
                          className={classes.textField4}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setbookingData({
                              ...bookingData,
                              follow_up_date_text: e.target.value,
                              fup: [
                                ...bookingData.fup.slice(
                                  0,
                                  bookingData.fup.length - 1,
                                ),
                                {
                                  ...bookingData.fup[
                                    bookingData.fup.length - 1
                                  ],
                                  date: e.target.value,
                                },
                              ],
                            })
                          }
                        />
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 24,
                            marginLeft: 5,
                          }}
                        >
                          <InputLabel>Updated By</InputLabel>
                          <Select
                            className={classes.textField4}
                            required
                            disabled={
                              bookingData.fup.length ==
                              bookingData.fup.indexOf(data) + 1
                                ? 0
                                : 1
                            }
                            value={data.assigned}
                            onChange={(e) =>
                              setbookingData({
                                ...bookingData,
                                fup: [
                                  ...bookingData.fup.slice(
                                    0,
                                    bookingData.fup.length - 1,
                                  ),
                                  {
                                    ...bookingData.fup[
                                      bookingData.fup.length - 1
                                    ],
                                    assigned: e.target.value,
                                  },
                                ],
                              })
                            }
                          >
                            {empops.map((emp) => (
                              <MenuItem value={emp}>{emp}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>
                            Please fill value to avoid deletion
                          </FormHelperText>
                        </FormControl>

                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="status">Category</InputLabel>
                          <Select
                            className={classes.textField}
                            labelId="status"
                            value={data.category}
                            disabled={
                              bookingData.fup.length ==
                              bookingData.fup.indexOf(data) + 1
                                ? 0
                                : 1
                            }
                            onChange={(e) =>
                              setbookingData({
                                ...bookingData,
                                fup: [
                                  ...bookingData.fup.slice(
                                    0,
                                    bookingData.fup.length - 1,
                                  ),
                                  {
                                    ...bookingData.fup[
                                      bookingData.fup.length - 1
                                    ],
                                    category: e.target.value,
                                  },
                                ],
                              })
                            }
                          >
                            <MenuItem value={"Payment Collection"}>
                              Payment Collection
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Booking inventory"}>
                              Booking inventory
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Providing information"}>
                              Providing information
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Change request"}>
                              Change request
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Visa processing"}>
                              Visa processing
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Booking additional items"}>
                              Booking additional items
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Voucher match/explanation"}>
                              Voucher match/explanation
                            </MenuItem>
                            //{" "}
                            <MenuItem value={"Driver details"}>
                              Driver details
                            </MenuItem>
                            // <MenuItem value={"Others"}>Others</MenuItem>
                          </Select>
                          <FormHelperText>
                            Please fill value to avoid deletion
                          </FormHelperText>
                        </FormControl>
                      </FormGroup>
                      <TextField
                        variant="standard"
                        disabled={
                          bookingData.fup.length ==
                          bookingData.fup.indexOf(data) + 1
                            ? 0
                            : 1
                        }
                        fullWidth
                        required
                        value={data.note}
                        className={classes.textArea}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) =>
                          setbookingData({
                            ...bookingData,
                            fup: [
                              ...bookingData.fup.slice(
                                0,
                                bookingData.fup.length - 1,
                              ),
                              {
                                ...bookingData.fup[bookingData.fup.length - 1],
                                note: e.target.value,
                              },
                            ],
                          })
                        }
                      />
                      <br></br>
                    </div>
                  )}
                </div>
              );
            })}
          <br></br>
          <br></br>
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Operations-Support
          </Typography>
          <br></br>

          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Voucher
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpen16(true)}
              className={classes.button}
            >
              Voucher Match
            </Button>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="vm">Voucher Matched?</InputLabel>
              <Select
                disabled
                classname={classes.textField}
                // required={
                //   tripData.trip_status == "Converted" ||
                //   tripData.trip_status == "Closed"
                //     ? 1
                //     : 0
                // }
                labelId="vm"
                value={bookingData ? bookingData.voucher_matched : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    voucher_matched: e.target.value,
                    voucher_matched_date:
                      e.target.value == "Yes" ? new Date() : null,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <br></br>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="inv">Invoice Name & PAN Matched?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="vm"
                value={bookingData ? bookingData.invoice_name_matched : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    invoice_name_matched: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="state">Customer state matched?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="state"
                value={bookingData ? bookingData.cust_state_matched : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    cust_state_matched: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="ve">Voucher Explained?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                labelId="ve"
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                value={bookingData ? bookingData.voucher_explained : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    voucher_explained: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="pm">Preventive Messages?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                labelId="pm"
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                value={bookingData ? bookingData.preventive_messages : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    preventive_messages: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="standard"
              label="VM Date"
              type="date"
              disabled
              value={
                "booking" in tripData &&
                "voucher_matched_date" in tripData.booking &&
                tripData.booking.voucher_matched_date
                  ? tripData.booking.voucher_matched_date.split("T").slice(0, 1)
                  : ""
              }
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
            />
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Docs & Groups
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              onClick={refreshconvquote}
              className={classes.button}
            >
              Refresh Conv Quote
            </Button>
            {role == "Admin" ||
            role == "Operations" ||
            role == "Product" ||
            role == "Operations-TL" ||
            role == "TL" ||
            role == "Accounts" ||
            role == "Support" ||
            role == "Sales" ? (
              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={opendocmgmt}
                  className={classes.button}
                >
                  Document Management
                </Button>
              </div>
            ) : (
              ""
            )}
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="wagroup">WA Group Created?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="wagroup"
                value={bookingData ? bookingData.wa_group : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, wa_group: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            {/* <TextField
          variant="standard"
          label="Red Flag"
          disabled
          value={tripData.red_flag}
          InputLabelProps={{ shrink: true }}
          className={classes.textField}
        /> */}
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="bc">Briefing Call</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="bc"
                value={
                  bookingData &&
                  "briefing_call" in bookingData &&
                  bookingData.briefing_call
                    ? bookingData.briefing_call
                    : ""
                }
                onChange={(e) => briefingcallchange(e)}
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
                <MenuItem value={"Attempted"}>Attempted</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="bc">Hotel Pitch</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations"
                    ? 0
                    : 1
                }
                labelId="bc"
                value={
                  bookingData &&
                  "hotel_pitch" in bookingData &&
                  bookingData.hotel_pitch
                    ? bookingData.hotel_pitch
                    : ""
                }
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    hotel_pitch: e.target.value,
                  })
                }
              >
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
                <MenuItem value={"Attempted"}>Attempted</MenuItem>
                <MenuItem value={"Upsell Done"}>Upsell Done</MenuItem>
                <MenuItem value={"Non Refundable"}>Non Refundable</MenuItem>
                <MenuItem value={"Red Flag Guest"}>Red Flag Guest</MenuItem>
                <MenuItem value={"Interested"}>Interested</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              href={"/taskdataentry"}
            >
              Create Task
            </Button>
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext2}
          >
            Customer Docs
          </Typography>
          <Divider></Divider>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 300,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="passport">
                Passport for all pax (Front& Back)?
              </InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="passport"
                value={bookingData ? bookingData.passport : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, passport: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 300,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="passportcheck">Passport checked?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="passportcheck"
                value={bookingData ? bookingData.passport_checked : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    passport_checked: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 180,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="pan">PAN card?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="pan"
                value={bookingData ? bookingData.pan : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, pan: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 180,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="aadhaar">Aadhaar/Voter?</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="aadhaar"
                value={bookingData ? bookingData.aadhaar : ""}
                onChange={(e) =>
                  setbookingData({ ...bookingData, aadhaar: e.target.value })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 180,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="rt">Return Tickets</InputLabel>
              <Select
                classname={classes.textField}
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                disabled={
                  role == "Admin" ||
                  role == "Operations-TL" ||
                  role == "Product" ||
                  role == "Operations" ||
                  role == "Support"
                    ? 0
                    : 1
                }
                labelId="rt"
                value={bookingData ? bookingData.return_tickets : ""}
                onChange={(e) =>
                  setbookingData({
                    ...bookingData,
                    return_tickets: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"NA"}>NA</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <br></br>
          <Divider></Divider>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={Open10} onClose={handleClose11}>
          <h2>Techniques to be used for Closing</h2>
          <FormGroup row className={classes.formgroup}>
            <Button
              onClick={() => setObj1(true)}
              variant="contained"
              color="secondary"
              className={classes.smallbutton2}
            >
              Price
            </Button>
            <Button
              onClick={() => setObj2(true)}
              variant="contained"
              color="secondary"
              className={classes.smallbutton2}
            >
              Permission
            </Button>
            <Button
              onClick={() => setObj3(true)}
              variant="contained"
              color="secondary"
              className={classes.smallbutton2}
            >
              Delay
            </Button>
            <Button
              onClick={() => setObj4(true)}
              variant="contained"
              color="secondary"
              className={classes.smallbutton2}
            >
              Trust
            </Button>
            <Button
              onClick={() => setObj5(true)}
              variant="contained"
              color="secondary"
              className={classes.smallbutton2}
            >
              Discount
            </Button>
          </FormGroup>
          {Obj1 ? (
            <div>
              <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Price</h3>
              <ol>
                <li>If customer does not have enough budget</li>
                <ol>
                  <li>
                    Verify if budget is the real issue - ask if you get the
                    quote in your budget will you book today?
                  </li>
                  <li>
                    Customize the package- change hotel, flight, dates, duration
                    to bring within budget
                  </li>
                  <li>If not possible, suggest different destination</li>
                  <li>
                    Pitch EMI options - no cost EMI or long tenure travel loan
                  </li>
                </ol>
                <br></br>
                <li>If customer feels our quote is costly</li>
                <ol>
                  <li>
                    Verify if budget is the real issue - ask if you get the
                    quote at the price you are asking will you book today?
                  </li>
                  <li>
                    If client got a competing quote, ask for the competing quote
                    and beat the price. If you are unable take Product team's
                    help. If not possible, share the best you can do
                  </li>
                  <li>
                    If client does not have a competing quote, justify your
                    price. Use team size, reviews, WA group, fast response as
                    pitching points
                  </li>
                  <li>
                    If client does not agree- customize the package- change
                    hotel, flight, dates, duration to reduce cost
                  </li>
                </ol>
                <br></br>
                <li>How to reduce flight cost?</li>
                <ol>
                  <li>Change dates 1 or 2 or 3 days up and down</li>
                  <li>Check flight rates up and down separately</li>
                  <li>Give intermediate stops to reduce flight rates</li>
                  <li>Change in and out cities and check flight rates</li>
                  <li>Check up and down flights from nearby airports</li>
                  <li>Check if baggage can be reduced</li>
                  <li>Alternate Airports:</li>
                  <ul>
                    <li>DEL:</li>
                    <li>BOM:</li>
                    <li>BLR:MAA, COK, HYD</li>
                    <li>MAA: BLR, HYD, COK</li>
                    <li>HYD: BLR, MAA</li>
                    <li>CCU:</li>
                    <li>AMD: DEL, BOM</li>
                  </ul>
                </ol>
                <br></br>
                <li>How to reduce hotel cost?</li>
                <ol>
                  <li>Check if there is any event that makes things costly</li>
                  <li>
                    Check hotels in Rezlive and TBO. Ensure it is within service
                    area
                  </li>
                  <li>
                    Do not go by star rating. Check lower star rating but good
                    quality property
                  </li>
                  <li>Check why client is preferring a certain hotel</li>
                  <li>Pitch USP of your preferred hotel</li>
                  <li>Change room allocation</li>
                </ol>
                <br></br>
                <li>How to reduce land cost?</li>
                <ol>
                  <li>Reduce costly items or provide alternate options</li>
                  <li>Reduce activities not preferred by guest</li>
                </ol>
                <br></br>
                <li>If nothing works, ask to change destination</li>
              </ol>
            </div>
          ) : (
            ""
          )}

          {Obj2 ? (
            <div>
              <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Permission</h3>
              <ol>
                <li>Acknowledge the objection</li>
                <li>
                  Ask to contact the decision maker- ask number, create WA group
                </li>
                <li>
                  If not possible, convince the caller- Ask if you have any
                  problems with the package? If the decision maker approves, can
                  you go ahead with booking?
                </li>
                <li>
                  If caller is convinced only then he/she will fight for your
                  package
                </li>
                <li>
                  Ask what could be the possible objection by decision maker?
                  Clarify those objections in advance
                </li>
              </ol>
            </div>
          ) : (
            ""
          )}

          {Obj3 ? (
            <div>
              <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delay</h3>
              <ol>
                <li>Ask for the reason of delay</li>
                <li>Create fear of loss - pirce increase, hotel sold out</li>
                <li>
                  Push for closure- what needs to be done for you to book today?
                </li>
                <li>
                  If customer is hesitating, show him benefits of booking -
                  lower costs, peace of mind, guaranteed vacation etc.
                </li>
              </ol>
            </div>
          ) : (
            ""
          )}

          {Obj4 ? (
            <div>
              <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trust</h3>
              <ol>
                <li>Acknowledge that trusting can be difficult</li>
                <li>Show proof of genuineness- GST, CoI, MSME</li>
                <li>Show online presence- Google reviews, Insta profile</li>
                <li>Do a video call and show office</li>
                <li>Share number of old customers for reference</li>
              </ol>
            </div>
          ) : (
            ""
          )}

          {Obj5 ? (
            <div>
              <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Discount & Closure</h3>
              <ol>
                <li>Statements to tackle discount requests:</li>
                <ol>
                  <li>
                    Always give discounts with coupons and time restrictions
                  </li>
                  <li>Ask customers to post reels in return of discount</li>
                </ol>
                <br></br>
                <br></br>
                <li>Statements to induce closure:</li>
                <ol>
                  <li>
                    We have held your flight till ||time|| otherwise prices will
                    increase
                  </li>
                  <li>We can process your hotel booking tonight</li>
                  <li>
                    I can complete my target and in return I am giving you this
                    discount
                  </li>
                </ol>
              </ol>
            </div>
          ) : (
            ""
          )}

          <Button
            onClick={closeobjections}
            variant="contained"
            color="primary"
            className={classes.smallbutton2}
          >
            Back
          </Button>
          <br></br>
          <br></br>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={Open12} onClose={closescan}>
          <h3>Possible PAN matches:{panstring}</h3>
          <br></br>
          <br></br>
          <h3>Possible Passport number matches:{passportstring}</h3>
          <br></br>
          <br></br>
          <h2>Scanned Words</h2>
          {scannedwords ? scannedwords : ""}
          <br></br>
          <br></br>
          <Button
            onClick={closescan}
            variant="contained"
            color="primary"
            className={classes.smallbutton2}
          >
            Back
          </Button>
          <br></br>
          <br></br>
        </Dialog>

        <Dialog maxWidth="m" open={showsh} onClose={() => setshowsh(false)}>
          <Table border="1">
            <TableHead>
              <TableCell>Status</TableCell>
              <TableCell>Date</TableCell>
            </TableHead>
            {"status_history" in tripData &&
              tripData.status_history.map((data) => (
                <div>
                  <TableRow>
                    <TableCell>{data.new_status}</TableCell>
                    <TableCell>{data.date}</TableCell>
                  </TableRow>
                </div>
              ))}
          </Table>
        </Dialog>

        <Dialog maxWidth="m" open={Open20} onClose={() => setOpen20(false)}>
          {AIdata ? (
            AIdata == "loading" ? (
              <Loading message={`Loading data...`} />
            ) : (
              JSON.stringify(AIdata)
            )
          ) : (
            ""
          )}
          <br></br>
          <br></br>
          <div align="center">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => saveextracteddata()}
              className={classes.smallbutton2}
            >
              Update
            </Button>
          </div>
          <br></br>
          <br></br>
          <hr></hr>
          <br></br>
          <br></br>
          <Table>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Expiry Date</TableCell>
              <TableCell>Birth Date</TableCell>
            </TableRow>
            {tripData &&
              "passport_details" in tripData &&
              tripData.passport_details.length > 0 &&
              tripData.passport_details.map((p) => (
                <TableRow>
                  <TableCell>{p.passport_holder_name}</TableCell>
                  <TableCell>
                    {"date_of_expiry" in p && p.date_of_expiry
                      ? p.date_of_expiry.toLocaleString()
                      : ""}
                  </TableCell>
                  <TableCell>
                    {"date_of_birth" in p && p.date_of_birth
                      ? p.date_of_birth.toLocaleString()
                      : ""}
                  </TableCell>
                </TableRow>
              ))}
          </Table>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={docmgmt} onClose={handleClose9}>
          <h3 className={classes.headtext}>
            PAN mentioned (as mentioned in webiste): {tripData.pan}
          </h3>
          <h3 className={classes.headtext}>
            Name of which invoice should be made (as mentioned in webiste):{" "}
            {tripData.invoice_name}
          </h3>
          <BlinkingText>Check if PAN and Invoice name matches</BlinkingText>
          <h4 className={classes.headtext}>Upload File:</h4>
          <h3>Select document type first and then upload</h3>
          <input
            type="file"
            name="myFile"
            onChange={(e) => handleFileInput(e)}
          />
          <br></br>
          <input
            multiple
            type="file"
            name="myFile"
            onChange={(e) => handleFileInput2(e)}
          />
          <FormControl
            style={{
              minWidth: 450,
              marginTop: 16,
              marginRight: 24,
              marginLeft: 5,
            }}
          >
            <InputLabel id="file type">File Type</InputLabel>
            <Select
              className={classes.textField}
              labelId="File Type"
              //required

              value={filecategory ? filecategory : ""}
              onChange={(e) => setfilecategory(e.target.value)}
            >
              <MenuItem value={"Passport"}>Passport</MenuItem>
              <MenuItem value={"PAN"}>PAN</MenuItem>
              <MenuItem value={"Hotel Voucher"}>Hotel Voucher</MenuItem>
              <MenuItem value={"Flight Ticket"}>Flight Ticket</MenuItem>
              <MenuItem value={"Land Voucher"}>Land Voucher</MenuItem>
              <MenuItem value={"Hotel & Land Voucher"}>
                Hotel & Land Voucher
              </MenuItem>
              <MenuItem value={"Visa"}>Visa</MenuItem>
              <MenuItem value={"Aadhaar"}>Aadhaar</MenuItem>
              <MenuItem value={"TCS"}>TCS</MenuItem>
              <MenuItem value={"Other Items"}>Other Items</MenuItem>
            </Select>
          </FormControl>
          {role == "Operations" ||
          role == "Product" ||
          role == "Operations-TL" ||
          role == "Support" ||
          role == "Admin" ||
          role == "TL" ||
          role =="Manager" ||
          role == "Sales" ||
          role == "SME" ? (
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={uploadfile}
                className={classes.button}
              >
                Upload
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={uploadmultifile}
                className={classes.button}
              >
                Multi-Upload
              </Button>
            </div>
          ) : (
            ""
          )}
          <h2 className={classes.headtext}>
            <b>Do not forget to save trip after making changes</b>
          </h2>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            className={classes.button}
          >
            Save
          </Button>
          <Table>
            <TableHead>
              <TableCell>Type of Document</TableCell>
              <TableCell>Document</TableCell>
              <TableCell>Show to customer</TableCell>
              <TableCell>Action Item</TableCell>
              <TableCell>Analyze</TableCell>
            </TableHead>
            {finalfiledetails.map((f) => {
              return (
                <TableRow>
                  <TableCell>
                    <h4 className={classes.headtext}>{f.type_of_doc}</h4>
                  </TableCell>
                  <TableCell>
                    <a href={f.location} target="_blank">
                      <h4 className={classes.headtext}>{f.name}</h4>
                    </a>
                  </TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={<Checkbox color="primary" />}
                      value={"show_file" in f ? f.show_file : true}
                      checked={"show_file" in f ? f.show_file : true}
                      onChange={(e) =>
                        setfinalfiledetails(
                          finalfiledetails.map((ff) =>
                            finalfiledetails.indexOf(ff) ==
                            finalfiledetails.indexOf(f)
                              ? { ...ff, show_file: e.target.checked }
                              : ff,
                          ),
                        )
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => deletefile2(f.name)}
                      className={classes.smallbutton2}
                    >
                      Delete
                    </Button>
                  </TableCell>
                  <TableCell>
                    {f.type_of_doc == "Passport" || f.type_of_doc == "PAN" ? (
                      <div>
                        {/* <Button
            variant="contained"
            color="secondary"
            onClick={()=>scandocs(f)}
            className={classes.smallbutton2}
          >
            Scan
          </Button> */}
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => extractviaai(f)}
                          className={classes.smallbutton2}
                        >
                          Extract
                        </Button>
                      </div>
                    ) : (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => extractviaai(f)}
                        className={classes.smallbutton2}
                      >
                        Extract
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </Table>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth="xl"
          open={Open7}
          //onClose={handleClose7}
        >
          <h2 className={classes.headtext}>Make Progress on planning:</h2>
          <h4 className={classes.bodytext}>Did they see the quote?</h4>
          <h4 className={classes.bodytext}>Do they want any changes?</h4>
          <h4 className={classes.bodytext}>
            If customer is asking for more hotel options or flight options,
            clarify what exactly are they looking for? What is the problem with
            the hotels you have provided?
          </h4>
          <br></br>
          <h2 className={classes.headtext}>Asking time:</h2>
          <h4 className={classes.bodytext}>
            Why the delay? Are they waiting for someone or something else?
          </h4>
          <br></br>
          <h2 className={classes.headtext}>Explain quote:</h2>
          <h4 className={classes.bodytext}>
            Why the quote is suitable for them?
          </h4>
          <h4 className={classes.bodytext}>
            Do not talk about prices or negaotiate pn prices before the quote is
            finalized
          </h4>
          <br></br>
          <h2 className={classes.headtext}>Guide next steps:</h2>
          <h4 className={classes.bodytext}>
            Ask them to call or msg for any queries
          </h4>
          <br></br>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose7}
            className={classes.button}
          >
            Process Followed
          </Button>
        </Dialog>

        {/* <Dialog
 
        maxWidth="xl"
        open={Open8}
        //onClose={handleClose8}
      >
      <h2 className={classes.headtext}>I swear on my family, God and my TL that I have:     </h2>
      <h4 className={classes.headtext}> 1.Not made any false commitment to the client</h4>
      <h4 className={classes.headtext}> 2. Not made any verbal commitment (that is not mentioned in writing in the quote)</h4>
      <h4 className={classes.headtext}> 3. Updated the final quote to match exactly with what I have committed</h4>

      

      <Button
            variant="contained"
            color="primary"
            // type="submit"
            onClick={handleClose8}
            className={classes.button}
          >
          I swear
          </Button>
          <h2 className={classes.headtext}>If not, please update the final quote</h2>
      </Dialog> */}

        <Dialog fullWidth maxWidth="xl" open={Open6} onClose={handleClose6}>
          <Table>
            <TableRow>
              <TableCell>Trip Id</TableCell>
              <TableCell>Agent</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Recording</TableCell>
              <TableCell>Cause</TableCell>
              <TableCell>Call Id</TableCell>
              <TableCell>Quality</TableCell>
              {/* <TableCell>Insight</TableCell> */}
            </TableRow>
            {removeDuplicatesmulti2(
              callrecorddata,
              "answered_agent_name",
              "duration",
              "start_stamp",
            ).map((cr) => (
              <TableRow>
                <TableCell>{cr.trip_id}</TableCell>
                <TableCell>{cr.answered_agent_name}</TableCell>
                <TableCell>{cr.start_stamp}</TableCell>
                <TableCell>{cr.call_status}</TableCell>
                <TableCell>
                  {cr.call_status == "answered" ? cr.outbound_sec : cr.duration}
                </TableCell>
                <TableCell>
                  <audio src={cr.recording_url} controls>
                    Your browser does not support the audio element.
                  </audio>
                </TableCell>
                <TableCell>{cr.hangup_cause}</TableCell>
                <TableCell>{cr.call_id}</TableCell>
                <TableCell>
                  {cr.call_status == "answered" ? (
                    <Button
                      onClick={() => qualityopen(cr)}
                      variant="contained"
                      target="_blank"
                      color="primary"
                      className={classes.smallbutton2}
                    >
                      Quality
                    </Button>
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell>
                  {role == "Admin" || role == "Manager" ? (
                    <div>
                      {/* <Button
              onClick={()=>getInsight(callrecorddata.indexOf(cr))}
            variant="contained"
            target="_blank"
            color="primary"
            className={classes.smallbutton2}
          >
            Go
          </Button> */}
                      <Button
                        onClick={() => getClaudeInsight(cr)}
                        variant="contained"
                        target="_blank"
                        color="secondary"
                        className={classes.smallbutton2}
                      >
                        AI Insight
                      </Button>
                      {"summary" in cr
                        ? {
                            /* <Button
              onClick={()=>showInsight(callrecorddata.indexOf(cr))}
            variant="contained"
            target="_blank"
            color="primary"
            className={classes.smallbutton2}
          >
            Insight
          </Button> */
                          }
                        : ""}
                    </div>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </Dialog>

        <Dialog fullWidth maxWidth="xl" open={Open5} onClose={handleClose5}>
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            Results
          </Typography>
          {frData ? (
            <div>
              <br></br>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                Cheapest
              </Typography>

              {frData.itineraries.buckets ? (
                <table border="0" width="700" align="center">
                  {frData?.itineraries?.buckets[2]?.items.map((item) => (
                    <div>
                      <tr>
                        <td>
                          <b>Price:</b>
                          {item.price.raw} (Total)
                        </td>
                      </tr>
                      <br></br>
                      {item.legs.map((leg) => (
                        <div>
                          {leg.segments.map((segment) => (
                            <div>
                              <table border="0" width="700">
                                <tr>
                                  <td>
                                    <b>From:</b>
                                    {segment.origin.name}(
                                    {segment.origin.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>To:</b>
                                    {segment.destination.name}(
                                    {segment.destination.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>Airline:</b>
                                    {segment.marketingCarrier.name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Duration: </b>
                                    {(segment.durationInMinutes / 60).toFixed(
                                      0,
                                    )}{" "}
                                    hrs {segment.durationInMinutes % 60} mins
                                  </td>
                                </tr>
                                <br></br>
                              </table>
                            </div>
                          ))}
                        </div>
                      ))}
                      <hr></hr>
                    </div>
                  ))}
                </table>
              ) : (
                ""
              )}

              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                Fastest
              </Typography>
              {frData.itineraries.buckets ? (
                <table border="0" width="700" align="center">
                  {frData?.itineraries?.buckets[1]?.items.map((item) => (
                    <div>
                      <tr>
                        <td>
                          <b>Price:</b>
                          {item.price.raw} (Total)
                        </td>
                      </tr>
                      <br></br>
                      {item.legs.map((leg) => (
                        <div>
                          {leg.segments.map((segment) => (
                            <div>
                              <table border="0" width="700">
                                <tr>
                                  <td>
                                    <b>From:</b>
                                    {segment.origin.name}(
                                    {segment.origin.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>To:</b>
                                    {segment.destination.name}(
                                    {segment.destination.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>Airline:</b>
                                    {segment.marketingCarrier.name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Duration: </b>
                                    {(segment.durationInMinutes / 60).toFixed(
                                      0,
                                    )}{" "}
                                    hrs {segment.durationInMinutes % 60} mins
                                  </td>
                                </tr>
                                <br></br>
                              </table>
                            </div>
                          ))}
                        </div>
                      ))}
                      <hr></hr>
                    </div>
                  ))}
                </table>
              ) : (
                ""
              )}
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                Direct
              </Typography>
              {frData.itineraries.buckets ? (
                <table border="0" width="700" align="center">
                  {frData?.itineraries?.buckets[3]?.items.map((item) => (
                    <div>
                      <tr>
                        <td>
                          <b>Price:</b>
                          {item.price.raw} (Total)
                        </td>
                      </tr>
                      <br></br>
                      {item.legs.map((leg) => (
                        <div>
                          {leg.segments.map((segment) => (
                            <div>
                              <table border="0" width="700">
                                <tr>
                                  <td>
                                    <b>From:</b>
                                    {segment.origin.name}(
                                    {segment.origin.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>To:</b>
                                    {segment.destination.name}(
                                    {segment.destination.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>Airline:</b>
                                    {segment.marketingCarrier.name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Duration: </b>
                                    {(segment.durationInMinutes / 60).toFixed(
                                      0,
                                    )}{" "}
                                    hrs {segment.durationInMinutes % 60} mins
                                  </td>
                                </tr>
                                <br></br>
                              </table>
                            </div>
                          ))}
                        </div>
                      ))}
                      <hr></hr>
                    </div>
                  ))}
                </table>
              ) : (
                ""
              )}
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                Best
              </Typography>
              {frData.itineraries.buckets ? (
                <table border="0" width="700" align="center">
                  {frData?.itineraries?.buckets[0]?.items.map((item) => (
                    <div>
                      <tr>
                        <td>
                          <b>Price:</b>
                          {item.price.raw} (Total)
                        </td>
                      </tr>
                      <br></br>
                      {item.legs.map((leg) => (
                        <div>
                          {leg.segments.map((segment) => (
                            <div>
                              <table border="0" width="700">
                                <tr>
                                  <td>
                                    <b>From:</b>
                                    {segment.origin.name}(
                                    {segment.origin.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>To:</b>
                                    {segment.destination.name}(
                                    {segment.destination.flightPlaceId})
                                  </td>
                                  <td>
                                    <b>Airline:</b>
                                    {segment.marketingCarrier.name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.departure)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Departure:</b>
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(0, 1)}{" "}
                                    at{" "}
                                    {String(segment.arrival)
                                      .split("T")
                                      .slice(1, 2)}
                                  </td>
                                  <td>
                                    <b>Duration: </b>
                                    {(segment.durationInMinutes / 60).toFixed(
                                      0,
                                    )}{" "}
                                    hrs {segment.durationInMinutes % 60} mins
                                  </td>
                                </tr>
                                <br></br>
                              </table>
                            </div>
                          ))}
                        </div>
                      ))}
                      <hr></hr>
                    </div>
                  ))}
                </table>
              ) : (
                ""
              )}
            </div>
          ) : (
            "Loading..."
          )}
        </Dialog>

        <Dialog fullWidth maxWidth="sm" open={Open4} onClose={handleClose4}>
          <a
            href="https://docs.google.com/spreadsheets/d/19Wf3-D1hW-SILdEip0F6Gf9ypBlBIUxWQX2xFwYX1J8"
            rel="noopener noreferrer"
            target="_blank"
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Doc Link for Airport codes
          </a>
          <TextField
            variant="standard"
            label="Source Apt Code (Code only)"
            value={fsData.source}
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) => setfsData({ ...fsData, source: e.target.value })}
          />
          <TextField
            variant="standard"
            label="Dest Apt Code (Code only)"
            value={fsData.dest}
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) => setfsData({ ...fsData, dest: e.target.value })}
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="type">Type</InputLabel>
            <Select
              className={classes.textField}
              labelId="type"
              value={fsData.type}
              onChange={(e) => setfsData({ ...fsData, type: e.target.value })}
            >
              <MenuItem value={"One-way"}>One-way</MenuItem>
              <MenuItem value={"Return"}>Return</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="direct">Direct</InputLabel>
            <Select
              className={classes.textField}
              labelId="direct"
              value={fsData.direct}
              onChange={(e) => setfsData({ ...fsData, direct: e.target.value })}
            >
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Adults">
              # Adults (number-between 1 and 9)
            </InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Adults"
              value={fsData.number_adults}
              onChange={(e) =>
                setfsData({ ...fsData, number_adults: e.target.value })
              }
            >
              <MenuItem value={1}>1 </MenuItem>
              <MenuItem value={2}>2 </MenuItem>
              <MenuItem value={3}>3 </MenuItem>
              <MenuItem value={4}>4 </MenuItem>
              <MenuItem value={5}>5 </MenuItem>
              <MenuItem value={6}>6 </MenuItem>
              <MenuItem value={7}>7 </MenuItem>
              <MenuItem value={8}>8 </MenuItem>
              <MenuItem value={9}>9 </MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Child"># Child/Infant (number)</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Child"
              value={fsData.number_child}
              onChange={(e) =>
                setfsData({ ...fsData, number_child: e.target.value })
              }
            >
              <MenuItem value={0}>0 </MenuItem>
              <MenuItem value={1}>1 </MenuItem>
              <MenuItem value={2}>2 </MenuItem>
              <MenuItem value={3}>3 </MenuItem>
              <MenuItem value={4}>4 </MenuItem>
              <MenuItem value={5}>5 </MenuItem>
              <MenuItem value={6}>6 </MenuItem>
              <MenuItem value={7}>7 </MenuItem>
              <MenuItem value={8}>8 </MenuItem>
              <MenuItem value={9}>9 </MenuItem>
            </Select>
          </FormControl>

          <TextField
            variant="outlined"
            type="date"
            label="Date of travel"
            value={fsData.dot}
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) => setfsData({ ...fsData, dot: e.target.value })}
          />
          <TextField
            variant="outlined"
            type="date"
            label="Date of return"
            value={fsData.dor}
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) => setfsData({ ...fsData, dor: e.target.value })}
          />
          <FormGroup row className={classes.formgroup}>
            <Button
              onClick={() => flightsearchtj(fsData)}
              variant="outlined"
              color="primary"
              className={classes.button}
            >
              TripJack Search
            </Button>
            <Button
              onClick={() => flightsearchtc(fsData)}
              variant="outlined"
              color="primary"
              className={classes.button}
            >
              Travclan Search
            </Button>
            {/* <Button
            onClick={() => flightsearchapi(fsData)}
            variant="outlined"
            color="primary"
            className={classes.button}
          >
            API Search
          </Button> */}
          </FormGroup>
        </Dialog>

        <Dialog fullWidth maxWidth="lg" open={Open2} onClose={handleClose2}>
          <a
            href="https://docs.google.com/spreadsheets/d/1D7huwcWGlh0prUBXL4KVYlxd5wpo3IKvQvuq7F__mVg/edit#gid=0"
            rel="noopener noreferrer"
            target="_blank"
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Doc Link for detailed messages
          </a>
          <div align="center">{nextaction}</div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 420 }} align="center">
                    Message Name - Message Category{" "}
                    <Button
                      onClick={custom}
                      variant="outlined"
                      color="secondary"
                      className={classes.smallbutton2}
                    >
                      Custom
                    </Button>
                    <Button
                      onClick={() => alert(tripData.wa_sequence.join(", "))}
                      variant="outlined"
                      color="secondary"
                      className={classes.smallbutton2}
                    >
                      Show WA Sequence
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ width: 420 }} align="center">
                    <Typography>
                      Next fup on {followupData2Ref.current?.date} at{" "}
                      {followupData2Ref.current?.time}
                      <Button
                        onClick={handleSubmit2}
                        variant="contained"
                        color="primary"
                        className={classes.smallbutton2}
                      >
                        Save
                      </Button>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {walist?.map((wa) => {
                  return (
                    <div>
                      {userdetails &&
                      userdetails.permissions.manual_cancellation ? (
                        <div>
                          {wa.wa_id == 57 ||
                          wa.wa_id == 58 ||
                          wa.wa_id == 130 ||
                          wa.wa_id == 131 ? (
                            ""
                          ) : (
                            <div>
                              <TableRow key={wa.wa_id} align="center">
                                <Typography
                                  variant="h5"
                                  align="center"
                                  className={classes.headertext}
                                >
                                  {" "}
                                  {wa.group_name ? wa.group_name : ""}
                                </Typography>
                              </TableRow>
                              <TableRow key={wa.wa_id} align="center">
                                <TableCell
                                  style={{ width: 420, height: 10 }}
                                  align="center"
                                >
                                  {wa.wa_name} - {wa.wa_category}{" "}
                                </TableCell>
                                {/* // <TableCell>
                        {wa.wa_id > 35 && wa.wa_id < 40 ? ( */}

                                {/* <Button
                              onClick={() => whatsapp(wa.wa_name)}
                              variant="outlined"
                              color="primary"
                              className={classes.smallbutton2}
                            >
                              Send
                            </Button>
                            </TableCell> */}
                                <TableCell
                                  style={{ width: 220 }}
                                  align="center"
                                >
                                  <Button
                                    onClick={(e) =>
                                      whatsappupdate5(wa.wa_name, e)
                                    }
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.button2}
                                  >
                                    Send
                                  </Button>
                                </TableCell>
                                {/* <TableCell>
                            <Button
                    onClick={handleSubmit2}
                    variant="contained"
                    color="primary"
                    className={classes.smallbutton2}
                  >
                    Save
                  </Button>
                  </TableCell> */}
                              </TableRow>
                              <TableRow key={wa.wa_id} align="center">
                                {/* <TableCell style={{ width: 220 }} align="center">
                    
                            <Button
                              onClick={(e) => whatsappupdate5(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button2}
                            >
                              Send
                              </Button>
                            </TableCell> */}
                                {/* {tripData.trip_status=="Hot" || ("lead" in tripData && "potential" in tripData.lead && tripData.lead.potential==true)?(<div>
                    <TableCell style={{ width: 220 }} align="center">
                    
                            <Button
                              onClick={(e) => whatsappupdate1(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button2}
                            >
                              Send - 5:30pm
                            </Button>
                            </TableCell>
                            <TableCell style={{ width: 220 }} align="center">
                            <Button
                              onClick={(e) => whatsappupdate2(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button2}
                            >
                              Send - 2:00pm
                            </Button>
                            </TableCell>
                       
                        
                        <TableCell style={{ width: 220 }} align="center">
                        <Button
                              onClick={(e) => whatsappupdate3(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button3}
                            >
                              Send - D+1 12:30pm
                            </Button>
                            </TableCell>
                            <TableCell style={{ width: 220 }} align="center">
                            <Button
                              onClick={(e) => whatsappupdate4(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button3}
                            >
                              Send - D+2 12:30pm
                            </Button>
                       
                      </TableCell>
                      </div>
                      
                      ):(<div>
                          {(new Date(tripData.follow_up[tripData.follow_up.length-1].date).getTime()<=new Date().getTime() && tripData.follow_up[tripData.follow_up.length-1].time=="12:30") || (new Date(tripData.follow_up[tripData.follow_up.length-1].date).getTime()<new Date().getTime() && tripData.follow_up[tripData.follow_up.length-1].time=="12:00")?(""):(<div>
                        <TableCell style={{ width: 220 }} align="center">
                        <Button
                              onClick={(e) => whatsappupdate3(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button3}
                            >
                              Send - D+1 12:30pm
                            </Button>
                            </TableCell>
                            <TableCell style={{ width: 220 }} align="center">
                            <Button
                              onClick={(e) => whatsappupdate4(wa.wa_name, e)}
                              variant="outlined"
                              color="secondary"
                              className={classes.button3}
                            >
                              Send - D+2 12:30pm
                            </Button>
                  
                      </TableCell>
                      </div>)}
                        </div>)} */}
                              </TableRow>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          {wa.wa_id == 155 || wa.wa_id == 156 ? (
                            ""
                          ) : (
                            <div>
                              <TableRow key={wa.wa_id} align="center">
                                <Typography
                                  variant="h5"
                                  align="center"
                                  className={classes.headertext}
                                >
                                  {" "}
                                  {wa.group_name ? wa.group_name : ""}
                                </Typography>
                              </TableRow>
                              <TableRow key={wa.wa_id} align="center">
                                <TableCell
                                  style={{ width: 420, height: 10 }}
                                  align="center"
                                >
                                  {wa.wa_name} - {wa.wa_category}{" "}
                                </TableCell>

                                <TableCell
                                  style={{ width: 220 }}
                                  align="center"
                                >
                                  <Button
                                    onClick={(e) =>
                                      whatsappupdate5(wa.wa_name, e)
                                    }
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.button2}
                                  >
                                    Send
                                  </Button>
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={wa.wa_id}
                                align="center"
                              ></TableRow>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>

        <Dialog fullWidth maxWidth="lg" open={Open2b} onClose={handleClose2b}>
          <a
            href="https://docs.google.com/spreadsheets/d/1D7huwcWGlh0prUBXL4KVYlxd5wpo3IKvQvuq7F__mVg/edit#gid=0"
            rel="noopener noreferrer"
            target="_blank"
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Doc Link for detailed messages
          </a>
          <div align="center">{nextaction}</div>
          <TableContainer>
            <Table>
              <TableBody>
                {walist2b?.map((wa) => {
                  return (
                    <div>
                      {wa.wa_id == 57 ||
                      wa.wa_id == 58 ||
                      wa.wa_id == 130 ||
                      wa.wa_id == 131 ? (
                        ""
                      ) : (
                        <div>
                          <TableRow key={wa.wa_id} align="center">
                            <Typography
                              variant="h5"
                              align="center"
                              className={classes.headertext}
                            >
                              {" "}
                              {wa.group_name ? wa.group_name : ""}
                            </Typography>
                          </TableRow>
                          <TableRow key={wa.wa_id} align="center">
                            <TableCell
                              style={{ width: 420, height: 10 }}
                              align="center"
                            >
                              {wa.wa_name} - {wa.wa_category}{" "}
                            </TableCell>
                            <TableCell>
                              {/* {wa.wa_id > 35 && wa.wa_id < 40 ? ( */}

                              <Button
                                onClick={() => whatsapp(wa.wa_name)}
                                variant="outlined"
                                color="primary"
                                className={classes.smallbutton2}
                              >
                                Send
                              </Button>
                            </TableCell>
                            {/* <TableCell>
                            <Button
                    onClick={handleSubmit2}
                    variant="contained"
                    color="primary"
                    className={classes.smallbutton2}
                  >
                    Save
                  </Button>
                  </TableCell> */}
                          </TableRow>
                          <TableRow key={wa.wa_id} align="center">
                            <TableCell style={{ width: 220 }} align="center">
                              <Button
                                onClick={(e) => whatsappupdate1(wa.wa_name, e)}
                                variant="outlined"
                                color="secondary"
                                className={classes.button2}
                              >
                                Send - 5:30pm
                              </Button>
                            </TableCell>
                            <TableCell style={{ width: 220 }} align="center">
                              <Button
                                onClick={(e) => whatsappupdate2(wa.wa_name, e)}
                                variant="outlined"
                                color="secondary"
                                className={classes.button2}
                              >
                                Send - 2:00pm
                              </Button>
                            </TableCell>
                            {/* ) : ( */}
                            {tripData.trip_status == "Hot" ||
                            ("lead" in tripData &&
                              "potential" in tripData.lead &&
                              tripData.lead.potential == true) ? (
                              <div>
                                <TableCell
                                  style={{ width: 220 }}
                                  align="center"
                                >
                                  <Button
                                    onClick={(e) =>
                                      whatsappupdate3(wa.wa_name, e)
                                    }
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.button3}
                                  >
                                    Send - D+1 12:30pm
                                  </Button>
                                </TableCell>
                                <TableCell
                                  style={{ width: 220 }}
                                  align="center"
                                >
                                  <Button
                                    onClick={(e) =>
                                      whatsappupdate4(wa.wa_name, e)
                                    }
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.button3}
                                  >
                                    Send - D+2 12:30pm
                                  </Button>
                                  {/* )} */}
                                </TableCell>
                              </div>
                            ) : (
                              <div>
                                {(new Date(
                                  tripData.follow_up[
                                    tripData.follow_up.length - 1
                                  ].date,
                                ).getTime() <= new Date().getTime() &&
                                  tripData.follow_up[
                                    tripData.follow_up.length - 1
                                  ].time == "12:30") ||
                                (new Date(
                                  tripData.follow_up[
                                    tripData.follow_up.length - 1
                                  ].date,
                                ).getTime() < new Date().getTime() &&
                                  tripData.follow_up[
                                    tripData.follow_up.length - 1
                                  ].time == "12:00") ? (
                                  ""
                                ) : (
                                  <div>
                                    <TableCell
                                      style={{ width: 220 }}
                                      align="center"
                                    >
                                      <Button
                                        onClick={(e) =>
                                          whatsappupdate3(wa.wa_name, e)
                                        }
                                        variant="outlined"
                                        color="secondary"
                                        className={classes.button3}
                                      >
                                        Send - D+1 12:30pm
                                      </Button>
                                    </TableCell>
                                    <TableCell
                                      style={{ width: 220 }}
                                      align="center"
                                    >
                                      <Button
                                        onClick={(e) =>
                                          whatsappupdate4(wa.wa_name, e)
                                        }
                                        variant="outlined"
                                        color="secondary"
                                        className={classes.button3}
                                      >
                                        Send - D+2 12:30pm
                                      </Button>
                                      {/* )} */}
                                    </TableCell>
                                  </div>
                                )}
                              </div>
                            )}
                          </TableRow>
                        </div>
                      )}
                    </div>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>

        {role == "Product" ||
        role == "Support" ||
        role == "Admin" ||
        role == "Manager" ||
        role == "Accounts" ? (
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Update Trip - Type {tripData.trip_model} - Quality{" "}
            {"lead" in tripData
              ? getquality(
                  tripData.lead.lead_status,
                  tripData.lead.time_to_book,
                  tripData.trip_channel,
                  tripData.trip_start_date,
                  tripData.lead.quality_upgrade,
                  null,
                )
              : getquality(
                  null,
                  null,
                  tripData.trip_channel,
                  tripData.trip_start_date,
                  null,
                  null,
                )}{" "}
            {"lead" in tripData && "potential" in tripData.lead
              ? " - " + "Potential: " + tripData.lead.potential
              : ""}
          </Typography>
        ) : (
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Update Trip - Type {tripData.trip_model} -{" "}
            {"lead" in tripData && "potential" in tripData.lead
              ? " - " + "Potential: " + tripData.lead.potential
              : ""}
          </Typography>
        )}
        {"dup_lead" in tripData && tripData.dup_lead.length > 0 ? (
          <div align="center">
            <Typography variant="h5" className={classes.red}>
              {"Customer placed another lead at: " +
                tripData.dup_lead[tripData.dup_lead.length - 1].placedAt +
                " for " +
                tripData.dup_lead[tripData.dup_lead.length - 1].destination}
              {"reactivate" in tripData && tripData.reactivate
                ? "Trip activated by customer"
                : ""}
            </Typography>
          </div>
        ) : (
          ""
        )}

        {role == "TL" ||
        role == "Support" ||
        role == "Admin" ||
        role == "Manager" ||
        role == "Accounts" ||
        ("trip_owner" in tripData && cuser && cuser == tripData.trip_owner) ? (
          <a href={"/custdataentry/" + tripData.cust_id}>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              {" Customer Name: " +
                tripData.cust_name +
                " (" +
                tripData.cust_id +
                ") " +
                "Ph- " +
                custData.primary_mobile_number}
            </Typography>
          </a>
        ) : (
          <div>
            {Attempted ? (
              <a href={"/custdataentry/" + tripData.cust_id}>
                <Typography
                  variant="h6"
                  align="center"
                  className={classes.headertext}
                >
                  {" Customer Name: " +
                    tripData.cust_name +
                    " (" +
                    tripData.cust_id +
                    ") " +
                    "Ph- " +
                    custData.primary_mobile_number}
                </Typography>
              </a>
            ) : (
              <a href={"/custdataentry/" + tripData.cust_id}>
                <Typography
                  variant="h6"
                  align="center"
                  className={classes.headertext}
                >
                  {" Customer Name: " +
                    tripData.cust_name +
                    " (" +
                    tripData.cust_id +
                    ") "}
                </Typography>
              </a>
            )}
          </div>
        )}

        {"merge_trips" in tripData &&
        tripData.merge_trips.length > 0 &&
        tripData.merge_trips[0] !== tripData.trip_id
          ? "Merge Trip: " + tripData.merge_trips.toString()
          : ""}
        <FormGroup>
          <div align="center">
            {nextaction + " || "}
            {role == "Admin" || role == "TL" || role == "Manager"
              ? tripData.prev_next_action +
                "||" +
                tripData.canc_flag +
                "||" +
                tripData.canc_flag_time
              : ""}
          </div>
          {/* //<Button onClick={nextaction}>Next</Button> */}
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {"Trip Id:" +
              currentid +
              " || Created at: " +
              new Date(tripData.createdAt).toLocaleString("en-IN")}
          </Typography>
          {"reactivate" in tripData && tripData.reactivate ? (
            <div align="center">
              <BlinkingText>
                Trip Reactiavted by customer at {tripData.reactivate_date}
              </BlinkingText>
            </div>
          ) : (
            ""
          )}
          {"credit_note_amount" in custData &&
          custData.credit_note_amount > 0 ? (
            <div align="center">
              <BlinkingText>
                Credit Note active on this customer of value{" "}
                {custData.credit_note_amount}
              </BlinkingText>
            </div>
          ) : (
            ""
          )}
          <div align="center">
            {tripData.quote?.map((quote) => {
              return (
                <a href={"/quotedataentry/" + quote}>
                  <span
                    className={
                      "conv_quote" in tripData && quote == tripData.conv_quote
                        ? classes.red
                        : classes.headertext
                    }
                  >
                    {quote}
                  </span>{" "}
                  ||{" "}
                </a>
              );
            })}
          </div>
          <Typography
            variant="h6"
            align="center"
            className={classes.headertext}
          >
            {" "}
            {tripData.status_history.length == 0 ? (
              ""
            ) : (
              <>
                {tripData.status_history[tripData.status_history.length - 1]
                  .new_status +
                  " at: " +
                  String(
                    new Date(
                      tripData.status_history[
                        tripData.status_history.length - 1
                      ].date,
                    ),
                  ).slice(
                    0,
                    String(
                      tripData.status_history[
                        tripData.status_history.length - 1
                      ].date,
                    ).length,
                  ) +
                  " || TL credited: " +
                  tripData.team_leader +
                  " || Lead: "}
                <a
                  href={`${url}/lead/${leadid}`}
                  target="_blank"
                  rel="noreferrer"
                  className={classes.headertext}
                >
                  {leadid}
                </a> {" || Tasks:"}{tasklist.map(t=> {return(<a href={"/taskdataentry/"+t.task_id} target="_blank">{t.task_id+" || "}</a>)})}
              </>
            )}
          </Typography>
          {oldstatus == "Converted" || oldstatus == "Closed" ? (
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              Hotel Voucher - {gethoteltime()} || Land Voucher - {getlandtime()}
            </Typography>
          ) : (
            ""
          )}
        </FormGroup>
        <Dialog open={open} onClose={handleClose}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 420 }} align="center">
                    Quote Id - Quote Identifier
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {quotelist?.map((quote) => {
                  return (
                    <div>
                      <TableRow key={quote.quote_id}>
                        <TableCell style={{ width: 420 }} align="center">
                          {quote.quote_id} - {quote.quote_identifier}
                        </TableCell>
                      </TableRow>
                    </div>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
        <Dialog open={Open3} onClose={handleClose3}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 120 }} align="center">
                    Script
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell style={{ width: 120 }} align="center">
                    Call Start
                  </TableCell>
                  <TableCell style={{ width: 1620 }} align="center">
                    Hi, this is {tripData.trip_owner} calling from Jeto
                    Vacations about your upcoming trip to{" "}
                    {tripData.primary_destination}. Is this a good time to
                    speak?
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ width: 120 }} align="center">
                    Call Ending
                  </TableCell>
                  <TableCell style={{ width: 1620 }} align="center">
                    Please save my contact number. If you or any of your
                    family/friends have any need for any trip, please reach out
                    to me. <br></br> This is *your name* from Jeto Vacations.
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ width: 120 }} align="center">
                    Req Gathering
                  </TableCell>
                  <TableCell style={{ width: 1620 }} align="center">
                    Which destination do you want to visit? <br></br>
                    Is it fixed or are you looking for other options as well?
                    From which city you will be travelling?<br></br>
                    How many people will be travelling? Are there any kids or
                    seniors?<br></br>
                    When do you want to travel?/What will be your date of
                    travel? <br></br>Is it fixed? Is it for some special
                    occasion?
                    <br></br>
                    Do you have any preference regarding hotels and tours ?
                    <br></br>
                    Can you give me some idea about your total budget? Does it
                    include flights?
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ width: 120 }} align="center">
                    Kashmir
                  </TableCell>
                  <TableCell style={{ width: 1620 }} align="center">
                    Kashmir is world famous for its picturesque valleys and snow
                    covered mountain tops. People visit Kashmir to see snow,
                    amazing valleys, lakes and the cold weather. Kashmir is a
                    favorite hotspot for couples. Srinagar, Gulmarg, Pahalgam &
                    Sonmarg are the top tourist places. Gulmarg is famous for
                    his snow activities and it's also known as HEAVEN, Pahalgam
                    is famous for its valley view and in Srinagar you will see
                    the famous Mughal Gardens & Dal Lake even sir we will
                    provide the stay at Houseboat as well.
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
        <Dialog fullWidth maxWidth="xl" open={Open13} onClose={handleClose13}>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="opening">Call Type</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField2}
                labelId="opening"
                disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                value={calldata.call_type}
                onChange={(e) =>
                  setcalldata({
                    ...calldata,
                    call_type: e.target.value,
                    audit_date: new Date(),
                  })
                }
              >
                <MenuItem value={"First Call"}>First Call</MenuItem>
                <MenuItem value={"FUP Call"}>FUP Call</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
            {calldata.call_type == "FUP Call" ? (
              <div>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="opening">Opening Script</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="opening"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.opening_script}
                    onChange={(e) =>
                      setcalldata({
                        ...calldata,
                        opening_script: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="closing">Closing Script</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="closing"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.closing_script}
                    onChange={(e) =>
                      setcalldata({
                        ...calldata,
                        closing_script: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                  </Select>
                </FormControl>
              </div>
            ) : (
              <div>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="opening">Opening Script</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="opening"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.opening_script}
                    onChange={(e) =>
                      setcalldata({
                        ...calldata,
                        opening_script: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="closing">Closing Script</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="closing"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.closing_script}
                    onChange={(e) =>
                      setcalldata({
                        ...calldata,
                        closing_script: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}

            {calldata.call_type == "FUP Call" ? (
              ""
            ) : (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="hold">Hold Script</InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="hold"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.hold_script}
                  onChange={(e) =>
                    setcalldata({ ...calldata, hold_script: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                </Select>
              </FormControl>
            )}
          </FormGroup>
          <hr></hr>
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Interruption">Interruption</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField2}
                labelId="Interruption"
                disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                value={calldata.interruption}
                onChange={(e) =>
                  setcalldata({ ...calldata, interruption: e.target.value })
                }
              >
                <MenuItem value={null}>Clear</MenuItem>
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
              </Select>
            </FormControl>
            {calldata.call_type == "FUP Call" ? (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="ros">Rate of Speech</InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="ros"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.rate_of_speech}
                  onChange={(e) =>
                    setcalldata({ ...calldata, rate_of_speech: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                </Select>
              </FormControl>
            ) : (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="ros">Rate of Speech</InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="ros"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.rate_of_speech}
                  onChange={(e) =>
                    setcalldata({ ...calldata, rate_of_speech: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                </Select>
              </FormControl>
            )}
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="language">Language</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField2}
                labelId="language"
                disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                value={calldata.language}
                onChange={(e) =>
                  setcalldata({ ...calldata, language: e.target.value })
                }
              >
                <MenuItem value={null}>Clear</MenuItem>
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
              </Select>
            </FormControl>
            {calldata.call_type == "FUP Call" ? (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="empathy">Empathy</InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="empathy"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.empathy}
                  onChange={(e) =>
                    setcalldata({ ...calldata, empathy: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                </Select>
              </FormControl>
            ) : (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="empathy">Empathy</InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="empathy"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.empathy}
                  onChange={(e) =>
                    setcalldata({ ...calldata, empathy: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                </Select>
              </FormControl>
            )}
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="psgu">
                Pronunciation/Spelling/Grammar/Understandability
              </InputLabel>
              <Select
                displayEmpty
                classname={classes.textField2}
                labelId="psgu"
                disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                value={calldata.tone}
                onChange={(e) =>
                  setcalldata({ ...calldata, tone: e.target.value })
                }
              >
                <MenuItem value={null}>Clear</MenuItem>
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
              </Select>
            </FormControl>
            {calldata.call_type == "FUP Call" ? (
              ""
            ) : (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="tone">Tone</InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="tone"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.language}
                  onChange={(e) =>
                    setcalldata({ ...calldata, language: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                </Select>
              </FormControl>
            )}
            {calldata.call_type == "FUP Call" ? (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="hold">
                  Fumbling/Fillers/Slangs/Dead Air/Mute
                </InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="hold"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.fillers}
                  onChange={(e) =>
                    setcalldata({ ...calldata, fillers: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                </Select>
              </FormControl>
            ) : (
              <FormControl
                style={{
                  minWidth: 240,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="hold">
                  Fumbling/Fillers/Slangs/Dead Air/Mute
                </InputLabel>
                <Select
                  displayEmpty
                  classname={classes.textField2}
                  labelId="hold"
                  disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                  value={calldata.fillers}
                  onChange={(e) =>
                    setcalldata({ ...calldata, fillers: e.target.value })
                  }
                >
                  <MenuItem value={null}>Clear</MenuItem>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                </Select>
              </FormControl>
            )}
          </FormGroup>
          <hr></hr>
          <br></br>
          {calldata.call_type == "FUP Call" ? (
            <div>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="delay">OH Delay</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="delay"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.oh_delay}
                    onChange={(e) =>
                      setcalldata({ ...calldata, oh_delay: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="price">OH Price</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="price"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.oh_price}
                    onChange={(e) =>
                      setcalldata({ ...calldata, oh_price: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="permission">OH Permission</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="permission"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.oh_permission}
                    onChange={(e) =>
                      setcalldata({
                        ...calldata,
                        oh_permission: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <hr></hr>
              <br></br>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="trust">OH-Trust</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="trust"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.oh_trust}
                    onChange={(e) =>
                      setcalldata({ ...calldata, oh_trust: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="probing">OH-Probing</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="probing"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.oh_probing}
                    onChange={(e) =>
                      setcalldata({ ...calldata, oh_probing: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="guidance">Guidance</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="guidance"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.guidance}
                    onChange={(e) =>
                      setcalldata({ ...calldata, guidance: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={17}>17</MenuItem>
                    <MenuItem value={18}>18</MenuItem>
                    <MenuItem value={19}>19</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="closing">Closing</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="closing"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.closing}
                    onChange={(e) =>
                      setcalldata({ ...calldata, closing: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <hr></hr>
              <br></br>
            </div>
          ) : (
            <div>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="psgu">
                    Active Listening/Attentive on Call/Repetition Same Query
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="psgu"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.active_listening}
                    onChange={(e) =>
                      setcalldata({
                        ...calldata,
                        active_listening: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="rapport">Rapport Building</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="rapport"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.rapport}
                    onChange={(e) =>
                      setcalldata({ ...calldata, rapport: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={17}>17</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="empathy">
                    Acknowledgement, Confirmation, Empathy
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="empathy"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.empathy}
                    onChange={(e) =>
                      setcalldata({ ...calldata, empathy: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <hr></hr>
              <br></br>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="psgu">Explaining Destination</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="psgu"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.explanation}
                    onChange={(e) =>
                      setcalldata({ ...calldata, explanation: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                  </Select>
                </FormControl>
                {calldata.call_type == "FUP Call" ? (
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="guidance">Guidance</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField2}
                      labelId="guidance"
                      disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                      value={calldata.guidance}
                      onChange={(e) =>
                        setcalldata({ ...calldata, guidance: e.target.value })
                      }
                    >
                      <MenuItem value={null}>Clear</MenuItem>
                      <MenuItem value={0}>0</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={6}>6</MenuItem>
                      <MenuItem value={7}>7</MenuItem>
                      <MenuItem value={8}>8</MenuItem>
                      <MenuItem value={9}>9</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={11}>11</MenuItem>
                      <MenuItem value={12}>12</MenuItem>
                      <MenuItem value={13}>13</MenuItem>
                      <MenuItem value={14}>14</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={16}>16</MenuItem>
                      <MenuItem value={17}>17</MenuItem>
                      <MenuItem value={18}>18</MenuItem>
                      <MenuItem value={19}>19</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="guidance">Guidance</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField2}
                      labelId="guidance"
                      disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                      value={calldata.guidance}
                      onChange={(e) =>
                        setcalldata({ ...calldata, guidance: e.target.value })
                      }
                    >
                      <MenuItem value={null}>Clear</MenuItem>
                      <MenuItem value={0}>0</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={6}>6</MenuItem>
                      <MenuItem value={7}>7</MenuItem>
                      <MenuItem value={8}>8</MenuItem>
                      <MenuItem value={9}>9</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={11}>11</MenuItem>
                      <MenuItem value={12}>12</MenuItem>
                      <MenuItem value={13}>13</MenuItem>
                      <MenuItem value={14}>14</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                    </Select>
                  </FormControl>
                )}
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="empathy">Sales pitch</InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField2}
                    labelId="empathy"
                    disabled={role == "Admin" || role == "Manager" ? 0 : 1}
                    value={calldata.sales_pitch}
                    onChange={(e) =>
                      setcalldata({ ...calldata, sales_pitch: e.target.value })
                    }
                  >
                    <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <hr></hr>
              <br></br>
            </div>
          )}
          <FormGroup row className={classes.formgroup}>
            <TextField
              variant="outlined"
              label="Description"
              value={calldata.description}
              className={classes.textArea}
              fullWidth
              multiline
              rows={2}
              onChange={(e) =>
                setcalldata({ ...calldata, description: e.target.value })
              }
            />

            <TextField
              variant="outlined"
              label="AoI"
              value={calldata.improvement}
              className={classes.textArea}
              fullWidth
              multiline
              rows={2}
              onChange={(e) =>
                setcalldata({ ...calldata, improvement: e.target.value })
              }
            />
          </FormGroup>
          <hr></hr>
          <br></br>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className={classes.button}
          >
            Save
          </Button>
        </Dialog>
        <form onSubmit={handleSubmit}>
          <FormGroup row className={classes.formgroup}>
            {tripData &&
            (tripData.trip_status == "New" ||
              tripData.trip_status == "Hot" ||
              tripData.trip_status == "Active") ? (
              <FormControl
                style={{
                  minWidth: 450,
                  marginTop: 16,
                  marginRight: 24,
                  marginLeft: 5,
                }}
              >
                <InputLabel id="Trip Owner">Trip Owner</InputLabel>
                <Select
                  displayEmpty
                  className={classes.textField}
                  labelId="Trip Owner"
                  required
                  disabled={
                    cuser == "Debayan" || cuser == "Amit"
                      ? 0
                      : tripData.trip_status == "Closed" ||
                          tripData.trip_status == "Converted" ||
                          role == "Sales" ||
                          role == "SME"
                        ? 1
                        : 0
                  }
                  value={tripData.trip_owner}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_owner: e.target.value })
                  }
                >
                  {emp22.map((emp) => {
                    return <MenuItem value={emp}>{emp}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            ) : (
              <FormControl
                style={{
                  minWidth: 450,
                  marginTop: 16,
                  marginRight: 24,
                  marginLeft: 5,
                }}
              >
                <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select
                  displayEmpty
                  className={classes.textField}
                  labelId="Trip Owner"
                  required
                  disabled={
                    cuser == "Debayan" || cuser == "Amit"
                      ? 0
                      : tripData.trip_status == "Closed" ||
                          tripData.trip_status == "Converted" ||
                          role == "Sales" ||
                          role == "SME"
                        ? 1
                        : 0
                  }
                  value={tripData.trip_owner}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_owner: e.target.value })
                  }
                >
                  <MenuItem value={"Amit"}>Amit</MenuItem>
                  <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
                  <MenuItem value={"RohitS"}>RohitS</MenuItem>
                  {emp.map((emp) => {
                    return <MenuItem value={emp}>{emp}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            )}

            <FormControl
              style={{
                minWidth: 450,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 5,
              }}
            >
              <InputLabel id="primary destination">
                Primary Destination
              </InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="primary destination"
                required
                value={tripData.primary_destination}
                onChange={(e) =>
                  settripData({
                    ...tripData,
                    primary_destination: e.target.value,
                  })
                }
              >
                {dest.map((dest) => {
                  return <MenuItem value={dest}>{dest}</MenuItem>;
                })}
              </Select>
            </FormControl>
            {tripData.trip_status == "Closed" ||
            tripData.trip_status == "Converted" ||
            tripData.trip_status == "Cancelled" ? (
              <TextField
                required
                variant="standard"
                type="date"
                label={"Start Date"}
                disabled={role == "Sales" || role == "SME" ? 1 : 0}
                helperText={"Time to travel: " + ttt + " Days"}
                InputLabelProps={{ shrink: true }}
                value={
                  "trip_start_date" in tripData && tripData.trip_start_date
                    ? tripData.trip_start_date.split("T").slice(0, 1)
                    : ""
                }
                className={classes.textField3}
                defaultValue="2026-01-01"
                onChange={(e) => changestartdate(e.target.value)}
              />
            ) : (
              <TextField
                required
                variant="standard"
                type="date"
                label={"Start Date"}
                helperText={"Time to travel: " + ttt + " Days"}
                inputProps={{ min: fupfinalDate2, style: { color: "red" } }}
                InputLabelProps={{ shrink: true }}
                value={
                  "trip_start_date" in tripData && tripData.trip_start_date
                    ? tripData.trip_start_date.split("T").slice(0, 1)
                    : ""
                }
                className={classes.textField3}
                defaultValue="2025-01-01"
                onChange={(e) =>
                  settripData({ ...tripData, trip_start_date: e.target.value })
                }
              />
            )}
          </FormGroup>

          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="multidest">Multiple Destinations?</InputLabel>
              <Select
                defaultValue="No"
                classname={classes.textField}
                labelId="multidest"
                value={tripData.multi_destinations}
                onChange={(e) => changemultidest(e)}
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 320,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 5,
              }}
            >
              <InputLabel id="primary destination">
                Secondary Destination
              </InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="secondary destination"
                disabled={tripData.multi_destinations == "Yes" ? 0 : 1}
                value={tripData.secondary_destinations}
                onChange={(e) =>
                  settripData({
                    ...tripData,
                    secondary_destinations: e.target.value,
                  })
                }
              >
                {dest.map((dest) => {
                  return <MenuItem value={dest}>{dest}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 320,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 5,
              }}
            >
              <InputLabel id="tertiary destination">
                Tertiary Destination
              </InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="tertiary destination"
                disabled={tripData.secondary_destinations ? 0 : 1}
                value={tripData.tertiary_destinations}
                onChange={(e) =>
                  settripData({
                    ...tripData,
                    tertiary_destinations: e.target.value,
                  })
                }
              >
                {dest.map((dest) => {
                  return <MenuItem value={dest}>{dest}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Start date undecided">
                Start date undecided?
              </InputLabel>
              <Select
                defaultValue="No"
                classname={classes.textField}
                labelId="Start date undecided"
                value={tripData.start_date_undecided}
                onChange={(e) =>
                  settripData({
                    ...tripData,
                    start_date_undecided: e.target.value,
                  })
                }
              >
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>

          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Adults"># Adults (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Adults"
                value={tripData.number_adults}
                onChange={(e) =>
                  settripData({ ...tripData, number_adults: e.target.value })
                }
              >
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
                <MenuItem value={10}>10 </MenuItem>
                <MenuItem value={11}>11 </MenuItem>
                <MenuItem value={12}>12 </MenuItem>
                <MenuItem value={13}>13 </MenuItem>
                <MenuItem value={14}>14 </MenuItem>
                <MenuItem value={15}>15 </MenuItem>
                <MenuItem value={16}>16 </MenuItem>
                <MenuItem value={17}>17 </MenuItem>
                <MenuItem value={18}>18 </MenuItem>
                <MenuItem value={19}>19 </MenuItem>
                <MenuItem value={20}>20 </MenuItem>
                <MenuItem value={21}>21 </MenuItem>
                <MenuItem value={22}>22 </MenuItem>
                <MenuItem value={23}>23 </MenuItem>
                <MenuItem value={24}>24 </MenuItem>
                <MenuItem value={25}>25 </MenuItem>
                <MenuItem value={26}>26 </MenuItem>
                <MenuItem value={27}>27 </MenuItem>
                <MenuItem value={28}>28 </MenuItem>
                <MenuItem value={29}>29 </MenuItem>
                <MenuItem value={30}>30 </MenuItem>
                <MenuItem value={31}>31 </MenuItem>
                <MenuItem value={32}>32 </MenuItem>
                <MenuItem value={33}>33 </MenuItem>
                <MenuItem value={34}>34 </MenuItem>
                <MenuItem value={35}>35 </MenuItem>
                <MenuItem value={36}>36 </MenuItem>
                <MenuItem value={37}>37 </MenuItem>
                <MenuItem value={38}>38 </MenuItem>
                <MenuItem value={39}>39 </MenuItem>
                <MenuItem value={40}>40 </MenuItem>
                <MenuItem value={41}>41 </MenuItem>
                <MenuItem value={42}>42 </MenuItem>
                <MenuItem value={43}>43 </MenuItem>
                <MenuItem value={44}>44 </MenuItem>
                <MenuItem value={45}>45 </MenuItem>
                <MenuItem value={46}>46 </MenuItem>
                <MenuItem value={47}>47 </MenuItem>
                <MenuItem value={48}>48 </MenuItem>
                <MenuItem value={49}>49 </MenuItem>
                <MenuItem value={50}>50 </MenuItem>
                <MenuItem value={51}>51 </MenuItem>
                <MenuItem value={52}>52 </MenuItem>
                <MenuItem value={53}>53 </MenuItem>
                <MenuItem value={54}>54 </MenuItem>
                <MenuItem value={55}>55 </MenuItem>
                <MenuItem value={56}>56 </MenuItem>
                <MenuItem value={57}>57 </MenuItem>
                <MenuItem value={58}>58 </MenuItem>
                <MenuItem value={59}>59 </MenuItem>
                <MenuItem value={60}>60 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Child"># Child/Infant (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Child"
                value={tripData.number_child}
                onChange={(e) =>
                  settripData({ ...tripData, number_child: e.target.value })
                }
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
                <MenuItem value={10}>10 </MenuItem>
                <MenuItem value={11}>11 </MenuItem>
                <MenuItem value={12}>12 </MenuItem>
                <MenuItem value={13}>13 </MenuItem>
                <MenuItem value={14}>14 </MenuItem>
                <MenuItem value={15}>15 </MenuItem>
                <MenuItem value={16}>16 </MenuItem>
                <MenuItem value={17}>17 </MenuItem>
                <MenuItem value={18}>18 </MenuItem>
                <MenuItem value={19}>19 </MenuItem>
                <MenuItem value={20}>20 </MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="standard"
              label="Total Pax"
              value={tripData.number_adults + tripData.number_child}
              className={classes.textField4}
              disabled
            />
            <TextField
              required={
                "number_child" in tripData && tripData.number_child > 0 ? 1 : 0
              }
              variant="standard"
              label={"Child Age"}
              helperText={"Enter child age separated by commas"}
              InputLabelProps={{ shrink: true }}
              value={tripData.child_age}
              className={classes.textField4}
              onChange={(e) =>
                settripData({ ...tripData, child_age: e.target.value })
              }
            />
          </FormGroup>

          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 240,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Type of vacation">Type of Vacation</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Type of vacation"
                value={tripData.type_of_vacation}
                onChange={(e) =>
                  settripData({ ...tripData, type_of_vacation: e.target.value })
                }
              >
                <MenuItem value={"Honeymoon"}>Honeymoon</MenuItem>
                <MenuItem value={"Anniversary"}>Anniversary</MenuItem>
                <MenuItem value={"Birthday"}>Birthday</MenuItem>
                <MenuItem value={"Break"}>Break</MenuItem>
                <MenuItem value={"Children-Special"}>Children-Special</MenuItem>
                <MenuItem value={"Nothing-Special"}>Nothing-Special</MenuItem>
                <MenuItem value={"Others"}>Others</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Duration">Duration (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Duration"
                value={tripData.duration}
                onChange={(e) =>
                  settripData({ ...tripData, duration: e.target.value })
                }
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={11}>11</MenuItem>
                <MenuItem value={12}>12</MenuItem>
                <MenuItem value={13}>13</MenuItem>
                <MenuItem value={14}>14</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={16}>16</MenuItem>
                <MenuItem value={17}>17</MenuItem>
                <MenuItem value={18}>18</MenuItem>
                <MenuItem value={19}>19</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
            {oldstatus && oldstatus == "New" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_status: e.target.value })
                  }
                >
                  <MenuItem value={"New"}>New</MenuItem>
                  <MenuItem value={"Active"}>Active</MenuItem>

                  {/* <MenuItem value={"Cancelled"}>Cancelled</MenuItem> */}
                  {postponedlength < 25 ? (
                    <MenuItem value={"Postponed"}>Postponed</MenuItem>
                  ) : (
                    ""
                  )}
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Active" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_status: e.target.value })
                  }
                >
                  <MenuItem value={"Active"}>Active</MenuItem>

                  <MenuItem value={"Hot"}>Hot</MenuItem>

                  {postponedlength < 25 ? (
                    <MenuItem value={"Postponed"}>Postponed</MenuItem>
                  ) : (
                    ""
                  )}
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Closed" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                
                  displayEmpty
                  disabled
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) => markconv(e)}
                >
                  <MenuItem disabled value={"New"}>New</MenuItem>
                  <MenuItem disabled value={"Active"}>Active</MenuItem>
                  <MenuItem disabled value={"Closed"}>Closed</MenuItem>
                  <MenuItem disabled value={"Hot"}>Hot</MenuItem>
                  <MenuItem disabled={role=="Admin"?0:1} value={"Converted"}>Converted</MenuItem>
                  {/* <MenuItem value={"Cancelled"}>Cancelled</MenuItem> */}
                  {postponedlength < 25 ? (
                    <MenuItem disabled value={"Postponed"}>Postponed</MenuItem>
                  ) : (
                    ""
                  )}
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <MenuItem disabled value={"Booked Outside"}>Booked Outside</MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem disabled value={"Dropped After Booking"}>
                    Dropped After Booking
                  </MenuItem>
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Hot" ? (
              <div>
                {role == "Admin" || role == "Manager" || role == "TL" ? (
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                      <InputLabel id="Trip Status">
                        Trip Status <InfoIcon className={classes.icon} />
                      </InputLabel>
                    </Tooltip>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="Trip Status"
                      value={tripData.trip_status}
                      onChange={(e) => markconv(e)}
                    >
                      <MenuItem value={"Hot"}>Hot</MenuItem>
                      <MenuItem value={"Converted"}>Converted</MenuItem>
                      <MenuItem value={"Active"}>Active</MenuItem>
                      {postponedlength < 25 ? (
                        <MenuItem value={"Postponed"}>Postponed</MenuItem>
                      ) : (
                        ""
                      )}
                      {userdetails &&
                      userdetails.permissions.manual_cancellation ? (
                        <MenuItem value={"Booked Outside"}>
                          Booked Outside
                        </MenuItem>
                      ) : (
                        ""
                      )}
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                      <InputLabel id="Trip Status">
                        Trip Status <InfoIcon className={classes.icon} />
                      </InputLabel>
                    </Tooltip>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="Trip Status"
                      value={tripData.trip_status}
                      onChange={(e) => markconv(e)}
                    >
                      <MenuItem value={"Hot"}>Hot</MenuItem>
                      <MenuItem value={"Converted"}>Converted</MenuItem>

                      {postponedlength < 25 ? (
                        <MenuItem value={"Postponed"}>Postponed</MenuItem>
                      ) : (
                        ""
                      )}
                      {userdetails &&
                      userdetails.permissions.manual_cancellation ? (
                        <MenuItem value={"Booked Outside"}>
                          Booked Outside
                        </MenuItem>
                      ) : (
                        ""
                      )}
                    </Select>
                  </FormControl>
                )}
              </div>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Converted" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  disabled={role == "Sales" || role == "SME" ? 1 : 0}
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) => markconv(e)}
                >
                  <MenuItem value={"Closed"}>Closed</MenuItem>

                  <MenuItem value={"Converted"}>Converted</MenuItem>

                  <MenuItem value={"Dropped After Booking"}>
                    Dropped After Booking
                  </MenuItem>
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Cancelled" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_status: e.target.value })
                  }
                > 
                  {tripData && ((new Date().getTime() - new Date(tripData.createdAt).getTime())/(1000*60*60*24*60))<1?(
                  <MenuItem value={"Active"}>Active</MenuItem>
                    ):("")}
                  <MenuItem value={"Hot"}>Hot</MenuItem>

                  <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                  {postponedlength < 25 ? (
                    <MenuItem value={"Postponed"}>Postponed</MenuItem>
                  ) : (
                    ""
                  )}
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Postponed" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_status: e.target.value })
                  }
                >
                  <MenuItem value={"Active"}>Active</MenuItem>

                  <MenuItem value={"Hot"}>Hot</MenuItem>
                  {role == "Sales Support" ? (
                    <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                  ) : (
                    ""
                  )}
                  {postponedlength < 25 ? (
                    <MenuItem value={"Postponed"}>Postponed</MenuItem>
                  ) : (
                    ""
                  )}
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Booked Outside" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) =>
                    settripData({ ...tripData, trip_status: e.target.value })
                  }
                >
                  <MenuItem value={"Active"}>Active</MenuItem>

                  {/* <MenuItem value={"Cancelled"}>Cancelled</MenuItem> */}

                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
              </FormControl>
            ) : (
              ""
            )}
            {oldstatus && oldstatus == "Dropped After Booking" ? (
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <Tooltip title="Destination, date, pax and package - 3 out of 4 is final. Customer has cursory agreement to buy">
                  <InputLabel id="Trip Status">
                    Trip Status <InfoIcon className={classes.icon} />
                  </InputLabel>
                </Tooltip>
                <Select
                  displayEmpty
                  classname={classes.textField}
                  labelId="Trip Status"
                  value={tripData.trip_status}
                  onChange={(e) => markconv(e)}
                >
                  <MenuItem value={"Converted"}>Converted</MenuItem>

                  <MenuItem value={"Dropped After Booking"}>
                    Dropped After Booking
                  </MenuItem>
                </Select>
              </FormControl>
            ) : (
              ""
            )}
          </FormGroup>
          <br></br>
          {oldstatus == "Hot" || tripData.trip_status == "Hot" ? (
            <div>
              <FormGroup row className={classes.formgroup}>
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  value={whyhot.destination}
                  checked={whyhot.destination}
                  label="Destination final?"
                  onChange={(e) =>
                    setwhyhot({ ...whyhot, destination: !whyhot.destination })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  value={whyhot.date}
                  checked={whyhot.date}
                  label="Date final?"
                  onChange={(e) => setwhyhot({ ...whyhot, date: !whyhot.date })}
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  value={whyhot.pax}
                  checked={whyhot.pax}
                  label="Pax final?"
                  onChange={(e) => setwhyhot({ ...whyhot, pax: !whyhot.pax })}
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  value={whyhot.package}
                  checked={whyhot.package}
                  label="Package final?"
                  onChange={(e) =>
                    setwhyhot({ ...whyhot, package: !whyhot.package })
                  }
                />
              </FormGroup>
              <div align="center">
                <p className={classes.red}>
                  Destination, date, pax and package - 3 out of 4 is final.
                  Customer has cursory agreement to buy
                </p>
                <p className={classes.red}>
                  How the customer sounds or how you feel are not valid reasons
                  for marking hot. Please use HOT definition for marking HOT
                </p>
              </div>
              {/* <FormGroup row className={classes.formgroup}>
          <FormControlLabel control={<Checkbox color="primary"/>}   value={whyhot.fake1} checked={whyhot.fake1} label="Customer sounds very positive" onChange={(e)=> setwhyhot({...whyhot,fake1:!whyhot.package})}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={whyhot.fake2} checked={whyhot.fake2} label="Customer is highly responsive" onChange={(e)=> setwhyhot({...whyhot,fake2:!whyhot.package})}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={whyhot.fake3} checked={whyhot.fake3} label="Feels like customer will go" onChange={(e)=> setwhyhot({...whyhot,fake3:!whyhot.package})}/>
          </FormGroup> */}
            </div>
          ) : (
            ""
          )}
          <br></br>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Channel">Channel</InputLabel>
              <Select
                classname={classes.textField}
                labelId="Channel"
                value={tripData.trip_channel}
                onChange={(e) =>
                  settripData({ ...tripData, trip_channel: e.target.value })
                }
              >
                <MenuItem value={"TripCrafters"}>TripCrafters</MenuItem>
                <MenuItem value={"TripClap"}>TripClap</MenuItem>
                <MenuItem value={"PayTM"}>PayTM</MenuItem>
                <MenuItem value={"Reference"}>Reference</MenuItem>
                <MenuItem value={"Manual"}>Manual</MenuItem>
                <MenuItem value={"Organic"}>Organic</MenuItem>
                <MenuItem value={"Email"}>Email</MenuItem>
                <MenuItem value={"Meta"}>Meta</MenuItem>
                <MenuItem value={"Poptin"}>Poptin</MenuItem>
                <MenuItem value={"Google"}>Google</MenuItem>
                <MenuItem value={"Duplicate"}>Duplicate</MenuItem>
                <MenuItem value={"Unknown"}>Others</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="standard"
              label="Campaign"
              value={tripData.trip_campaign}
              className={classes.textField}
              onChange={(e) =>
                settripData({ ...tripData, trip_campaign: e.target.value })
              }
            />
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="Trip Stage">Trip Stage</InputLabel>
              <Select
                classname={classes.textField}
                labelId="Trip Stage"
                value={tripData.trip_stage}
                onChange={(e) =>
                  settripData({ ...tripData, trip_stage: e.target.value })
                }
              >
                <MenuItem value={"Flight/Train booked"}>
                  Flight/Train booked
                </MenuItem>
                <MenuItem value={"Definitely going"}>Definitely going</MenuItem>
                <MenuItem value={"Plan in progress"}>Plan in progress</MenuItem>
                <MenuItem value={"Still dreaming"}>Still dreaming</MenuItem>
                <MenuItem value={"Looking for info"}>Looking for info</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="flightreq">Flight Required?</InputLabel>
              <Select
                classname={classes.textField}
                labelId="flightreq"
                value={tripData.flight_required ? true : false}
                onChange={(e) =>
                  settripData({ ...tripData, flight_required: e.target.value })
                }
              >
                <MenuItem value={false}>false</MenuItem>
                <MenuItem value={true}>true</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="sourceairport">
                Source Airport (Airport code only)
              </InputLabel>
              <Select
                classname={classes.textField}
                displayEmpty
                labelId="sourceairport"
                value={tripData.lead_source_airport}
                required={role == "Admin" || role == "Accounts" ? 0 : 1}
                onChange={(e) =>
                  settripData({
                    ...tripData,
                    lead_source_airport: e.target.value,
                  })
                }
                inputProps={{ className: classes.input, pattern: "[A-Z]{3}" }}
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem value={"DNK"}>DNK</MenuItem>
                {airportlist2.map((data) => (
                  <MenuItem value={data.airport}>{data.airport}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </FormGroup>

          <FormGroup row className={classes.formgroup}>
            <TextField
              variant="outlined"
              label="Requirements - shown to customer in quote"
              value={tripData.trip_requirements}
              className={classes.textArea}
              fullWidth
              multiline
              rows={4}
              onChange={(e) =>
                settripData({ ...tripData, trip_requirements: e.target.value })
              }
            />
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
            <TextField
              variant="outlined"
              label="Password-for customer"
              InputLabelProps={{ shrink: true }}
              value={tripData.trip_password}
              className={classes.textField}
              onChange={(e) =>
                settripData({ ...tripData, trip_password: e.target.value })
              }
            />
          </FormGroup>
          {tripData.trip_status == "Cancelled" ? (
            <div>
              <FormGroup row className={classes.formgroup}>
                {/* <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 64,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="canc_reason">
                  Cancellation Classification
                </InputLabel>
                <Select
                  classname={classes.textField}
                  disbaled
                  labelId="canc_reason"
                  value={
                    tripData.trip_canc_reason_short
                      ? tripData.trip_canc_reason_short
                      : ""
                  }
                  // onChange={(e) =>
                  //   settripData({
                  //     ...tripData,
                  //     trip_canc_reason_short: e.target.value,
                  //   })
                  // }
                >
                  <MenuItem value={"No response"}>No response</MenuItem>
                  <MenuItem value={"Said planned cancelled - reason not given"}>
                    Said planned cancelled - reason not given
                  </MenuItem>
                  <MenuItem value={"Said planned cancelled - reason given"}>
                    Said planned cancelled - reason given
                  </MenuItem>
                  <MenuItem
                    value={"Said planned cancelled - will contact later"}
                  >
                    Said planned cancelled - will contact later
                  </MenuItem>
                  <MenuItem value={"Demand cannot be met"}>
                    Demand cannot be met
                  </MenuItem>
                  <MenuItem value={"Duplicate"}>Duplicate</MenuItem>
                  <MenuItem value={"No budget"}>No budget</MenuItem>
                  <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
              </FormControl> */}
                <TextField
                  // required={
                  //   tripData.trip_status == "Cancelled" ||
                  //   tripData.trip_status == "Booked Outside"
                  //     ? 1
                  //     : 0
                  // }
                  disabled
                  variant="outlined"
                  label="Trip Cancellation Reason"
                  value={
                    tripData.trip_canc_reason_short
                      ? tripData.trip_canc_reason_short
                      : ""
                  }
                  className={classes.textArea}
                  fullWidth
                  multiline
                  rows={2}
                  // onChange={(e) =>
                  //   settripData({ ...tripData, trip_canc_reason: e.target.value })
                  // }
                />
                <TextField
                  // required={
                  //   tripData.trip_status == "Cancelled" ||
                  //   tripData.trip_status == "Booked Outside"
                  //     ? 1
                  //     : 0
                  // }
                  disabled
                  variant="outlined"
                  label="Trip Cancellation Reason"
                  value={
                    tripData.trip_canc_reason ? tripData.trip_canc_reason : ""
                  }
                  className={classes.textArea}
                  fullWidth
                  multiline
                  rows={2}
                  // onChange={(e) =>
                  //   settripData({ ...tripData, trip_canc_reason: e.target.value })
                  // }
                />
              </FormGroup>
            </div>
          ) : (
            ""
          )}

          {tripData.trip_status == "Booked Outside" ? (
            <FormGroup row className={classes.formgroup}>
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 64,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="canc_reason">
                  Cancellation Classification
                </InputLabel>
                <Select
                  classname={classes.textField}
                  required={
                    tripData.trip_status == "Booked Outside" ||
                    followupData.fupautonote == "Asked to cancel-on call" ||
                    followupData.fupautonote == "Asked to cancel-on whatsapp" ||
                    followupData.fupautonote ==
                      "System fup - WA msg sent -Asked to cancel-on call" ||
                    followupData.fupautonote ==
                      "System fup - WA msg sent -Asked to cancel-on whatsapp"
                      ? 1
                      : 0
                  }
                  labelId="canc_reason"
                  value={
                    tripData.trip_canc_reason_short
                      ? tripData.trip_canc_reason_short
                      : ""
                  }
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      trip_canc_reason_short: e.target.value,
                    })
                  }
                >
                  <MenuItem value={"Booked outside without any information"}>
                    Booked outside without any information
                  </MenuItem>
                  <MenuItem value={"Booked from a known person"}>
                    Booked from a known person
                  </MenuItem>
                  <MenuItem value={"Booking DIY"}>Booking DIY</MenuItem>
                  <MenuItem value={"Shared quote but unable to beat price"}>
                    Shared quote but unable to beat price
                  </MenuItem>
                  <MenuItem
                    value={"Shared quote, price beat yet booked outside"}
                  >
                    Shared quote, price beat yet booked outside
                  </MenuItem>
                  <MenuItem value={"Trust Issue"}>Trust Issue</MenuItem>
                  <MenuItem value={"Will not book with Delhi agent"}>
                    Will not book with Delhi agent
                  </MenuItem>
                  <MenuItem value={"Unable to match requirement"}>
                    Unable to match requirement
                  </MenuItem>
                  <MenuItem value={"Unable to match product"}>
                    Unable to match product
                  </MenuItem>
                  <MenuItem
                    value={
                      "Just checking rates. Already booked from somewhere else"
                    }
                  >
                    Just checking rates. Already booked from somewhere else
                  </MenuItem>
                  <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
              </FormControl>

              <TextField
                variant="outlined"
                label="Cancfupautonote"
                required={
                  tripData.trip_status == "Cancelled" ||
                  tripData.trip_status == "Booked Outside" ||
                  followupData.fupautonote == "Asked to cancel-on call" ||
                  followupData.fupautonote == "Asked to cancel-on whatsapp" ||
                  followupData.fupautonote ==
                    "System fup - WA msg sent -Asked to cancel-on call" ||
                  followupData.fupautonote ==
                    "System fup - WA msg sent -Asked to cancel-on whatsapp"
                    ? 1
                    : 0
                }
                className={classes.textArea}
                value={
                  tripData.trip_canc_reason ? tripData.trip_canc_reason : ""
                }
                fullWidth
                rows={2}
                onChange={(e) =>
                  settripData({ ...tripData, trip_canc_reason: e.target.value })
                }
              />
            </FormGroup>
          ) : (
            ""
          )}

          {tripData.trip_status == "Converted" ||
          tripData.trip_status == "Closed" ||
          tripData.trip_status == "Dropped After Booking" ? (
            <div>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 24,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="quotenumber">
                    Converted Quote number
                  </InputLabel>
                  <Select
                    displayEmpty
                    required={
                      tripData.trip_status == "Converted" ||
                      tripData.trip_status == "Closed"
                        ? 1
                        : 0
                    }
                    className={classes.textField}
                    labelId="quotenumber"
                    value={tripData.conv_quote ? tripData.conv_quote : ""}
                    onChange={(e) =>
                      settripData({ ...tripData, conv_quote: e.target.value })
                    }
                  >
                    <MenuItem value="1">1</MenuItem>
                    {tripData.quote.map((quote) => (
                      <MenuItem value={quote}>{quote}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextField
                required={
                  tripData.trip_status == "Converted" ||
                  tripData.trip_status == "Closed"
                    ? 1
                    : 0
                }
                variant="outlined"
                label="Converted Quote number (Number)"
                value={tripData.conv_quote ? tripData.conv_quote : ""}
                className={classes.textArea}
                multiline
                rows={1}
                onChange={(e) =>
                  settripData({ ...tripData, conv_quote: e.target.value })
                }
              /> */}

                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 64,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="State">State</InputLabel>
                  <Select
                    classname={classes.textField}
                    required={
                      tripData.trip_status == "Converted" ||
                      tripData.trip_status == "Closed"
                        ? 1
                        : 0
                    }
                    labelId="State"
                    value={tripData.cust_state ? tripData.cust_state : ""}
                    onChange={(e) =>
                      settripData({ ...tripData, cust_state: e.target.value })
                    }
                  >
                    <MenuItem value={"Andaman & Nicober Islands"}>
                      Andaman & Nicober Islands
                    </MenuItem>
                    <MenuItem value={"New Delhi"}>New Delhi</MenuItem>
                    <MenuItem value={"Karnataka"}>Karnataka</MenuItem>
                    <MenuItem value={"Telangana"}>Telangana</MenuItem>
                    <MenuItem value={"Andhra Pradesh"}>Andhra Pradesh</MenuItem>
                    <MenuItem value={"Manipur"}>Manipur</MenuItem>
                    <MenuItem value={"Maharashtra"}>Maharashtra</MenuItem>
                    <MenuItem value={"Goa"}>Goa</MenuItem>
                    <MenuItem value={"Odisha"}>Odisha</MenuItem>
                    <MenuItem value={"West Bengal"}>West Bengal</MenuItem>
                    <MenuItem value={"Gujarat"}>Gujarat</MenuItem>
                    <MenuItem value={"Assam"}>Assam</MenuItem>
                    <MenuItem value={"Haryana"}>Haryana</MenuItem>
                    <MenuItem value={"Punjab"}>Punjab</MenuItem>
                    <MenuItem value={"Chandigarh"}>Chandigarh</MenuItem>
                    <MenuItem value={"Himachal Pradesh"}>
                      Himachal Pradesh
                    </MenuItem>
                    <MenuItem value={"Uttar Pradesh"}>Uttar Pradesh</MenuItem>
                    <MenuItem value={"Sikkim"}>Sikkim</MenuItem>
                    <MenuItem value={"Rajasthan"}>Rajasthan</MenuItem>
                    <MenuItem value={"Jammu & Kashmir"}>
                      Jammu & Kashmir
                    </MenuItem>
                    <MenuItem value={"Madhya Pradesh"}>Madhya Pradesh</MenuItem>
                    <MenuItem value={"Chattisgarh"}>Chattisgarh</MenuItem>
                    <MenuItem value={"Bihar"}>Bihar</MenuItem>
                    <MenuItem value={"Jharkhand"}>Jharkhand</MenuItem>
                    <MenuItem value={"Nagaland"}>Nagaland</MenuItem>
                    <MenuItem value={"Tripura"}>Tripura</MenuItem>
                    <MenuItem value={"Mizoram"}>Mizoram</MenuItem>
                    <MenuItem value={"Arunachal Pradesh"}>
                      Arunachal Pradesh
                    </MenuItem>
                    <MenuItem value={"Uttarakhand"}>Uttarakhand</MenuItem>
                    <MenuItem value={"Tamil Nadu"}>Tamil Nadu</MenuItem>
                    <MenuItem value={"Kerala"}>Kerala</MenuItem>
                    <MenuItem value={"Ladakh"}>Ladakh</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  variant="outlined"
                  label="Refund Committed"
                  disabled
                  value={
                    tripData.refund_committed ? tripData.refund_committed : ""
                  }
                  className={classes.textField}
                  // onChange={(e) =>
                  //   settripData({ ...tripData, refund_committed: e.target.value })
                  // }
                />
                <TextField
                  variant="outlined"
                  label="Merge Ids"
                  disabled
                  value={
                    tripData.merge_trips ? tripData.merge_trips.toString() : ""
                  }
                  className={classes.textField}
                  // onChange={(e) =>
                  //   settripData({ ...tripData, refund_committed: e.target.value })
                  // }
                />
                {((role == "Admin" || role == "Accounts") &&
                  tripData.trip_status == "Closed") ||
                ((role == "Admin" || role == "Accounts") &&
                  tripData.trip_status == "Dropped After Booking") ? (
                  <div>
                    <FormControl
                      style={{
                        minWidth: 450,
                        marginTop: 16,
                        marginRight: 24,
                        marginLeft: 5,
                      }}
                    >
                      <InputLabel id="incentive">Incentive Paid?</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        labelId="incentive"
                        required
                        value={tripData.incentive_paid}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            incentive_paid: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="Skip">Skip</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                ) : (
                  ""
                )}
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="Mailsent">Mail sent?</InputLabel>
                  <Select
                    classname={classes.textField}
                    required={tripData.trip_status == "Converted" ? 1 : 0}
                    labelId="Mailsent"
                    value={
                      bookingData && bookingData.mail_sent
                        ? bookingData.mail_sent
                        : ""
                    }
                    onChange={(e) =>
                      setbookingData({
                        ...bookingData,
                        mail_sent: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"NA"}>NA</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="psacc">Payment Schedule Accepted?</InputLabel>
                  <Select
                    classname={classes.textField}
                    required={tripData.trip_status == "Converted" ? 1 : 0}
                    labelId="psacc"
                    value={
                      bookingData && bookingData.payment_scheduled
                        ? bookingData.payment_scheduled
                        : ""
                    }
                    onChange={(e) =>
                      setbookingData({
                        ...bookingData,
                        payment_scheduled: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"NA"}>NA</MenuItem>
                  </Select>
                </FormControl>
                {role == "Sales" ||
                role == "SME" ||
                role == "TL" ||
                role == "Product" ||
                role == "Admin" ||
                role == "Manager" ||
                role == "Sales Support" ? (
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="transfer">
                      Transfer to Operations?
                    </InputLabel>
                    <Select
                      classname={classes.textField}
                      disabled={
                        bookingData &&
                        "transfer_state" in bookingData &&
                        bookingData.transfer_state == "Accepted"
                          ? 1
                          : 0
                      }
                      required={tripData.trip_status == "Converted" ? 1 : 0}
                      labelId="transfer"
                      value={
                        bookingData && bookingData.transfer_state
                          ? bookingData.transfer_state
                          : ""
                      }
                      onChange={(e) => changetransferstate(e)}
                    >
                      <MenuItem value={"Just Converted"}>
                        Just Converted
                      </MenuItem>
                      {oldstatus == "Converted" &&
                      bookingData &&
                      "mail_sent" in bookingData &&
                      bookingData.mail_sent == "Yes" ? (
                        <MenuItem value={"Requested"}>Requested</MenuItem>
                      ) : null}
                      <MenuItem value={"NA"}>NA</MenuItem>
                    </Select>
                    <FormHelperText>
                      {"JC Date: " +
                        tripData.jc_date +
                        " || Accepted Date: " +
                        tripData.accepted_date}
                    </FormHelperText>
                  </FormControl>
                ) : (
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="transfer">
                      Transfer to Operations?
                    </InputLabel>
                    <Select
                      classname={classes.textField}
                      required={
                        tripData.trip_status == "Converted" ||
                        tripData.trip_status == "Closed"
                          ? 1
                          : 0
                      }
                      labelId="transfer"
                      value={
                        bookingData && bookingData.transfer_state
                          ? bookingData.transfer_state
                          : ""
                      }
                      onChange={(e) => changetransferstate(e)}
                    >
                      <MenuItem value={"Just Converted"}>
                        Just Converted
                      </MenuItem>
                      <MenuItem value={"Requested"}>Requested</MenuItem>
                      <MenuItem value={"Accepted"}>Accepted</MenuItem>
                      <MenuItem value={"Rejected"}>Rejected</MenuItem>
                      <MenuItem value={"Back to Sales"}>Back to Sales</MenuItem>
                      <MenuItem value={"NA"}>NA</MenuItem>
                    </Select>
                    <FormHelperText>
                      {"JC Date: " +
                        tripData.jc_date +
                        " || Accepted Date: " +
                        tripData.accepted_date}
                    </FormHelperText>
                  </FormControl>
                )}
              </FormGroup>
            </div>
          ) : (
            ""
          )}
          <br></br>
          {tripData.trip_status == "Converted" ||
          tripData.trip_status == "Closed" ||
          tripData.trip_status == "Dropped After Booking" ? (
            <div align="center">
              <Divider></Divider>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpen9(true)}
                className={classes.button}
              >
                Operations
              </Button>
              <Divider></Divider>
            </div>
          ) : (
            ""
          )}

          {(role == "Admin" ||
            role == "Manager" ||
            role == "TL" ||
            role == "Accounts") &&
          tripData.trip_status == "Closed" ? (
            <div>
              <FormGroup row className={classes.formgroup}>
                <TextField
                  variant="outlined"
                  label="Taxes"
                  value={tripData.taxes ? tripData.taxes : ""}
                  className={classes.textField}
                  onChange={(e) =>
                    settripData({ ...tripData, taxes: e.target.value })
                  }
                />
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 64,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="spincentive">
                    SalesPerson Incentive
                  </InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="spincentive"
                    value={tripData.sp_incentive ? tripData.sp_incentive : ""}
                    onChange={(e) =>
                      settripData({ ...tripData, sp_incentive: e.target.value })
                    }
                  >
                    <MenuItem value={0}>0%</MenuItem>
                    <MenuItem value={1}>1%</MenuItem>
                    <MenuItem value={2}>2%</MenuItem>
                    <MenuItem value={3}>3%</MenuItem>
                    <MenuItem value={4}>4%</MenuItem>
                    <MenuItem value={5}>5%</MenuItem>
                    <MenuItem value={6}>6%</MenuItem>
                    <MenuItem value={7}>7%</MenuItem>
                    <MenuItem value={8}>8%</MenuItem>
                    <MenuItem value={9}>9%</MenuItem>
                    <MenuItem value={10}>10%</MenuItem>
                    <MenuItem value={11}>11%</MenuItem>
                    <MenuItem value={12}>12%</MenuItem>
                    <MenuItem value={13}>13%</MenuItem>
                    <MenuItem value={14}>14%</MenuItem>
                    <MenuItem value={15}>15%</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  variant="outlined"
                  label="Incentive Amount"
                  // value={(
                  //   ((parseInt(tripData.flight_sp) +
                  //     parseInt(tripData.visa_sp) +
                  //     parseInt(tripData.anc_sp) +
                  //     parseInt(tripData.cruise_sp) +
                  //     parseInt(tripData.land_sp) -
                  //     (parseInt(tripData.flight_cp) +
                  //       parseInt(tripData.visa_cp) +
                  //       parseInt(tripData.anc_cp) +
                  //       parseInt(tripData.cruise_cp) +
                  //       parseInt(tripData.land_cp)) -
                  //     tripData.taxes-(gettcs2(tripData)-gettcs(tripData))) *
                  //     tripData.sp_incentive) /
                  //   100
                  // ).toFixed(2)}
                  value={(
                    (getprofit(tripData) * tripData.sp_incentive) /
                    100
                  ).toFixed(2)}
                  className={classes.textField}
                  disabled
                />
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 64,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="tlincentive">TL Incentive</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="tlincentive"
                    value={tripData.tl_incentive ? tripData.tl_incentive : ""}
                    onChange={(e) =>
                      settripData({ ...tripData, tl_incentive: e.target.value })
                    }
                  >
                    <MenuItem value={0}>0%</MenuItem>
                    <MenuItem value={1}>1%</MenuItem>
                    <MenuItem value={1.25}>1.25%</MenuItem>
                    <MenuItem value={1.5}>1.5%</MenuItem>
                    <MenuItem value={2}>2%</MenuItem>
                    <MenuItem value={2.5}>2.5%</MenuItem>
                    <MenuItem value={3}>3%</MenuItem>
                    <MenuItem value={4}>4%</MenuItem>
                    <MenuItem value={5}>5%</MenuItem>
                    <MenuItem value={6}>6%</MenuItem>
                    <MenuItem value={7}>7%</MenuItem>
                    <MenuItem value={8}>8%</MenuItem>
                    <MenuItem value={9}>9%</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  variant="outlined"
                  label="Incentive Amount"
                  value={(
                    (getprofit(tripData) * tripData.tl_incentive) /
                    100
                  ).toFixed(2)}
                  className={classes.textField}
                  disabled
                />
              </FormGroup>
            </div>
          ) : (
            ""
          )}

          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Old Followups
          </Typography>
          <div align="center">
            <Button
              onClick={() => scrollshow()}
              variant="outlined"
              color="secondary"
              className={classes.button2}
            >
              {scroll ? "Show 3 fups" : "Show all fups"}
            </Button>
          </div>

          {fupData &&
            fupData.length > 0 &&
            fupData.map((fup) => {
              return (
                <div>
                  {fup.fupautonote == "" &&
                  fup.notes == "" &&
                  fup.fuptype == "" ? (
                    ""
                  ) : (
                    <div>
                      <Typography variant="h6" align="center">
                        Follow up created on:
                        {new Date(fup.createdAt)
                          .toLocaleString()
                          .split(",")
                          .slice(0, 1)}{" "}
                        at
                        {new Date(fup.createdAt)
                          .toLocaleString()
                          .split(",")
                          .slice(1, 2)}{" "}
                        by {fup.createdby}{" "}
                        {"skip_call_reason" in fup
                          ? " || Skip Reason: " + fup.skip_call_reason
                          : ""}
                      </Typography>
                      <FormGroup row className={classes.formgroup}>
                        <FormControl
                          style={{
                            minWidth: 480,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="status">Followup Status</InputLabel>
                          <Select
                            disabled
                            className={classes.textField}
                            labelId="status"
                            value={fup.status}
                            onChange={(e) =>
                              setfollowupData({
                                ...followupData,
                                status: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={"Open"}>Open</MenuItem>
                            <MenuItem value={"Closed"}>Closed</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 480,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="fuptype">Followup Type</InputLabel>
                          <Select
                            value={fup.fuptype}
                            disabled
                            className={classes.textField}
                            labelId="fuptype"
                            onChange={(e) =>
                              setfollowupData({
                                ...followupData,
                                fuptype: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={"Share first quote"}>
                              Share first quote
                            </MenuItem>
                            <MenuItem value={"Share revised quote"}>
                              Share revised quote
                            </MenuItem>
                            <MenuItem value={"Quote explanation"}>
                              Quote explanation
                            </MenuItem>
                            <MenuItem value={"Quote feedback"}>
                              Quote feedback
                            </MenuItem>
                            <MenuItem value={"Ask for payment"}>
                              Ask for payment
                            </MenuItem>
                            <MenuItem value={"Voucher or Confirmation pending"}>
                              Voucher or Confirmation pending
                            </MenuItem>
                            <MenuItem value={"Trip Feedback"}>
                              Trip Feedback
                            </MenuItem>
                            <MenuItem value={"Others"}>Others</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          disbaled
                          control={<Checkbox color="primary" />}
                          checked={fup.override}
                          label="Overide fup date?"
                        />
                      </FormGroup>
                      <FormGroup row className={classes.formgroup}>
                        <TextField
                          variant="standard"
                          disabled
                          required={
                            tripData.trip_status == "Closed" ||
                            tripData.trip_status == "Cancelled" ||
                            tripData.trip_status == "Booked Outside" ||
                            tripData.trip_status == "Dropped After Booking"
                              ? null
                              : 1
                          }
                          value={fup.date}
                          type="date"
                          label="Followup Date"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setfollowupData({
                              ...followupData,
                              date: e.target.value,
                              new_date: new Date(e.target.value),
                            })
                          }
                        />
                        <TextField
                          variant="standard"
                          disabled
                          required={
                            tripData.trip_status == "Closed" ||
                            tripData.trip_status == "Cancelled" ||
                            tripData.trip_status == "Booked Outside" ||
                            tripData.trip_status == "Dropped After Booking"
                              ? null
                              : 1
                          }
                          value={fup.time}
                          type="time"
                          label="Followup Time"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setfollowupData({
                              ...followupData,
                              time: e.target.value,
                            })
                          }
                        />
                      </FormGroup>

                      <FormGroup row className={classes.formgroup}>
                        <TextField
                          variant="outlined"
                          disabled
                          label="Notes"
                          className={classes.textArea}
                          value={fup.fupautonote + " || " + fup.notes}
                          fullWidth
                          multiline
                          // onChange={(e) =>
                          //   setfollowupData({
                          //     ...followupData,
                          //     notes: e.target.value,
                          //   })
                          // }
                        />
                      </FormGroup>
                    </div>
                  )}
                </div>
              );
            })}

          {(role && role !== "Sales") ||
          (role &&
            (role == "Sales" || role == "SME") &&
            "trip_status" in tripData &&
            tripData.trip_status !== "Cancelled" &&
            shownewfup) ? (
            <div>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                {/* New Followup (Call:{tripData.lead?(calltrue2()?"Must":"Optional"):(calltrue()?"Must":"Optional")}) */}
                New Followup (Call:{calltrue2(tripData) ? "Must" : "Optional"})
              </Typography>

              {fupData &&
              fupData.length > 0 &&
              fupData[fupData.length - 1].fupautonote ==
                "Need changes. Need to share updated quote" ? (
                <FormGroup row className={classes.formgroup}>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="fupautonote">Canned Notes</InputLabel>
                    <Select
                      className={classes.textField}
                      labelId="fupautonote"
                      required={
                        role == "Admin" ||
                        role == "Operations" ||
                        role == "Operations-TL" ||
                        role == "Product"
                          ? 0
                          : oldstatus == "Converted" ||
                              oldstatus == "Cancelled" ||
                              oldstatus == "Closed" ||
                              oldstatus == "Booked Outside" ||
                              oldstatus == "Dropped After Booking"
                            ? 0
                            : 1
                      }
                      onChange={(e) => changecannednotes(e)}
                    >
                      <MenuItem
                        value={
                          "Asked to add flights. Shared quote with flights"
                        }
                      >
                        Asked to add flights. Shared quote with flights
                      </MenuItem>

                      <MenuItem value={"Quote shared"}>Quote shared</MenuItem>
                      <MenuItem value={"Waiting for rates"}>
                        Waiting for rates
                      </MenuItem>

                      <MenuItem value={"Needed changes. Shared updated quote"}>
                        Needed changes. Shared updated quote
                      </MenuItem>

                      <MenuItem
                        value={"Our quote is costly. Shared other options"}
                      >
                        Our quote is costly. Shared other options
                      </MenuItem>
                      <MenuItem value={"Data entry only"}>
                        Data entry only
                      </MenuItem>
                      <MenuItem value={"Data entry only - Msg sent"}>
                        Data entry only - Msg sent
                      </MenuItem>
                    </Select>
                    <FormHelperText className={classes.red}>
                      Share new or revised quote before updating the trip
                    </FormHelperText>
                  </FormControl>
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <FormControlLabel
                      disabled={
                        tripData.trip_status == "Converted" ||
                        tripData.trip_status == "Postponed"
                          ? 0
                          : role == "Sales" || role == "SME"
                            ? followupData.fupautonote ==
                              "Asked to call at a specific time"
                              ? 0
                              : 1
                            : 1
                      }
                      control={<Checkbox color="primary" />}
                      checked={followupData.override}
                      label="Overide fup date?"
                      onChange={(e) =>
                        setfollowupData({
                          ...followupData,
                          override: e.target.checked,
                        })
                      }
                    />
                  ) : (
                    ""
                  )}

                  <Typography
                    className={classes.redheadtext}
                    align="center"
                    variant="h6"
                  >
                    {quotepending ? "Quote Pending" : ""}
                  </Typography>
                </FormGroup>
              ) : (
                <div>
                  {userdetails &&
                  userdetails.permissions.manual_cancellation ? (
                    <FormGroup row className={classes.formgroup}>
                      <FormControl
                        style={{
                          minWidth: 480,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="fupautonote">Canned Notes</InputLabel>
                        <Select
                          className={classes.textField}
                          labelId="fupautonote"
                          required={
                            role == "Admin" ||
                            role == "Operations" ||
                            role == "Operations-TL" ||
                            role == "Product"
                              ? 0
                              : oldstatus == "Converted" ||
                                  oldstatus == "Cancelled" ||
                                  oldstatus == "Closed" ||
                                  oldstatus == "Booked Outside" ||
                                  oldstatus == "Dropped After Booking"
                                ? 0
                                : 1
                          }
                          onChange={(e) => changecannednotes(e)}
                        >
                          <ListSubheader>No Response Group</ListSubheader>
                          <MenuItem value={"Call not picked"}>
                            Call not picked
                          </MenuItem>
                          <MenuItem value={"Call disconnected by client"}>
                            Call disconnected by client
                          </MenuItem>
                          <MenuItem value={"Call not picked. WA sent"}>
                            Call not picked. WA sent
                          </MenuItem>
                          <MenuItem
                            value={
                              "Call not picked and no response on Whatsapp"
                            }
                          >
                            Call not picked and no response on Whatsapp
                          </MenuItem>
                          {/* <MenuItem value={"No response after multiple follow ups"}>
                No response after multiple follow ups
              </MenuItem> */}
                          <ListSubheader>
                            First or Revised Quote Group
                          </ListSubheader>
                          <MenuItem
                            value={
                              "Asked to add flights. Shared quote with flights"
                            }
                          >
                            Asked to add flights. Shared quote with flights
                          </MenuItem>
                          <MenuItem value={"Need to share first quote"}>
                            Need to share first quote
                          </MenuItem>
                          <MenuItem value={"Quote shared"}>
                            Quote shared
                          </MenuItem>
                          <MenuItem value={"Waiting for rates"}>
                            Waiting for rates
                          </MenuItem>
                          <MenuItem
                            value={"Need changes. Need to share updated quote"}
                          >
                            Need changes. Need to share updated quote
                          </MenuItem>
                          <MenuItem
                            value={"Needed changes. Shared updated quote"}
                          >
                            Needed changes. Shared updated quote
                          </MenuItem>
                          <MenuItem
                            value={"Budget issue. Shared other options"}
                          >
                            Budget issue. Shared other options
                          </MenuItem>
                          <MenuItem
                            value={"Our quote is costly. Shared other options"}
                          >
                            Our quote is costly. Shared other options
                          </MenuItem>
                          <ListSubheader>Generic Response Group</ListSubheader>
                          <MenuItem value={"Yet to view quote"}>
                            Yet to view quote
                          </MenuItem>
                          <MenuItem value={"Will let you know tomorrow"}>
                            Will let you know tomorrow
                          </MenuItem>
                          <MenuItem value={"Will let you know"}>
                            Will let you know
                          </MenuItem>
                          <MenuItem value={"Will contact you on my own"}>
                            Will contact you on my own
                          </MenuItem>
                          <MenuItem value={"Need more time-client is positive"}>
                            Need more time-client is positive
                          </MenuItem>
                          <MenuItem value={"Will let you know within 2-3 days"}>
                            Will let you know within 2-3 days
                          </MenuItem>
                          <MenuItem value={"Will let you know within a week"}>
                            Will let you know within a week
                          </MenuItem>
                          <MenuItem value={"Asked to call later"}>
                            Asked to call later
                          </MenuItem>
                          <MenuItem
                            value={"Asked to call later after a few days"}
                          >
                            Asked to call later after a few days
                          </MenuItem>
                          <MenuItem value={"Asked to call later after a week"}>
                            Asked to call later after a week
                          </MenuItem>
                          <MenuItem value={"Asked to call at a specific time"}>
                            Asked to call at a specific time
                          </MenuItem>
                          <MenuItem value={"Extra attempt to be made"}>
                            Extra attempt to be made
                          </MenuItem>
                          <MenuItem value={"Budget issue. Will let us know"}>
                            Budget issue. Will let us know
                          </MenuItem>
                          <MenuItem value={"Discussion going on over WA"}>
                            Discussion going on over WA
                          </MenuItem>
                          //cancellation issue
                          <ListSubheader>Cancel Group</ListSubheader>
                          {/* <MenuItem value={"Asked to cancel-on call"}>
                Asked to cancel-on call
              </MenuItem> */}
                          <MenuItem value={"Already active with another SP"}>
                            Already active with another SP
                          </MenuItem>
                          <MenuItem
                            value={
                              "Unable to meet guest requirements on product"
                            }
                          >
                            Unable to meet guest requirements on product
                          </MenuItem>
                          <MenuItem
                            value={"No response after multiple follow ups"}
                          >
                            No response after multiple follow ups
                          </MenuItem>
                          {userdetails &&
                          userdetails.permissions.manual_cancellation ? (
                            <MenuItem value={"Booked Outside"}>
                              Booked Outside
                            </MenuItem>
                          ) : (
                            ""
                          )}
                          <ListSubheader>Postpone Group</ListSubheader>
                          <MenuItem
                            value={"Will call you back if we are interested"}
                          >
                            Will call you back if we are interested
                          </MenuItem>
                          <MenuItem value={"Plan on hold"}>
                            Plan on hold
                          </MenuItem>
                          <MenuItem value={"Asked to postpone"}>
                            Asked to postpone
                          </MenuItem>
                          <ListSubheader>Hot Group</ListSubheader>
                          <MenuItem
                            value={"Comparing packages with other agencies"}
                          >
                            Comparing packages with other agencies
                          </MenuItem>
                          <MenuItem
                            value={"Everything finalized. Awaiting payment"}
                          >
                            Everything finalized. Awaiting payment
                          </MenuItem>
                          <MenuItem
                            value={
                              "Okay with package. Will tell the final decision"
                            }
                          >
                            Okay with package. Will tell the final decision
                          </MenuItem>
                          <ListSubheader>Data Entry Group</ListSubheader>
                          <MenuItem value={"Data entry only"}>
                            Data entry only
                          </MenuItem>
                          <MenuItem value={"Data entry only - Msg sent"}>
                            Data entry only - Msg sent
                          </MenuItem>
                          <MenuItem value={"Call not needed. Msg dropped"}>
                            Call not needed. Msg dropped
                          </MenuItem>
                          <ListSubheader>Post Sales Group</ListSubheader>
                          {/* <MenuItem value={"Plan on hold"}>
                Plan on hold
              </MenuItem> */}
                          <MenuItem value={"Need to share voucher or tickets"}>
                            Need to share voucher or tickets
                          </MenuItem>
                          <MenuItem value={"Need to share insurance"}>
                            Need to share insurance
                          </MenuItem>
                          <MenuItem
                            value={"Need to confirm booking with supplier"}
                          >
                            Need to confirm booking with supplier
                          </MenuItem>
                          <MenuItem value={"Need to make payment to supplier"}>
                            Need to make payment to supplier
                          </MenuItem>
                          <MenuItem value={"Call later for feedback"}>
                            Call later for feedback
                          </MenuItem>
                        </Select>
                        <FormHelperText className={classes.red}>
                          Share new or revised quote before updating the trip
                        </FormHelperText>
                      </FormControl>
                      {userdetails && userdetails.permissions.override ? (
                        <FormControlLabel
                          control={<Checkbox color="primary" />}
                          checked={followupData.override}
                          label="Overide fup date?"
                          onChange={(e) =>
                            setfollowupData({
                              ...followupData,
                              override: e.target.checked,
                            })
                          }
                        />
                      ) : (
                        ""
                      )}

                      <Typography
                        className={classes.redheadtext}
                        align="center"
                        variant="h6"
                      >
                        {quotepending ? "Quote Pending" : ""}
                      </Typography>
                    </FormGroup>
                  ) : (
                    <FormGroup row className={classes.formgroup}>
                      <FormControl
                        style={{
                          minWidth: 480,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="fupautonote">Canned Notes</InputLabel>
                        <Select
                          className={classes.textField}
                          labelId="fupautonote"
                          required={
                            role == "Admin" ||
                            role == "Operations" ||
                            role == "Operations-TL" ||
                            role == "Product"
                              ? 0
                              : oldstatus == "Converted" ||
                                  oldstatus == "Cancelled" ||
                                  oldstatus == "Closed" ||
                                  oldstatus == "Booked Outside" ||
                                  oldstatus == "Dropped After Booking"
                                ? 0
                                : 1
                          }
                          onChange={(e) => changecannednotes(e)}
                        >
                          <ListSubheader>No Response Group</ListSubheader>
                          <MenuItem value={"Call not picked"}>
                            Call not picked
                          </MenuItem>
                          <MenuItem value={"Call disconnected by client"}>
                            Call disconnected by client
                          </MenuItem>
                          <MenuItem value={"Call not picked. WA sent"}>
                            Call not picked. WA sent
                          </MenuItem>
                          <MenuItem
                            value={
                              "Call not picked and no response on Whatsapp"
                            }
                          >
                            Call not picked and no response on Whatsapp
                          </MenuItem>
                          {/* <MenuItem value={"No response after multiple follow ups"}>
                No response after multiple follow ups
              </MenuItem> */}
                          <ListSubheader>
                            First or Revised Quote Group
                          </ListSubheader>
                          <MenuItem
                            value={
                              "Asked to add flights. Shared quote with flights"
                            }
                          >
                            Asked to add flights. Shared quote with flights
                          </MenuItem>
                          <MenuItem value={"Need to share first quote"}>
                            Need to share first quote
                          </MenuItem>
                          <MenuItem value={"Quote shared"}>
                            Quote shared
                          </MenuItem>
                          <MenuItem value={"Waiting for rates"}>
                            Waiting for rates
                          </MenuItem>
                          <MenuItem
                            value={"Need changes. Need to share updated quote"}
                          >
                            Need changes. Need to share updated quote
                          </MenuItem>
                          <MenuItem
                            value={"Needed changes. Shared updated quote"}
                          >
                            Needed changes. Shared updated quote
                          </MenuItem>
                          <MenuItem
                            value={"Budget issue. Shared other options"}
                          >
                            Budget issue. Shared other options
                          </MenuItem>
                          <MenuItem
                            value={"Our quote is costly. Shared other options"}
                          >
                            Our quote is costly. Shared other options
                          </MenuItem>
                          <ListSubheader>Generic Response Group</ListSubheader>
                          <MenuItem value={"Yet to view quote"}>
                            Yet to view quote
                          </MenuItem>
                          <MenuItem value={"Will let you know tomorrow"}>
                            Will let you know tomorrow
                          </MenuItem>
                          <MenuItem value={"Will let you know"}>
                            Will let you know
                          </MenuItem>
                          <MenuItem value={"Will contact you on my own"}>
                            Will contact you on my own
                          </MenuItem>
                          <MenuItem value={"Need more time-client is positive"}>
                            Need more time-client is positive
                          </MenuItem>
                          <MenuItem value={"Will let you know within 2-3 days"}>
                            Will let you know within 2-3 days
                          </MenuItem>
                          <MenuItem value={"Will let you know within a week"}>
                            Will let you know within a week
                          </MenuItem>
                          <MenuItem value={"Asked to call later"}>
                            Asked to call later
                          </MenuItem>
                          <MenuItem
                            value={"Asked to call later after a few days"}
                          >
                            Asked to call later after a few days
                          </MenuItem>
                          <MenuItem value={"Asked to call later after a week"}>
                            Asked to call later after a week
                          </MenuItem>
                          <MenuItem value={"Asked to call at a specific time"}>
                            Asked to call at a specific time
                          </MenuItem>
                          <MenuItem value={"Extra attempt to be made"}>
                            Extra attempt to be made
                          </MenuItem>
                          <MenuItem value={"Budget issue. Will let us know"}>
                            Budget issue. Will let us know
                          </MenuItem>
                          <MenuItem value={"Discussion going on over WA"}>
                            Discussion going on over WA
                          </MenuItem>
                          {/* <ListSubheader>Cancel Group</ListSubheader> 
              <MenuItem value={"Asked to cancel-on call"}>
                Asked to cancel-on call
              </MenuItem>
              <MenuItem value={"Asked to cancel-on whatsapp"}>
                Asked to cancel-on whatsapp
              </MenuItem>
              <MenuItem value={"Unable to meet guest requirements on product"}>
              Unable to meet guest requirements on product
              </MenuItem>
              <MenuItem value={"No response after multiple follow ups"}>
                No response after multiple follow ups
              </MenuItem>
              <MenuItem value={"Booked Outside"}>
                Booked Outside
              </MenuItem> */}

                          <ListSubheader>Postpone Group</ListSubheader>
                          <MenuItem
                            value={"Will call you back if we are interested"}
                          >
                            Will call you back if we are interested
                          </MenuItem>
                          <MenuItem value={"Plan on hold"}>
                            Plan on hold
                          </MenuItem>
                          <MenuItem value={"Asked to postpone"}>
                            Asked to postpone
                          </MenuItem>
                          <ListSubheader>Hot Group</ListSubheader>
                          <MenuItem
                            value={"Comparing packages with other agencies"}
                          >
                            Comparing packages with other agencies
                          </MenuItem>
                          <MenuItem
                            value={"Everything finalized. Awaiting payment"}
                          >
                            Everything finalized. Awaiting payment
                          </MenuItem>
                          <MenuItem
                            value={
                              "Okay with package. Will tell the final decision"
                            }
                          >
                            Okay with package. Will tell the final decision
                          </MenuItem>
                          <ListSubheader>Data Entry Group</ListSubheader>
                          <MenuItem value={"Data entry only"}>
                            Data entry only
                          </MenuItem>
                          <MenuItem value={"Data entry only - Msg sent"}>
                            Data entry only - Msg sent
                          </MenuItem>
                          <MenuItem value={"Call not needed. Msg dropped"}>
                            Call not needed. Msg dropped
                          </MenuItem>

                          <ListSubheader>Post Sales Group</ListSubheader>
                          {/* <MenuItem value={"Plan on hold"}>
                Plan on hold
              </MenuItem> */}
                          <MenuItem value={"Need to share voucher or tickets"}>
                            Need to share voucher or tickets
                          </MenuItem>
                          <MenuItem value={"Need to share insurance"}>
                            Need to share insurance
                          </MenuItem>
                          <MenuItem
                            value={"Need to confirm booking with supplier"}
                          >
                            Need to confirm booking with supplier
                          </MenuItem>
                          <MenuItem value={"Need to make payment to supplier"}>
                            Need to make payment to supplier
                          </MenuItem>
                          <MenuItem value={"Call later for feedback"}>
                            Call later for feedback
                          </MenuItem>
                        </Select>
                        <FormHelperText className={classes.red}>
                          Share new or revised quote before updating the trip
                        </FormHelperText>
                      </FormControl>
                      {userdetails && userdetails.permissions.override ? (
                        <FormControlLabel
                          control={<Checkbox color="primary" />}
                          checked={followupData.override}
                          label="Override fup date?"
                          onChange={(e) =>
                            setfollowupData({
                              ...followupData,
                              override: true,
                            })
                          }
                        />
                      ) : (
                        ""
                      )}

                      <Typography
                        className={classes.redheadtext}
                        align="center"
                        variant="h6"
                      >
                        {quotepending ? "Quote Pending" : ""}
                      </Typography>
                    </FormGroup>
                  )}
                </div>
              )}

              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="status">Followup Status</InputLabel>
                  <Select
                    defaultValue="Open"
                    disabled
                    className={classes.textField}
                    labelId="status"
                    required
                    onChange={(e) =>
                      setfollowupData({
                        ...followupData,
                        status: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Open"}>Open</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="fuptype">Followup Type</InputLabel>
                  <Select
                    className={classes.textField}
                    labelId="fuptype"
                    required={
                      tripData.trip_status == "Closed" ||
                      tripData.trip_status == "Cancelled" ||
                      tripData.trip_status == "Converted" ||
                      tripData.trip_status == "Booked Outside" ||
                      tripData.trip_status == "Dropped After Booking"
                        ? null
                        : 1
                    }
                    onChange={(e) =>
                      setfollowupData({
                        ...followupData,
                        fuptype: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Share first quote"}>
                      Share first quote
                    </MenuItem>
                    <MenuItem value={"Share revised quote"}>
                      Share revised quote
                    </MenuItem>
                    <MenuItem value={"Quote feedback"}>Quote feedback</MenuItem>
                    <MenuItem value={"Ask for payment"}>
                      Ask for payment
                    </MenuItem>
                    <MenuItem value={"Voucher or Confirmation pending"}>
                      Voucher or Confirmation pending
                    </MenuItem>
                    <MenuItem value={"Trip Feedback"}>Trip Feedback</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              {"competition" in tripData && tripData.competition ? (
                <div align="center">
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    disabled
                    checked={tripData.competition}
                    label="Facing Competition"
                  />
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="comtype">Competition Type</InputLabel>
                    <Select
                      className={classes.textField}
                      labelId="comtype"
                      value={tripData.competition_from}
                      required={
                        "competition" in tripData && tripData.competition
                          ? 1
                          : 0
                      }
                      onChange={(e) =>
                        settripData({
                          ...tripData,
                          competition_from: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={"DIY"}>DIY</MenuItem>
                      <MenuItem value={"Local Destination Agent"}>
                        Local Destination Agent
                      </MenuItem>
                      <MenuItem value={"Branded TA"}>Branded TA</MenuItem>
                      <MenuItem value={"Small TA"}>Small TA</MenuItem>
                      <MenuItem value={"Similar TA"}>Similar TA</MenuItem>
                      <MenuItem value={"Large OTA"}>Large OTA</MenuItem>
                      <MenuItem value={"Multiple companies"}>
                        Multiple companies
                      </MenuItem>
                      <MenuItem value={"Others"}>Others</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="comstatus">Competition Status</InputLabel>
                    <Select
                      className={classes.textField}
                      labelId="comstatus"
                      value={tripData.competition_status}
                      required={
                        "competition" in tripData && tripData.competition
                          ? 1
                          : 0
                      }
                      onChange={(e) =>
                        settripData({
                          ...tripData,
                          competition_status: e.target.value,
                        })
                      }
                    >
                      <MenuItem
                        value={"Client claims but denied sharing proof"}
                      >
                        Client claims but denied sharing proof
                      </MenuItem>
                      <MenuItem value={"Client claims and will share proof"}>
                        Client claims and will share proof
                      </MenuItem>
                      <MenuItem
                        value={"Proof shared but does not seem genuine"}
                      >
                        Proof shared but does not seem genuine
                      </MenuItem>
                      <MenuItem value={"Proof shared and genuine"}>
                        Proof shared and genuine
                      </MenuItem>
                      <MenuItem value={"NA"}>NA</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              ) : (
                <div>
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    checked={tripData.competition}
                    label="Facing Competition"
                    onChange={(e) => competition(e)}
                  />
                </div>
              )}

              {followupData.override ? (
                <FormGroup row className={classes.formgroup}>
                  <TextField
                    variant="standard"
                    //disabled={followupData.override?0:1}
                    required={
                      tripData.trip_status == "Closed" ||
                      tripData.trip_status == "Cancelled" ||
                      tripData.trip_status == "Converted" ||
                      tripData.trip_status == "Booked Outside" ||
                      tripData.trip_status == "Dropped After Booking"
                        ? null
                        : 1
                    }
                    value={followupData.date}
                    type="date"
                    inputProps={
                      tripData.trip_status == "Hot" ||
                      ("lead" in tripData &&
                        "potential" in tripData.lead &&
                        tripData.lead.potential == true)
                        ? { min: fupfinalDate }
                        : (new Date(
                              tripData.follow_up[tripData.follow_up.length - 1]
                                .date,
                            ).getTime() <= new Date().getTime() &&
                              tripData.follow_up[tripData.follow_up.length - 1]
                                .time == "12:30") ||
                            (new Date(
                              tripData.follow_up[tripData.follow_up.length - 1]
                                .date,
                            ).getTime() < new Date().getTime() &&
                              tripData.follow_up[tripData.follow_up.length - 1]
                                .time == "12:00")
                          ? { max: fupfinalDate }
                          : { min: fupfinalDate }
                    }
                    label="Followup Date"
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setfollowupData({
                        ...followupData,
                        date: e.target.value,
                        new_date: new Date(e.target.value),
                      })
                    }
                  />
                  <TextField
                    variant="standard"
                    //disabled={followupData.override?0:1}
                    required={
                      tripData.trip_status == "Closed" ||
                      tripData.trip_status == "Cancelled" ||
                      tripData.trip_status == "Converted" ||
                      tripData.trip_status == "Booked Outside" ||
                      tripData.trip_status == "Dropped After Booking"
                        ? null
                        : 1
                    }
                    value={followupData.time}
                    type="time"
                    label="Followup Time"
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setfollowupData({ ...followupData, time: e.target.value })
                    }
                  />
                </FormGroup>
              ) : (
                <Typography
                  variant="h6"
                  align="center"
                  className={classes.headertext}
                >
                  Next follow up set on {followupData.date} at{" "}
                  {followupData.time}{" "}
                </Typography>
              )}

              <FormGroup row className={classes.formgroup}>
                <TextField
                  variant="outlined"
                  label="Notes"
                  required={
                    tripData.trip_status == "Closed" ||
                    tripData.trip_status == "Cancelled" ||
                    tripData.trip_status == "Converted" ||
                    tripData.trip_status == "Booked Outside" ||
                    tripData.trip_status == "Dropped After Booking"
                      ? null
                      : 1
                  }
                  className={classes.textArea}
                  value={followupData.notes}
                  fullWidth
                  multiline
                  rows={2}
                  onChange={(e) =>
                    setfollowupData({ ...followupData, notes: e.target.value })
                  }
                />
              </FormGroup>
              {tripData.trip_status == "Cancelled" ||
              followupData.fupautonote == "Asked to cancel-on call" ||
              followupData.fupautonote == "Asked to cancel-on whatsapp" ||
              followupData.fupautonote ==
                "System fup - WA msg sent -Asked to cancel-on call" ||
              followupData.fupautonote ==
                "System fup - WA msg sent -Asked to cancel-on whatsapp" ? (
                <FormGroup row className={classes.formgroup}>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 64,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="canc_reason">
                      Cancellation Classification
                    </InputLabel>
                    <Select
                      classname={classes.textField}
                      required={
                        tripData.trip_status == "Booked Outside" ||
                        followupData.fupautonote == "Asked to cancel-on call" ||
                        followupData.fupautonote ==
                          "Asked to cancel-on whatsapp" ||
                        followupData.fupautonote ==
                          " System fup - WA msg sent -Asked to cancel-on call" ||
                        followupData.fupautonote ==
                          " System fup - WA msg sent -Asked to cancel-on whatsapp"
                          ? 1
                          : 0
                      }
                      labelId="canc_reason"
                      value={
                        tripData.trip_canc_reason_short
                          ? tripData.trip_canc_reason_short
                          : ""
                      }
                      onChange={(e) =>
                        settripData({
                          ...tripData,
                          trip_canc_reason_short: e.target.value,
                        })
                      }
                    >
                      <MenuItem
                        value={"Said planned cancelled - reason not given"}
                      >
                        Said planned cancelled - reason not given
                      </MenuItem>
                      <MenuItem value={"Said planned cancelled - reason given"}>
                        Said planned cancelled - reason given
                      </MenuItem>
                      <MenuItem
                        value={"Said planned cancelled - will contact later"}
                      >
                        Said planned cancelled - will contact later
                      </MenuItem>
                      <MenuItem value={"Demand cannot be met"}>
                        Demand cannot be met
                      </MenuItem>
                      <MenuItem value={"Duplicate"}>Duplicate</MenuItem>
                      <MenuItem value={"No budget"}>No budget</MenuItem>
                      <MenuItem value={"Others"}>Others</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    variant="outlined"
                    label="CancNotes"
                    required={
                      tripData.trip_status == "Cancelled" ||
                      tripData.trip_status == "Booked Outside" ||
                      followupData.fupautonote == "Asked to cancel-on call" ||
                      followupData.fupautonote ==
                        "Asked to cancel-on whatsapp" ||
                      followupData.fupautonote ==
                        " System fup - WA msg sent -Asked to cancel-on call" ||
                      followupData.fupautonote ==
                        " System fup - WA msg sent -Asked to cancel-on whatsapp"
                        ? 1
                        : 0
                    }
                    className={classes.textArea}
                    value={
                      tripData.trip_canc_reason ? tripData.trip_canc_reason : ""
                    }
                    fullWidth
                    rows={2}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        trip_canc_reason: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div align="center">
              <br></br>
              <Typography variant="h4">
                New fup creation criteria not met
              </Typography>
              <Button
                onClick={skipfupcall}
                variant="contained"
                color="primary"
                className={classes.smallbutton}
              >
                <h6>Skip Call</h6>
              </Button>
            </div>
          )}

          {tripData.trip_status == "Converted" ||
          tripData.trip_status == "Closed" ? (
            <div>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Post Sales
              </Typography>
              {("tcs_mail" in tripData && tripData.tcs_mail) ||
              ("no_tcs" in tripData && tripData.no_tcs) ||
              ("no_tax" in tripData && tripData.no_tax) ||
              ("only_flight" in tripData && tripData.only_flight) ||
              !identifydest(tripData.primary_destination) ? (
                <div>
                  <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Flight Ticket">Flight Ticket</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Flight Ticket"
                        value={tripData.flight_ticket}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            flight_ticket: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Hotel Voucher">Hotel Voucher</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Hotel Voucher"
                        value={tripData.hotel_voucher}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            hotel_voucher: e.target.value,
                          })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Land Voucher">Land Voucher</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Hotel Voucher"
                        value={tripData.land_voucher}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            land_voucher: e.target.value,
                          })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Visa">Visa</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Visa"
                        value={tripData.visa}
                        onChange={(e) =>
                          settripData({ ...tripData, visa: e.target.value })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CheckIn"> Flight CheckIn</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CheckIn"
                        value={tripData.check_in}
                        onChange={(e) =>
                          settripData({ ...tripData, check_in: e.target.value })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Travel Insurance">
                        Travel Insurance
                      </InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Travel Insurance"
                        value={tripData.travel_insurance}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            travel_insurance: e.target.value,
                          })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                </div>
              ) : (
                <div>
                  <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Flight Ticket">Flight Ticket</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Flight Ticket"
                        value={tripData.flight_ticket}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            flight_ticket: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Hotel Voucher">Hotel Voucher</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Hotel Voucher"
                        value={tripData.hotel_voucher}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            hotel_voucher: e.target.value,
                          })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Land Voucher">Land Voucher</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Hotel Voucher"
                        value={tripData.land_voucher}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            land_voucher: e.target.value,
                          })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Visa">Visa</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Visa"
                        value={tripData.visa}
                        onChange={(e) =>
                          settripData({ ...tripData, visa: e.target.value })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CheckIn"> Flight CheckIn</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CheckIn"
                        value={tripData.check_in}
                        onChange={(e) =>
                          settripData({ ...tripData, check_in: e.target.value })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="Travel Insurance">
                        Travel Insurance
                      </InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="Travel Insurance"
                        value={tripData.travel_insurance}
                        onChange={(e) =>
                          settripData({
                            ...tripData,
                            travel_insurance: e.target.value,
                          })
                        }
                        // disabled={"tcs_mail" in tripData && tripData.tcs_mail?0:1}
                      >
                        <MenuItem value={"No"}>No</MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                        <MenuItem value={"NR"}>NR</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                </div>
              )}

              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="Vacationlist">Vacation List</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="Vacationlist"
                    value={tripData.vacation_list}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        vacation_list: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"NA"}>NA</MenuItem>
                    <MenuItem value={"NR"}>NR</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="helpdoc">Help Doc</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="helpdoc"
                    value={tripData.help_doc}
                    onChange={(e) =>
                      settripData({ ...tripData, help_doc: e.target.value })
                    }
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"NA"}>NA</MenuItem>
                    <MenuItem value={"NR"}>NR</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="flightstaus">Flight Status</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="flightstaus"
                    value={tripData.flight_status}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        flight_status: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"NA"}>NA</MenuItem>
                    <MenuItem value={"NR"}>NR</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen17(true)}
                  className={classes.button}
                >
                  Driver Number
                </Button>

                <TextField
                  variant="outlined"
                  label="Driver Name"
                  value={tripData.driver_name}
                  className={classes.textField}
                  onChange={(e) =>
                    settripData({ ...tripData, driver_name: e.target.value })
                  }
                />
                <TextField
                  variant="outlined"
                  label="Driver Contact"
                  value={tripData.driver_contact}
                  className={classes.textField}
                  onChange={(e) =>
                    settripData({ ...tripData, driver_contact: e.target.value })
                  }
                />
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <TextField
                  variant="outlined"
                  label="Post Sales Notes"
                  value={tripData.post_sales_notes}
                  className={classes.textArea}
                  fullWidth
                  multiline
                  rows={8}
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      post_sales_notes: e.target.value,
                    })
                  }
                />
              </FormGroup>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Trip Review
              </Typography>
              {cuser == "Debayan" ? (
                <FormControlLabel
                  control={
                    <Switch
                      checked={tripData.trip_review_show}
                      onChange={handleChange2}
                      color="secondary"
                    />
                  }
                  label="Publish Review?"
                />
              ) : (
                ""
              )}
              {cuser && cuser=="Purushotam" || cuser=="Kaushal" || role=="Admin"?(
              <div>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="Trip Review Score">
                    Trip Review Score
                  </InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="Trip Review Score"
                    value={tripData.trip_review_score}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        trip_review_score: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                  </Select>
                </FormControl>

                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="Trip Review Source">
                    Trip Review Source
                  </InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="Trip Review Source"
                    value={tripData.trip_review_source}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        trip_review_source: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={"Google"}>Google</MenuItem>
                    <MenuItem value={"Facebook"}>Facebook</MenuItem>
                    <MenuItem value={"TripCrafters"}>TripCrafters</MenuItem>
                    <MenuItem value={"TripClap"}>TripClap</MenuItem>
                    <MenuItem value={"PayTM"}>PayTM</MenuItem>
                    <MenuItem value={"Whatsapp"}>Whatsapp</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <TextField
                  variant="standard"
                  type="date"
                  label={"Review Date"}
                  disabled={role == "Sales" || role == "SME" ? 1 : 0}
                  InputLabelProps={{ shrink: true }}
                  value={(tripData.trip_review_date === undefined
                    ? ""
                    : tripData.trip_review_date.split("T")
                  ).slice(0, 1)}
                  className={classes.textField3}
                  defaultValue="2023-01-01"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      trip_review_date: e.target.value,
                    })
                  }
                />
                <TextField
                  variant="standard"
                  label={"Customer location"}
                  disabled={role == "Sales" || role == "SME" ? 1 : 0}
                  required={
                    (role == "Operations" || role == "Support") &&
                    tripData.trip_status == "Converted"
                      ? 1
                      : 0
                  }
                  InputLabelProps={{ shrink: true }}
                  value={tripData.trip_review_location}
                  className={classes.textField3}
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      trip_review_location: e.target.value,
                    })
                  }
                />
              </FormGroup>
              <TextField
                variant="outlined"
                label="Trip Review"
                className={classes.textArea}
                value={tripData.trip_review}
                fullWidth
                multiline
                rows={2}
                onChange={(e) =>
                  settripData({ ...tripData, trip_review: e.target.value })
                }
              />
              </div>
                ):("")}
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Internal Review Data
              </Typography>
              
                <div>
              <br></br>
              {cuser && cuser=="Purushotam" || cuser=="Kaushal" || role=="Admin"?(
                <div>
              <FormGroup row className={classes.formgroup}>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="PS Score">Post Sales Score</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="Post Sales Score"
                    value={tripData.post_sales_score}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        post_sales_score: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="PT Score">Post Trip Score</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="Post Trip Score"
                    value={tripData.post_trip_score}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        post_trip_score: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{
                    minWidth: 240,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="RA">Review Attempts</InputLabel>
                  <Select
                    classname={classes.textField}
                    labelId="Review Attempts"
                    value={tripData.review_attempts}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        review_attempts: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={-1}>-1</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>
              <TextField
                variant="outlined"
                label="Customer Comment"
                className={classes.textArea2}
                value={tripData.review_comment}
                multiline
                rows={2}
                onChange={(e) =>
                  settripData({ ...tripData, review_comment: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                label="Review Analysis"
                className={classes.textArea2}
                value={tripData.review_analysis}
                multiline
                rows={2}
                onChange={(e) =>
                  settripData({ ...tripData, review_analysis: e.target.value })
                }
              />
              </div>):("")}
              <br></br>
              <br></br>
              <FormGroup row className={classes.formgroup}>
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_hotel_issue}
                  label="Hotel Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_hotel_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_land_issue}
                  label="Land Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_land_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_supplier_issue}
                  label="Supplier Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_supplier_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_expectation_issue}
                  label="Expectation Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_expectation_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_outside_issue}
                  label="External Factor"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_outside_issue: e.target.checked,
                    })
                  }
                />
              </FormGroup>
              <FormGroup row className={classes.formgroup}>
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_sales_issue}
                  label="Sales Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_sales_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_support_issue}
                  label="Support Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_support_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_ops_issue}
                  label="Operations Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_ops_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_knowledge_issue}
                  label="Knowledge Issue"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_knowledge_issue: e.target.checked,
                    })
                  }
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  checked={tripData.review_communication_issue}
                  label="Communication Gap"
                  onChange={(e) =>
                    settripData({
                      ...tripData,
                      review_communication_issue: e.target.checked,
                    })
                  }
                />
              </FormGroup>
              <br></br>
              <br></br>
              {hotelData.length > 0 &&
              "review_hotel_issue" in tripData &&
              tripData.review_hotel_issue ? (
                <FormControl
                  style={{
                    minWidth: 480,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 8,
                  }}
                >
                  <InputLabel id="hotel name">Hotel Name</InputLabel>
                  <Select
                    
                    classname={classes.textField}
                    labelId="hotel name"
                    value={tripData.review_hotel_name}
                    onChange={(e) =>
                      settripData({
                        ...tripData,
                        review_hotel_name: e.target.value,
                      })
                    }
                  >
                    {hotelData.map((hotel) => {
                      return (
                        <MenuItem
                          value={hotel.hotel_name}
                          classname={classes.textField}
                        >
                          {hotel.hotel_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              ) : (
                ""
              )}
              </div>
              
              {role == "Product" || role == "Admin" || role == "Manager" ? (
                <div>
                  <TextField
                    variant="outlined"
                    label="Manager Note"
                    className={classes.textArea2}
                    value={tripData.review_comment}
                    multiline
                    rows={2}
                    onChange={(e) =>
                      settripData({ ...tripData, manager_note: e.target.value })
                    }
                  />
                  <TextField
                    variant="outlined"
                    label="RCA"
                    className={classes.textArea2}
                    value={tripData.rca}
                    multiline
                    rows={2}
                    onChange={(e) =>
                      settripData({ ...tripData, rca: e.target.value })
                    }
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}

          <FormGroup row className={classes.formgroup}>
            {showsave ? (
              <Button
                variant="contained"
                color="primary"
                // type="submit"
                onClick={preventDoubleClick(handleSubmit)}
                className={classes.button}
              >
                Save
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                onClick={sendcancelmsg}
                className={classes.button}
              >
                Send Cancel
              </Button>
            )}
            <Button
              href={"/custdataentry/" + tripData.cust_id}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Cancel
            </Button>
            {role!=="Admin" && (tripData.trip_status == "Converted" ||
              tripData.trip_status == "Active" ||
              tripData.trip_status == "New" ||
              tripData.trip_status == "Hot") ? (
              <div>
                {/* <Button
                href={"/duptripentry"}
                variant="contained"
                color="primary"
                className={classes.button}
              >
                Duplicate Trip
              </Button> */}
                <Button
                  href={"/quotedataentry"}
                  variant="contained"
                  color="inherit"
                  className={classes.button}
                >
                  Create Quote
                </Button>
                {!rbq ? (
                  <Button
                    href={"/reusequote"}
                    variant="contained"
                    color="inherit"
                    className={classes.button}
                  >
                    Re-use Quote
                  </Button>
                ) : (
                  <div>
                    <Button
                      href={"/reusequote"}
                      variant="contained"
                      color="inherit"
                      className={classes.button}
                    >
                      Re-use Quote
                    </Button>
                    <Button
                      href={"/productbased"}
                      variant="contained"
                      color="inherit"
                      className={classes.button}
                    >
                      RBQ
                    </Button>
                  </div>
                )}

                <Button
                  onClick={dialogopen}
                  variant="outlined"
                  color="inherit"
                  className={classes.button}
                >
                  Quote Numbers
                </Button>
              </div>
            ) : (
              ""
            )}
            {tripData.trip_status == "Converted" ||
            tripData.trip_status == "Closed" ||
            tripData.trip_status == "Hot" ||
            tripData.trip_status == "Dropped After Booking" ? (
              tripData.cust_payments?.length !== 0 ? (
                <Button
                  href={"/tripdataentry/" + tripData.trip_id + "/paymentupdate"}
                  variant="contained"
                  color={
                    tripData.trip_status == "Closed" ||
                    tripData.trip_status == "Converted" ||
                    tripData.trip_status == "Hot" ||
                    tripData.trip_status == "Dropped After Booking"
                      ? "primary"
                      : "inherit"
                  }
                  className={classes.button}
                >
                  {" "}
                  Update Payment
                </Button>
              ) : (
                <Button
                  href={"/tripdataentry/" + tripData.trip_id + "/payments"}
                  variant="contained"
                  color={
                    tripData.trip_status == "Closed" ||
                    tripData.trip_status == "Converted" ||
                    tripData.trip_status == "Hot" ||
                    tripData.trip_status == "Dropped After Booking"
                      ? "primary"
                      : "inherit"
                  }
                  className={classes.button}
                >
                  {" "}
                  Create Payment
                </Button>
              )
            ) : (
              ""
            )}
          </FormGroup>
        </form>
        {role == "Support" ||
        role == "Admin" ||
        role == "Operations" ||
        role == "Product" ||
        role == "Operations-TL" ||
        role == "Manager" ? (<div>
          <p>
            Referral Link:{" "}
            {"https://www.jetovacations.com/quoterequestref/REFBY=" +
              tripData.cust_name +
              tripData.trip_id}
          </p>
          <p>{tripData.bo_reason}</p>
          </div>
        ) : (
          ""
        )}
      </Paper>
      <Dialog fullWidth maxWidth="xl" open={Open11} onClose={handleClose12}>
        {insight ? (
          <div>
            <h3>&nbsp;&nbsp;&nbsp;Summary:</h3>
            <p>{insight.summary}</p>
            <br></br>
            <hr></hr>
            <br></br>
            <h3>&nbsp;&nbsp;&nbsp;Transcript:</h3>
            <br></br>
            <p>{insight.transcript}</p>
          </div>
        ) : (
          ""
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          className={classes.button}
        >
          Save
        </Button>
      </Dialog>
      <Dialog fullWidth maxWidth="xl" open={Open15} onClose={handleClose15}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Reconfirm Details
        </Typography>
        <BlinkingText variant="h3">
          {
            "If any of these details are found to be wrong, it will be considered as Tier I offence and penalty will be charged as per policy starting from Rs. 500"
          }
        </BlinkingText>
        <TextField
          variant="standard"
          label="Email"
          value={reconfirm.primary_email_id}
          className={classes.textField4}
          onChange={(e) =>
            setreconfirm({ ...reconfirm, primary_email_id: e.target.value })
          }
        />
        <FormGroup row className={classes.formgroup}>
          <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Adults"># Adults (number)</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Adults"
              value={reconfirm.number_adults}
              onChange={(e) =>
                setreconfirm({ ...reconfirm, number_adults: e.target.value })
              }
            >
              <MenuItem value={1}>1 </MenuItem>
              <MenuItem value={2}>2 </MenuItem>
              <MenuItem value={3}>3 </MenuItem>
              <MenuItem value={4}>4 </MenuItem>
              <MenuItem value={5}>5 </MenuItem>
              <MenuItem value={6}>6 </MenuItem>
              <MenuItem value={7}>7 </MenuItem>
              <MenuItem value={8}>8 </MenuItem>
              <MenuItem value={9}>9 </MenuItem>
              <MenuItem value={10}>10 </MenuItem>
              <MenuItem value={11}>11 </MenuItem>
              <MenuItem value={12}>12 </MenuItem>
              <MenuItem value={13}>13 </MenuItem>
              <MenuItem value={14}>14 </MenuItem>
              <MenuItem value={15}>15 </MenuItem>
              <MenuItem value={16}>16 </MenuItem>
              <MenuItem value={17}>17 </MenuItem>
              <MenuItem value={18}>18 </MenuItem>
              <MenuItem value={19}>19 </MenuItem>
              <MenuItem value={20}>20 </MenuItem>
              <MenuItem value={21}>21 </MenuItem>
              <MenuItem value={22}>22 </MenuItem>
              <MenuItem value={23}>23 </MenuItem>
              <MenuItem value={24}>24 </MenuItem>
              <MenuItem value={25}>25 </MenuItem>
              <MenuItem value={26}>26 </MenuItem>
              <MenuItem value={27}>27 </MenuItem>
              <MenuItem value={28}>28 </MenuItem>
              <MenuItem value={29}>29 </MenuItem>
              <MenuItem value={30}>30 </MenuItem>
              <MenuItem value={31}>31 </MenuItem>
              <MenuItem value={32}>32 </MenuItem>
              <MenuItem value={33}>33 </MenuItem>
              <MenuItem value={34}>34 </MenuItem>
              <MenuItem value={35}>35 </MenuItem>
              <MenuItem value={36}>36 </MenuItem>
              <MenuItem value={37}>37 </MenuItem>
              <MenuItem value={38}>38 </MenuItem>
              <MenuItem value={39}>39 </MenuItem>
              <MenuItem value={40}>40 </MenuItem>
              <MenuItem value={41}>41 </MenuItem>
              <MenuItem value={42}>42 </MenuItem>
              <MenuItem value={43}>43 </MenuItem>
              <MenuItem value={44}>44 </MenuItem>
              <MenuItem value={45}>45 </MenuItem>
              <MenuItem value={46}>46 </MenuItem>
              <MenuItem value={47}>47 </MenuItem>
              <MenuItem value={48}>48 </MenuItem>
              <MenuItem value={49}>49 </MenuItem>
              <MenuItem value={50}>50 </MenuItem>
              <MenuItem value={51}>51 </MenuItem>
              <MenuItem value={52}>52 </MenuItem>
              <MenuItem value={53}>53 </MenuItem>
              <MenuItem value={54}>54 </MenuItem>
              <MenuItem value={55}>55 </MenuItem>
              <MenuItem value={56}>56 </MenuItem>
              <MenuItem value={57}>57 </MenuItem>
              <MenuItem value={58}>58 </MenuItem>
              <MenuItem value={59}>59 </MenuItem>
              <MenuItem value={60}>60 </MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Child"># Child/Infant (number)</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Child"
              value={reconfirm.number_child}
              onChange={(e) =>
                setreconfirm({ ...reconfirm, number_child: e.target.value })
              }
            >
              <MenuItem value={0}>0 </MenuItem>
              <MenuItem value={1}>1 </MenuItem>
              <MenuItem value={2}>2 </MenuItem>
              <MenuItem value={3}>3 </MenuItem>
              <MenuItem value={4}>4 </MenuItem>
              <MenuItem value={5}>5 </MenuItem>
              <MenuItem value={6}>6 </MenuItem>
              <MenuItem value={7}>7 </MenuItem>
              <MenuItem value={8}>8 </MenuItem>
              <MenuItem value={9}>9 </MenuItem>
              <MenuItem value={10}>10 </MenuItem>
              <MenuItem value={11}>11 </MenuItem>
              <MenuItem value={12}>12 </MenuItem>
              <MenuItem value={13}>13 </MenuItem>
              <MenuItem value={14}>14 </MenuItem>
              <MenuItem value={15}>15 </MenuItem>
              <MenuItem value={16}>16 </MenuItem>
              <MenuItem value={17}>17 </MenuItem>
              <MenuItem value={18}>18 </MenuItem>
              <MenuItem value={19}>19 </MenuItem>
              <MenuItem value={20}>20 </MenuItem>
            </Select>
          </FormControl>
          <TextField
            variant="standard"
            label="Total Pax"
            value={reconfirm.number_adults + reconfirm.number_child}
            className={classes.textField4}
            disabled
          />
          <TextField
            required={
              "number_child" in reconfirm && reconfirm.number_child > 0 ? 1 : 0
            }
            variant="standard"
            label={"Child Age"}
            helperText={"Enter child age separated by commas"}
            InputLabelProps={{ shrink: true }}
            value={reconfirm.child_age}
            className={classes.textField4}
            onChange={(e) =>
              setreconfirm({ ...reconfirm, child_age: e.target.value })
            }
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="outlined"
            label="Merge Ids"
            className={classes.textField}
            value={reconfirm.merge_trips ? reconfirm.merge_trips : ""}
            helperText={"Write other trip ids separated by commas"}
            onChange={(e) =>
              setreconfirm({ ...reconfirm, merge_trips: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Duration">Duration (number)</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Duration"
              value={reconfirm.duration}
              onChange={(e) =>
                setreconfirm({ ...reconfirm, duration: e.target.value })
              }
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={6}>6</MenuItem>
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={11}>11</MenuItem>
              <MenuItem value={12}>12</MenuItem>
              <MenuItem value={13}>13</MenuItem>
              <MenuItem value={14}>14</MenuItem>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={16}>16</MenuItem>
              <MenuItem value={17}>17</MenuItem>
              <MenuItem value={18}>18</MenuItem>
              <MenuItem value={19}>19</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
          <TextField
            required
            variant="standard"
            type="date"
            label={"Start Date"}
            inputProps={{ min: fupfinalDate2 }}
            helperText={"Time to travel: " + ttt + " Days"}
            InputLabelProps={{ shrink: true }}
            value={(reconfirm.trip_start_date === undefined
              ? ""
              : reconfirm.trip_start_date.split("T")
            ).slice(0, 1)}
            className={classes.textField3}
            onChange={(e) =>
              setreconfirm({ ...reconfirm, trip_start_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="refund">Refund Committed</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="refund"
              value={reconfirm.refund_committed}
              onChange={(e) =>
                setreconfirm({ ...reconfirm, refund_committed: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
            </Select>
          </FormControl>
        </FormGroup>
        <h2 className={classes.headtext}>
          Please remember if you have done any commitments not written in
          customer notes:{" "}
        </h2>
        <BlinkingText variant=" h5" className={classes.headtext}>
          {" "}
          1.Couple benefits: floating breakfast, bed decoration, cake etc.
        </BlinkingText>
        <BlinkingText variant=" h5" className={classes.headtext}>
          {" "}
          2. Meals: any lunch or dinner not mentioned
        </BlinkingText>
        <BlinkingText variant=" h5" className={classes.headtext}>
          {" "}
          3. Payment Schedules: any special treatment while making payments
        </BlinkingText>
        <BlinkingText variant=" h5" className={classes.headtext}>
          {" "}
          4. Additional Items: Consecutive seats in flights, early check in, any
          upgrades etc.
        </BlinkingText>
        <BlinkingText variant=" h5" className={classes.headtext}>
          {" "}
          5. Waive off: payment gateway charges
        </BlinkingText>
        <BlinkingText variant=" h5" className={classes.headtext}>
          {" "}
          6. Extra bed: Any requirement for extra bed
        </BlinkingText>
        <br></br>
        <h2 className={classes.headtext}>
          Mention everything in customer notes{" "}
        </h2>
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="outlined"
            label="Customer Notes"
            InputLabelProps={{ shrink: true }}
            value={quotedetails.cust_notes}
            className={classes.textArea}
            fullWidth
            multiline
            rows={2}
            onChange={(e) =>
              setquotedetails({ ...quotedetails, cust_notes: e.target.value })
            }
          />
        </FormGroup>
        <Typography variant="h6" align="center" className={classes.headertext}>
          {" "}
          This is only for ops team. Customer cannot see this.
        </Typography>
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="outlined"
            label="Internal Notes"
            InputLabelProps={{ shrink: true }}
            value={quotedetails.internal_notes}
            className={classes.textArea}
            fullWidth
            multiline
            rows={2}
            onChange={(e) =>
              setquotedetails({
                ...quotedetails,
                internal_notes: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="outlined"
            label="Payment Notes"
            InputLabelProps={{ shrink: true }}
            value={tripData.payment_note}
            className={classes.textArea}
            fullWidth
            multiline
            rows={2}
            onChange={(e) =>
              settripData({ ...tripData, payment_note: e.target.value })
            }
          />
        </FormGroup>
        <FormControlLabel
          className={classes.headtext}
          control={<Checkbox color="primary" />}
          checked={reconfirm.consent}
          label="I confirm that all mentioned details are correct and penalty can be charged against me as per policy if anything is found to be incorrect"
          onChange={(e) =>
            setreconfirm({ ...reconfirm, consent: e.target.checked })
          }
        />
        {reconfirm && "consent" in reconfirm && reconfirm.consent ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className={classes.button}
          >
            Save
          </Button>
        ) : (
          ""
        )}
      </Dialog>
    </div>
  );
};

export default Tripdataupdate;
